import applySiteIcon from './siteIcon';
import React, { Component, createRef } from 'react'; //different
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import Casino from "./casino";
import Slot from "./slot";
import BannerMid from "./bannemiddle";
import BannerFooter from "./bannefooter";
import BannerSlip from "./banneslip";
import Fishing from "./fising";
import Sport from "./sport";
import TextSlider from "./textslide";
import affiliate from "./affiliate";
import Signin from "./signin";
import PopupDep from "./popupdeposit"
import Register from "./register";
import Loss from "./loss";
import Luckyfortune from "./luckyfortune";
import Coupon from "./coupon"
import Checkindaily from "./checkin";
import Cardminigame from "./cardminigame";
import Promotion from "./promotionx";
// import { isMobile } from 'react-device-detect';
import Profile from "./profile";
import Statement from "./statement";
import Banner from "./banner";
import SubBanner from "./subbanner";
import MoblieMenu from "./mobilemenu";
import Mainindex from "./mainindex";
import Lowmenu from "./lowmenu";
import Popup from "./popup";
import LanguageSwitcher from "./LanguageSwitcher";
import { t } from "./i18n";
// import Lotto from "./lotto";
import Listgameall from "./linklistall";
// import GameHit from "./gamehit";
import moment from 'moment';
import md5 from 'md5';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Login, LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import NProgress from "nprogress";
import axios from 'axios';
import io from "socket.io-client";
import './bwufa-home.css';
var settings = {
    dots: false, // ซ่อนจุดนำทาง
    infinite: true, // วนลูป slides
    slidesToShow: 3, // แสดง 3 slide ในหน้าจอใหญ่
    slidesToScroll: 1, // เลื่อนทีละ 1 slide
    autoplay: true, // autoplay
    speed: 2000, // ความเร็วในการเลื่อน (ms)
    autoplaySpeed: 3000, // ช่วงเวลาระหว่าง autoplay
    cssEase: "linear", // ความเรียบเนียนของ transition
    centerMode: true, // แสดง slide ตรงกลาง
    centerPadding: "20px", // ระยะห่างซ้าย-ขวาของ slides
    responsive: [
        {
            breakpoint: 1024, // เมื่อหน้าจอเล็กกว่า 1024px
            settings: {
                slidesToShow: 2, // แสดง 2 slide
                centerPadding: "15px", // ระยะห่างลดลง
            },
        },
        {
            breakpoint: 760, // เมื่อหน้าจอเล็กกว่า 760px
            settings: {
                slidesToShow: 1, // แสดง 1 slide
                centerPadding: "10px", // ระยะห่างลดลงอีก
            },
        },
    ],
};

const settingsx = {
    dots: true, // แสดงจุดบอกสถานะของสไลด์
    infinite: true, // สไลด์วนลูป
    speed: 500, // ความเร็วในการเลื่อนสไลด์ (ms)
    slidesToShow: 1, // จำนวนสไลด์ที่แสดง
    slidesToScroll: 1, // จำนวนสไลด์ที่เลื่อนต่อครั้ง
    autoplay: true, // เลื่อนอัตโนมัติ
    autoplaySpeed: 3000, // เวลาในแต่ละสไลด์ (ms)
    arrows: true // แสดงปุ่มเลื่อนซ้าย-ขวา
};

let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;
class Main extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }
    constructor(props) {
        super(props)
        this.state = {
            ios: true,
            topbaruse_m: false,
            topbarOpen: true,
            topbar2Open: true,
            gooaldaddyShow: true,
            showToTop: false,
            isWithdrawLoading: false,
            withdrawLockedUntil: Number(localStorage.getItem("withdrawLockedUntil") || 0),
            nowTs: Date.now(),
            redirectCountdown: 0,
            finish: 0,
            tabselectselect: 1,
            webnamexback: "",
            dateselect: moment(new Date()).format("YYYY/MM/DD"),
            inputTimeHour: moment(new Date()).format("HH"),
            inputTimeMin: moment(new Date()).format("mm"),
            isUploading: false,
            uploadslip: 0,
            currency: 'THB',
            Rate: 1,
            openAccordion: null,
            webname: "",
            picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
            previewUrl: null,
            usercheck: "",
            categorylist: [],
            isPopupOpen: false,
            selectedItem: null, // Store the selected item
            luckywheeldisplay: false,
            listitallgame: [],
            slotlist: [],
            sportlist: [],
            logoimg: '',
            describemain: "",
            fishinglist: [],
            gamehitlist: [],
            files: [],
            providorlist: [],
            filterlist: [],
            stats: {},
            isConfirmed: false,
            reports: {},
            qrstep: 1,
            listacc: [],
            addhome: true,
            whellsetting: [],
            pglist: [],
            tabselectdeposit: 0,
            rewardlist: [],
            loader: false,
            slotlist: [],
            recentlist: [],
            activePage: 1,
            ThmeseV: null,
            pagecount: 1,
            trueaccount: true,
            products_page_count: 1,
            isActive: false,
            resetpass: 0,
            paymentlist: null,
            checkcredit: false,
            refer: 1,
            showmodal: false,
            historylist: [],
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            tblprofile: [],
            userid: null,
            affiliate: [],
            cashoutSet: [],
            modal: false,
            modalpromotion: false,
            linkaff: "",
            point: 0,
            maxwithdrawstatus: 0,
            useradvice: [],
            affiliatetoday: [],
            affiliateall: [],
            balance: 0,
            counter: 300,
            partner: null,
            qrcodecheck: false,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            prolistx: [],
            prodetail: [],
            username: "",
            tabselect: 0,
            showpass: false,
            amount: "",
            remark: "",

            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            limit: null,
            name: "",
            password: "",
            oldpassword: "",
            passwordcf: "",
            left: false,
            pathname: "",
            linelink: "",
            lineid: "",
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            pagecount: 1,
            picture: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            mainacc: [],
            paymentgateway: null,
            tabselectsec: 0,
            checkcashout: false,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            activeTab: 'deposit-history', // ค่าเริ่มต้น
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
            modalx: false,
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            hours: 0,
            minutes: 0,
            seconds: 0,
            reviewList: [],
            reviewLoading: false,
            reviewTotal: 0,
            reviewPage: 1,
        }
        this.timer = null; // เก็บตัวนับเวลา
        this.popupRef = createRef();
    }
    handleClickOutside = (event) => {
        const isOutside =
            !event.target.closest('[role="dialog"]'); // ตรวจสอบว่า target อยู่นอก role="presentation"
        if (isOutside) {
            this.closeModal();
        }
    };
    handleTabChange = (tabId) => {
        this.setState({ activeTab: tabId });
    };

    toggleAccordion = (id) => {
        this.setState((prev) => ({
            openAccordion: prev.openAccordion === id ? null : id
        }));
    };

    handleChange = (event) => {
        console.log(event.target.value);
        const { name, value } = event.target;
        this.setState({
            [name]: value,
        });
    };
    getwheel = async () => {
        const cacheKey = "wheelSpinCache";
        const cacheTTL = 10 * 60 * 1000; // 10 นาทีในมิลลิวินาที
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));

        // ตรวจสอบว่ามีแคชและยังไม่หมดอายุ
        if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
            console.log("Using cached data wheelSpinCache");
            this.setState({
                tblwheelsetting: cachedData.data.tblwheelsetting,
                segments: cachedData.data.segments,
                segColors: cachedData.data.segColors,
            });
            return;
        }

        try {
            const res = await instance.post("/api/v1/getwheelspin", {
                System: Systems,
            });

            console.log("getwheelspin", res.data);
            if (res.data.status === 200) {
                const datas = res.data.message;
                const segments = [];
                const segColors = [];

                for (let i = 0; i < datas.length; i++) {
                    const { id, description: name, color, image } = datas[i];
                    segments.push({ id, name, image });
                    segColors.push(color);
                }

                const newData = {
                    tblwheelsetting: res.data.tblwheelsetting,
                    segments,
                    segColors,
                };

                this.setState(newData);

                // เก็บข้อมูลลงในแคช
                localStorage.setItem(cacheKey, JSON.stringify({
                    timestamp: Date.now(),
                    data: newData,
                }));

                console.log("Segments:", segments);
            } else {
                // Handle other statuses if needed
                console.log("Error: Status not 200");
            }
        } catch (error) {
            console.log("Error:", error);
        }
    };
    onChangexdep = event => {
        ////console.log(event.target.value);
        if (event.target !== undefined) {

            this.setState({ depositamount: event.target.value });
        }
    };
    validatergisterForm = async (e, fname) => {
        e.preventDefault();
        const { phoneNumber, password, passwordcf, bankselect, accnumbertxt } = this.state;
        console.log("fname", fname);
        if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
            var title = 'error'
            var text = t(this.lang, 'no_account_number')
            var object = { title, text }
            this.modalerror(object);

        }
        else if (fname === "" || fname === null || fname === undefined) {

            var title = 'error'
            var text = t(this.lang, 'no_fullname')
            var object = { title, text }
            this.modalerror(object);

        }
        else if (password.length > 15) {
            var title = 'error'
            var text = t(this.lang, 'password_max_15')
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 6) {
            var title = 'error'
            var text = t(this.lang, 'password_min_4')
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 6) {
            var title = 'error'
            var text = t(this.lang, 'u5_password_min_6')
            var object = { title, text }
            this.modalerror(object);
        }
        else {
            await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: bankselect,
                accno: accnumbertxt,
                System: Systems,
                Useradvise: this.state.userrecomend
            }).then(async (res) => {
                console.log(res.data);
                if (res.data.status === 200) {
                    var title = 'success'
                    var text = t(this.lang, 'register_success')
                    var object = { title, text }
                    await this.modalerror(object);

                    this.setState({
                        username: phoneNumber,
                        password: password,
                        finish: 1,
                    });


                }
                else if (res.data.status === 203) {
                    var title = 'error'
                    var text = t(this.lang, 'account_already_registered')
                    var object = { title, text }
                    this.modalerror(object);
                }
                else if (res.data.status === 202) {
                    var title = 'error'
                    var text = t(this.lang, 'username_already_taken')
                    var object = { title, text }
                    this.modalerror(object);
                }
                else {
                    var title = 'error'
                    var text = t(this.lang, 'invalid_username_name')
                    var object = { title, text }
                    this.modalerror(object);
                }
            });
        }


    };
    handleClickmodal = () => {
        // console.log(this.state.modalx);
        // if (!this.state.modalx) {
        //     //document.addEventListener("click", this.handleOutsideClick, false);
        // } else {
        //     document.removeEventListener("click", this.handleOutsideClick, false);
        // }

        // this.setState(prevState => ({
        //     modalx: !prevState.modalx
        // }));
    };
    closeModal = () => {
        this.setState({ modalpopup: false });
    };
    handleIosClick = () => {
        this.setState({ ios: true });
    };
    handleAndroidClick = () => {
        this.setState({ ios: false });
    };
    handleScroll = (e) => {
        const scrollTop =
            e?.currentTarget?.scrollTop ||
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;

        console.log("SCROLL TOP:", scrollTop);

        this.setState({
            showToTop: scrollTop > 200
        });
    };
    scrollToTop = () => {
        console.log("Scrolling to top anchor...");

        const anchor = document.getElementById("pageTopAnchor");

        if (anchor) {
            anchor.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }

        setTimeout(() => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;

            const root = document.getElementById("pageScrollRoot");
            if (root) root.scrollTop = 0;
        }, 300);
    };
    forceScrollTop = () => {
        console.log("FORCE SCROLL TOP");

        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        const selectors = [
            "#pageScrollRoot",
            "#root",
            ".App",
            ".main",
            ".main-content",
            ".content",
            ".page-content",
            ".tt_l",
            ".tt_full",
            ".bg",
            ".home",
            "main"
        ];

        selectors.forEach((selector) => {
            const el = document.querySelector(selector);
            if (el) {
                el.scrollTop = 0;
                el.scrollLeft = 0;
            }
        });

        document.querySelectorAll("*").forEach((el) => {
            if (el.scrollTop > 0) {
                el.scrollTop = 0;
            }
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.tabselect !== this.state.tabselect) {
            this.forceScrollTop();

            setTimeout(() => {
                this.forceScrollTop();
            }, 50);

            setTimeout(() => {
                this.forceScrollTop();
            }, 300);
        }
    }
    componentWillUnmount() {
        window.removeEventListener("popstate", this.handlePopState);
        document.removeEventListener("mousedown", this.handleClickOutside);
        if (this.withdrawTimer) clearInterval(this.withdrawTimer);
        if (this.redirectTimer) clearInterval(this.redirectTimer);
        if (this.redirectTimeout) clearTimeout(this.redirectTimeout);
        window.removeEventListener("scroll", this.handleScroll);
        clearInterval(this.timer); // ล้างตัวนับเมื่อคอมโพเนนต์ถูกถอดออก
    }
    getNextMondayTarget() {
        const now = new Date();
        let target = new Date();

        // คำนวณวันจันทร์ถัดไป
        const daysUntilMonday = (8 - now.getDay()) % 7; // คำนวณจำนวนวันที่เหลือถึงวันจันทร์
        target.setDate(now.getDate() + daysUntilMonday);
        target.setHours(1, 0, 0, 0); // ตั้งเป้าหมายเป็น 01:00 AM ของวันจันทร์

        // ถ้าขณะนี้เลยเวลาเป้าหมายไปแล้ว ให้เลื่อนเป้าหมายไปวันจันทร์ถัดไป
        if (now >= target) {
            target.setDate(target.getDate() + 7);
        }

        return target;
    }

    startCountdown() {
        let targetTime = this.getNextMondayTarget();

        this.timer = setInterval(() => {
            const now = new Date();
            const diff = targetTime - now;

            // ถ้าถึงเวลาเป้าหมายแล้ว ให้ตั้งเป้าหมายใหม่
            if (diff <= 0) {
                targetTime = this.getNextMondayTarget();
            }

            // คำนวณวัน ชั่วโมง นาที และวินาทีที่เหลือ
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            // อัปเดตสถานะ (state)
            this.setState({
                days: days >= 0 ? days : 0,
                hours: hours >= 0 ? hours : 0,
                minutes: minutes >= 0 ? minutes : 0,
                seconds: seconds >= 0 ? seconds : 0
            });
        }, 1000);
    }
    redeemrank = async (e, index) => {
        e.preventDefault();
        //console.log(index);

        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: t(this.lang, 'rank_claim_confirm'),
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/userredeemrank", {
                        User_id: Username,
                        rankno: index.no,
                        System: Systems,
                        amount: index.claimamount
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            const datas = res.data.message;
                            this.calllisthistory(Username);
                            this.checklogin();
                            Swal.fire(t(this.lang, 'process_success'), '', 'success')
                        }
                        else {
                            Swal.fire(t(this.lang, 'action_failed_wait'), '', 'error')
                        }
                    });

                }
            })
        }

    }

    // ===== แปลงสกุลเงิน (เว็บลาว): input เป็นบาท, แสดง/โอนเป็นกีบ = บาท x Rate =====
    // gated: ถ้า currency = THB (หรือว่าง) => คืนค่าบาทเดิม ไม่แปลง (เว็บเดิมไม่กระทบ)
    isForeignCur = () => !!(this.state.currency && String(this.state.currency).toUpperCase() !== 'THB');
    curRate = () => Number(this.state.Rate) || 1;
    curUnitLabel = () => this.isForeignCur() ? 'กีบ' : t(this.lang, 'baht');
    toCurAmount = (baht) => this.isForeignCur() ? Math.ceil(Number(baht || 0) * this.curRate()) : Number(baht || 0);
    // ข้อความ "โอน X กีบ" (+ อ้างอิงบาท) สำหรับ popup ฝาก
    curTransferText = (baht) => {
        const b = Number(baht || 0);
        if (!this.isForeignCur()) return `${b.toLocaleString()} <span class="dn-amount-unit">${t(this.lang, 'baht')}</span>`;
        const kip = this.toCurAmount(b);
        return `${kip.toLocaleString()} <span class="dn-amount-unit">กีบ</span>`;
    };
    openDepositAmountPopup = async () => {
        await Swal.fire({
            customClass: {
                popup: 'swal-deposit-popup',
            },
            showConfirmButton: false,
            showCancelButton: false,
            showCloseButton: true,
            background: '#fff',
            html: `
            <div class="dn-popup-icon"></div>

            <div style="text-align:center;margin-bottom:20px;">
                <h2 style="margin:0;font-size:22px;font-weight:bold;color:#1a1a2e;">
                    ${t(this.lang, 'ufa_create_deposit_title')}
                </h2>
                <p style="margin:5px 0 0 0;font-size:14px;color:#666;">
                    ${t(this.lang, 'ufa_create_deposit_subtitle')}
                </p>
            </div>

            <div class="dn-popup-label">${t(this.lang, 'ufa_deposit_channel')}</div>

            <div class="dn-popup-badges" style="grid-template-columns: repeat(2, 1fr); margin-bottom:15px;">
                <button type="button" class="dn-popup-badge active" data-paymentstate="0">
                    <span class="dn-badge-amount">${t(this.lang, 'ufa_bank_account')}</span>
                </button>

                <button type="button" class="dn-popup-badge" data-paymentstate="1">
                    <span class="dn-badge-amount">Payment Gateway</span>
                </button>
            </div>

            <div class="dn-popup-label">${t(this.lang, 'amount_label')}</div>

            <input
                type="number"
                id="swalDepositAmount"
                class="dn-popup-input"
                placeholder="0.00"
                min="${this.state.limit.min}"
                max="${this.state.limit.max}"
                step="1"
            />
            ${this.isForeignCur() ? `<div id="dnKipPreview" style="text-align:center;margin:8px 0 2px;font-weight:800;color:#00701a;font-size:15px;"></div>` : ''}

            <div class="dn-popup-badges">
                ${(this.isForeignCur() ? [100, 200, 300, 500, 1000, 2000, 3000, 5000] : [100, 200, 300, 500, 1000, 2000, 3000, 5000, 10000, 50000, 100000]).map(amount => `
                    <button type="button" class="dn-popup-badge dn-amount-choice" data-amount="${amount}">
                        ${amount === 500 ? `<span class="dn-badge-popular">${t(this.lang, 'popular')}</span>` : ''}
                        <span class="dn-badge-amount">${amount.toLocaleString()}</span>
                    </button>
                `).join('')}
            </div>

            <button type="button" id="dnSubmitBtn" class="dn-popup-submit">
                <i class="fas fa-check-circle" style="margin-right:8px;"></i>
                ${t(this.lang, 'ufa_confirm_amount')}
            </button>
        `,
            didOpen: () => {
                const input = document.getElementById('swalDepositAmount');
                const submitBtn = document.getElementById('dnSubmitBtn');

                const amountBtns = document.querySelectorAll('.dn-amount-choice');
                const paymentBtns = document.querySelectorAll('[data-paymentstate]');

                let selectedPaymentState = 0;

                // preview แปลงบาท -> กีบ (เฉพาะเว็บ currency != THB)
                const kipPreview = document.getElementById('dnKipPreview');
                const updateKip = () => {
                    if (!kipPreview) return;
                    const v = Number(input.value) || 0;
                    kipPreview.innerHTML = v > 0 ? ('= ' + this.toCurAmount(v).toLocaleString() + ' กีบ') : '';
                };
                if (input) input.addEventListener('input', updateKip);

                paymentBtns.forEach((btn) => {
                    btn.addEventListener('click', () => {
                        selectedPaymentState = Number(btn.getAttribute('data-paymentstate'));

                        paymentBtns.forEach(b => b.classList.remove('active'));
                        btn.classList.add('active');
                    });
                });

                amountBtns.forEach((btn) => {
                    btn.addEventListener('click', () => {
                        const amount = btn.getAttribute('data-amount');
                        input.value = amount;

                        amountBtns.forEach(b => b.classList.remove('active'));
                        btn.classList.add('active');
                        updateKip();
                    });
                });

                submitBtn.addEventListener('click', async () => {
                    const amount = Number(input.value);
                    const minDep = this.state.limit?.min ?? 100;
                    const maxDep = this.state.limit?.max ?? 1000000;

                    if (!amount || amount < minDep || amount > maxDep) {
                        Swal.showValidationMessage(
                            `${t(this.lang, 'deposit_limit_prefix')} ${minDep.toLocaleString()} – ${maxDep.toLocaleString()} ${t(this.lang, 'baht')}`
                        );
                        return;
                    }

                    submitBtn.disabled = true;
                    submitBtn.innerHTML = `
                    <i class="fas fa-spinner fa-spin" style="margin-right:8px;"></i>
                    ${t(this.lang, 'processing_label')}
                `;

                    try {
                        await this.confirmdeposit(null, 0, selectedPaymentState, amount);
                    } catch (error) {
                        console.log("openDepositAmountPopup error:", error);

                        submitBtn.disabled = false;
                        submitBtn.innerHTML = `
                        <i class="fas fa-check-circle" style="margin-right:8px;"></i>
                        ${t(this.lang, 'ufa_confirm_amount')}
                    `;

                        Swal.showValidationMessage(t(this.lang, 'ufa_cannot_create_deposit'));
                    }
                });
            }
        });
    };
    handleFileSelectedt = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const previewUrl = URL.createObjectURL(files[0]);
            this.setState({
                files: files,
                previewUrl: previewUrl,
                isConfirmed: false, // รีเซ็ตให้ต้องกดยืนยันใหม่
            });
        }
    };




    confirmqrcode = async () => {
        await Swal.fire({
            title: 'success!',
            text: t(this.lang, 'ufa_confirm_topup'),
            icon: 'success',
            confirmButtonText: t(this.lang, 'ok')
        })
        this.setState({
            tabselect: 0,
            qrcode: null,
            tabselectdeposit: 0,
        });
    };
    cancleqrcode = () => {
        Swal.fire({
            title: t(this.lang, 'ufa_cancel_qr_title'),
            html: t(this.lang, 'ufa_cancel_qr_text'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#81d539",
            cancelButtonColor: "#ea133d",
            confirmButtonText: t(this.lang, 'confirm'),
            cancelButtonText: t(this.lang, 'cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.setState({
                    qrstep: 0,
                    qrcodecheck: false,
                    counter: 0,
                });
            }
        });
    };
    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {
            console.log(err);

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", t(this.lang,'session_expired'));
                window.location.href = this.state.webnamexback;
            }
        });
    }
    login = (e) => {
        e.preventDefault();
        let errors = this.validateLoginForm();
    }
    handleClickdeposit = async (e, price) => {
        this.setState({
            depositamount: price

        });
    }
    validateLoginForm = async (e) => {
        const { username, password } = this.state;
        console.log(username, password);
        await instance.post("/api/v1/userlogin", {
            userid: username,
            password: password,
            System: Systems,
            Function: 'validateLoginForm-navbar.js'
        })
            .then((res) => {
                console.log(res);
                if (res.status === 200) {
                    //////console.log(res.data.status);
                    if (res.data.status === 200) {
                        localStorage.setItem('auth_token', res.data.token)
                        localStorage.removeItem('cookie', '')
                        this.setState({
                            userid: res.data.message.member_id,
                            username: res.data.message.playerid,
                            firstname: res.data.message.firstname,
                            lastname: res.data.message.lastname,
                            point: res.data.message.Point,
                            balance: res.databalance,
                            loginstate: true,
                        });
                        window.location.href = '/';
                    }
                    else if (res.data.status === 401) {
                        Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'invalid_credentials'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                    }
                    else {
                        Swal.fire({
                            title: 'error!',
                            text: t(this.lang, 'invalid_credentials'),
                            icon: 'error',
                            confirmButtonText: t(this.lang, 'ok')
                        })
                        //   Bonn.alert("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง")
                    }
                }
                else {
                    this.setState({
                        firstname: null,
                        lastname: null,
                        point: null,
                        loginstate: false,
                    });
                    var title = 'Error!'
                    var text = t(this.lang, 'username_already_taken')
                    var object = { title, text }
                    this.CheckThisGoalError(object);
                }
            });
    }
    async checklogin() {
        var token = localStorage.getItem('auth_token');
        console.log(11111111, token);
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.rechecklogin(Username, token);
        }
        else {
            this.setState({
                loginstate: false,
            });
            await this.notify("warning", t(this.lang,'session_expired'));
            console.log(this.state.webnamexback);
            window.location.href = '/login';
        }
    }
    radiocheck(input) {
        console.log(input);
        this.setState({
            bankselect: input
        });
        if (input == 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }

    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        this.setState({
            checkcredit: true,
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            // console.log(2);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-App.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)

                    this.setState({
                        usercheck: res.data.message.usercheck,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fullname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                        checkcredit: false,
                    });
                }
                else if (res.data.status === 401) {
                    //   console.log(res.data);
                    localStorage.clear();
                    await this.notify("warning", t(this.lang,'session_expired'));
                    window.location.href = this.state.webnamexback;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("warning", t(this.lang,'session_expired'));
                    window.location.href = this.state.webnamexback;
                }
            });
        }
        catch (ex) {
            ////////console.log(ex);
        }
    }
    // async opencliamcashout(evt, cityName) {
    //     var token = localStorage.getItem('auth_token');
    //     var decoded = jwt_decode(token);
    //     var Username = decoded.message.playerid;
    //     await instance.post("/api/v1/cliamcashout", {
    //         userid: Username,
    //         System: Systems,
    //     }, {
    //         headers: { Authorization: `Bearer ${token}` }
    //     }).then(async (res) => {
    //         if (res.data.status === 200) {
    //             var decoded = jwt_decode(token);
    //             var Username = decoded.message.playerid;
    //             this.rechecklogin(Username, token);
    //             await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
    //         }
    //         else if (res.data.status === 201) {
    //             await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
    //             return false;
    //         }
    //         else if (res.data.status === 202) {
    //             await this.notify("error", 'ไม่สามารถทำรายการได้');
    //             return false;
    //         }

    //     }).catch(async (err) => {
    //         // console.log(err);
    //         if (err.response.status === 401 || err.response.status === 403) {
    //             localStorage.clear();
    //             await this.notify("error", t(this.lang,'session_expired'));
    //             window.location.href = '/';
    //         }
    //     });
    // }
    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }
    onChangex = event => {
        // console.log("event", event.target.name);


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    handleOutsideClick = e => {
        if (!this.node.contains(e.target)) this.handleClickmodal();
    };
    claerclass = async (e, url) => {
        var i, tabcontent, tablinks;
        tabcontent = document.querySelectorAll('[id*="game"]');
        Array.prototype.forEach.call(tabcontent, callback);
        function callback(element, iterator) {
            if (!isMobile) {
                element.className = "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-luxecs";
            }
            else if (isMobile) {
                element.className = "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-5oh6yz";
            }
        }
    }
    async saveclickaff(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                this.setState({
                    userrecomend: res.data.username,
                    link: linkid
                });
                var username = res.data.username
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async saveclick(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                var username = res.data.username
                this.setState({
                    userrecomend: username,
                });
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    handleSelectItem = (item) => {
        if (item.id == 99) {
            this.setState({
                trueaccount: false,
                selectedItem: item,
                isPopupOpen: false,
                bankselect: item.id,
            });
        }
        else {
            this.setState({
                trueaccount: true,
                selectedItem: item,
                isPopupOpen: false,
                bankselect: item.id,
                fname: ""
            });
        }
        //  this.setState({}); // Store selected item and close menu
    };
    handleSubmit = async (event) => {
        event.preventDefault();
        const { oldPassword, newPassword, confirmPassword } = this.state;
        // console.log(type, newPassword, oldPassword, confirmPassword);
        var token = localStorage.getItem('auth_token');
        if (newPassword === confirmPassword) {
            var Username = null;
            var decoded = null;
            if (newPassword != oldPassword) {
                if (token != null) {
                    decoded = jwt_decode(token);
                    Username = decoded.message.playerid;
                    await instance.post("/api/v1/resetpassword", {
                        username: Username,
                        oldpass: oldPassword,
                        System: Systems,
                        newpass: newPassword,
                        type: 1
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            this.setState({
                                tabprofile: 1,
                            });
                            await this.notify("success", t(this.lang, 'change_password_success'));
                        }
                        else if (res.data.status === 201) {
                            await this.notify("error", t(this.lang, 'wrong_old_password'));
                        }
                        else if (res.data.status === 203) {
                            await this.notify("error", t(this.lang, 'password_error'));
                        }
                        else if (res.data.status === 202) {
                            await this.notify("error", t(this.lang, 'same_password'));
                        }
                    });
                }
                else {
                    await this.notify("error", t(this.lang, 'transaction_failed'));
                }
            }
            else {
                await this.notify("error", t(this.lang, 'same_password'));
            }
        }
        else {
            await this.notify("error", t(this.lang, 'password_mismatch'));
        }

    }
    closewheel(e) {
        e.preventDefault(); // ป้องกันพฤติกรรมเริ่มต้น
        this.setState({ luckywheeldisplay: false }); // ซ่อน Lucky Wheel
    }
    handleConfirmUpload = () => {
        if (this.state.files.length === 0) {
            this.notify("error", t(this.lang, 'select_file_first'));
            return;
        }
        this.setState({ isConfirmed: true }, () => {
            this.uploadSlip();
        });
    };


    uploadSlip = async (type = 5) => {
        const { files, dateselect, inputTimeHour, inputTimeMin, mainacc } = this.state;
        const token = localStorage.getItem("auth_token");

        if (this.state.isUploading) return;

        if (!token) {
            return this.notify("error", t(this.lang, 'not_logged_in'));
        }

        const file = files?.[0];
        if (!file) {
            return this.notify("error", t(this.lang, 'select_file_first'));
        }

        this.setState({ isUploading: true });

        try {
            const decoded = jwt_decode(token);
            const Username = decoded?.message?.playerid;

            if (!Username) throw new Error("Token ไม่ถูกต้อง");

            const ext = (file.name.match(/\.([a-z0-9]+)$/i)?.[1] || "jpg").toLowerCase();
            const filename = `slip_${Username}_${Date.now()}.${ext}`;

            const formData = new FormData();
            formData.append("System", "javisauto");
            formData.append("filename", filename);
            formData.append("file", new File([file], filename, { type: file.type || "application/octet-stream" }));

            const headers = { Authorization: "Bearer langter" };

            const resUpload = await axios.post(
                "https://r2-public.wordbalance931.workers.dev/upload/slip",
                formData,
                { headers }
            );

            const slip = resUpload?.data?.link || null;

            if (!slip) {
                this.setState({ isUploading: false });
                return this.notify("error", t(this.lang, 'upload_slip_failed'));
            }

            const object = {
                playerid: Username,
                amount: 1,
                date: dateselect,
                minute: inputTimeMin,
                hour: inputTimeHour,
                bank: mainacc,
                slipimg: slip,
                System: Systems,
                type: type,
            };

            const res = await instance.post("/api/v1/updateslip", object);

            if (res?.data?.status === 200) {
                await Swal.fire({
                    icon: "success",
                    title: t(this.lang, 'upload_success_title'),
                    text: t(this.lang, 'processing'),
                    confirmButtonText: t(this.lang, 'ok'),
                    confirmButtonColor: "#00c853",
                });
                this.setState({
                    files: [],
                    previewUrl: null,
                    isConfirmed: true,
                    isUploading: false,
                    tabselect: 1,
                });
                window.history.pushState(null, "", "/deposit");
            } else {
                await Swal.fire({
                    icon: "error",
                    title: t(this.lang, 'upload_slip_failed'),
                    text: res?.data?.message || t(this.lang, 'transaction_failed'),
                    confirmButtonText: t(this.lang, 'ok'),
                });
                this.setState({ isUploading: false, isConfirmed: false });
            }

        } catch (error) {
            await Swal.fire({
                icon: "error",
                title: t(this.lang, 'upload_slip_failed'),
                text: error?.response?.data?.message || error?.message,
                confirmButtonText: t(this.lang, 'ok'),
            });
            this.setState({ isUploading: false });
        }
    };
    checkurl = async (e, url) => {
        NProgress.start();
        const pathname = url.split("/")
        console.log(210, url.split("/"));

        this.setState({
            topbaruse_m: false,
        });

        document.body.className = "home blog";
        if (pathname.length > 1) {
            if (!this.state.loginstate && pathname[1] == "listgameall") {
                this.setState({
                    tabselect: 23,
                });
                return;
            }
            else {
                window.history.pushState(null, null, url);
                this.setState({
                    modalx: false,
                    modal: false,
                });
                if (pathname[1] == "") {
                    console.log(250, pathname[1]);
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "home") {
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "casino") {
                    this.setState({
                        tabselect: 10,
                    });
                }
                else if (pathname[1] == "gamehit") {
                    this.setState({
                        tabselect: 11,
                    });
                }
                else if (pathname[1] == "uploadslip") {
                    this.setState({
                        tabselect: 56,
                    });
                }
                else if (pathname[1] == "opencard") {
                    this.setState({
                        tabselect: 51,
                    });
                }
                else if (pathname[1] == "coupon") {
                    this.setState({
                        tabselect: 50,
                    });
                }
                else if (pathname[1] == "weeklychallenge") {
                    this.setState({
                        tabselect: 52
                    });
                }

                else if (pathname[1] == "checkinrule") {
                    this.setState({
                        tabselect: 53
                    });
                }

                else if (pathname[1] == "ulive") {
                    window.open("/ulive", "_blank");
                }

                else if (pathname[1] == "fishing") {
                    this.setState({
                        tabselect: 12,
                    });
                }
                else if (pathname[1] == "luckyfortune") {
                    this.setState({
                        tabselect: 35,
                    });
                }
                else if (pathname[1] == "checkindaily") {
                    this.setState({
                        tabselect: 36,
                    });
                }
                else if (pathname[1] == "cardminigame") {
                    this.setState({
                        tabselect: 37,
                    });
                }
                else if (pathname[1] == "slot") {
                    console.log(101, pathname);
                    this.setState({
                        tabselect: 13,
                    });
                }
                else if (pathname[1] == "sport") {
                    this.setState({
                        tabselect: 14,
                    });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }

                else if (pathname[1] == "event") {
                    this.setState({
                        tabselect: 16,
                    });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    this.setState({
                        tabselect: 1,
                        tabselectdeposit: 1,
                    });
                }
                else if (pathname[1] == "history") {
                    this.setState({
                        tabselect: 3,
                    });
                }
                else if (pathname[1] == "profile") {
                    this.setState({
                        tabselect: 8,
                    });
                }
                else if (pathname[1] == "register") {
                    // ใช้ฟอร์มสมัครของธีม (iframe) แทนฟอร์มเดิม — รองรับลิงก์ชวนเพื่อน /register?reg=CODE
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "signin" || pathname[1] == "login") {
                    // ใช้หน้า login ของธีม (iframe bwufa) เหมือน /register ไม่ใช้หน้า Signin เก่า (desktop)
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "affiliate") {
                    let _uid = this.state.username;
                    if (!_uid) { try { _uid = jwt_decode(localStorage.getItem('auth_token')).message.playerid; } catch (e) { _uid = ""; } }
                    await this.checkuseradvice(_uid)
                    this.setState({
                        tabselect: 4,
                    });
                }
                else if (pathname[1] == "network") {
                    await this.checkuseradvice()
                    this.setState({
                        tabselect: 44,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "listgameall") {
                    if (typeof this.getgame === "function") {
                        let check = await this.getgame(pathname[2], pathname[3], true);
                        console.log(614, check)
                        if (check) {
                            this.setState({
                                tabselect: 15,
                            });
                        }
                    }
                }
                else if (pathname[1] == "review") {
                    this.setState({ tabselect: 54 });
                    this.fetchReviewList(1);
                }
                else if (pathname[1] == "rank") {
                    this.setState({ tabselect: 55 });
                }
            }
        }
        else {
            this.setState({
                tabselect: 0,
            });
        }

        NProgress.done();

    }
    async calllisthistory(userid) {
        await instance.post("/api/v1/userwithdrawlist", {
            userid: userid,
            Cat_ID: 0,
            System: Systems,
            page: 1,
            type: 1
        }).then((res) => {
            console.log(864, res.data);
            if (res.data.status === 200) {
                const datas = res.data.message;
                //  //console.log(datas.withdrawlist);
                this.setState({
                    historylist: datas.withdrawlist
                });

            }
            else {
                this.setState({
                    historylist: []
                });
                // this.CheckThisGoalError();
            }
        });

    }
    forgetotpandregister = async (type) => {
        const { phoneNumber, otpphoneforget, bankselect, otpphone, accnumbertxt } = this.state;
        var recheck = false;
        if (type === 4) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 5) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphoneforget,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 6) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 7) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphone,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: accnumbertxt,
                bankid: bankselect,
                System: Systems,
                type: type
            }).then(async (res) => {
                return recheck = res.data.message;

            });
        }
        return recheck
    }
    async modalerror(object) {
        await this.notify(object.title, object.text);
    }
    nextstep = async (e, num) => {
        e.preventDefault();
        const { stateregis, password, bankselect, passwordcf, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state
        console.log(num);
        if (num === 1) {
            const check = await this.forgetotpandregister(6);
            if (phoneNumber.length === 10 && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else {
                if (phoneNumber.length !== 10) {
                    await this.notify("warning", t(this.lang, 'phone_invalid'));
                }
                else if (!check.checked && check.status === 201) {
                    await this.notify("warning", t(this.lang, 'phone_in_use'));
                }
                else {
                    await this.notify("warning", t(this.lang, 'rate_limited'));
                }
            }
        }
        else if (num === 2) {

            if (password === "" || password === null) {
                await this.notify("warning", t(this.lang, 'ufa_no_password'));
            }
            else if (password.length < 6) {
                await this.notify("warning", t(this.lang, 'ufa_password_more_6'));
            }
            else {
                this.setState({
                    stateregis: 3
                });
            }

        }
        else if (num === 3) {
            if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
                this.setState({
                    stateregis: 3
                });
            }
            else {
                await this.notify("warning", t(this.lang, 'ufa_fill_bank_info_6'));
                //////console.log(2, stateregis, checkboxacc);
            }
        }
        else if (num === 5) {
            var check = await this.forgetotpandregister(7);
            if (otpphone !== "" && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else if (otpphone === "" || otpphone.length < 4) {
                await this.notify("warning", t(this.lang, 'incomplete_digits'));
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }

            else {
                this.setState({
                    stateopterror: t(this.lang, 'otp_invalid')
                });
                await this.notify("warning", t(this.lang, 'otp_invalid'));
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }



        }
        else if (num === 11) {

            console.log(1, stateregis, num);

            this.setState({
                stateregis: 1
            });
        }
        else if (num === 22) {
            //////console.log(1, stateregis, num);
            this.setState({
                stateregis: 2
            });
        }
        else if (num === 25) {
            console.log("accnumbertxt", accnumbertxt);

            if (accnumbertxt === null || accnumbertxt === "" || typeof accnumbertxt == "undefined") {
                var title = 'error'
                var text = t(this.lang, 'no_account_number')
                var object = { title, text }
                this.modalerror(object);

            }
            else if (accnumbertxt.length < 10) {
                var title = 'error'
                var text = t(this.lang, 'no_bank_selected')
                var object = { title, text }
                this.modalerror(object);
            }
            else if (bankselect === 0) {
                var title = 'error'
                var text = t(this.lang, 'no_bank_selected')
                var object = { title, text }
                this.modalerror(object);
            }
            else {
                this.setState({
                    loading: true,
                });
                if (fname === '') {
                    let check = await this.forgetotpandregister(10)
                    if (check.checked) {
                        console.log(302, check.verifications);
                        console.log(302, check.verifications.name);
                        if (check.verifications.status == 0) {
                            this.setState({
                                trueaccount: false,
                            });
                        }
                        else if (check.verifications.status == 1) {
                            this.setState({
                                fname: check.verifications.name,
                            });
                            await this.validatergisterForm(e, check.verifications.name);
                        }
                    }
                    else {
                        var title = 'error'
                        var text = t(this.lang, 'invalid_account_number')
                        var object = { title, text }
                        this.modalerror(object);
                    }
                }
                else {
                    await this.validatergisterForm(e, fname)
                }
                this.setState({
                    loading: false,
                });
                //console.log(302, check.verifications);
            }



        }
    };
    getDepositCacheKey = (Username, System, paymentstate = 0) => {
        return `deposit_cache_${System}_${Username}_${paymentstate}`;
    };

    getActiveDepositCache = (Username, System, paymentstate = 0) => {
        const key = this.getDepositCacheKey(Username, System, paymentstate);
        const raw = localStorage.getItem(key);

        if (!raw) return null;

        try {
            const data = JSON.parse(raw);

            if (!data.expireAt || Date.now() >= data.expireAt) {
                localStorage.removeItem(key);
                return null;
            }

            return data;
        } catch (e) {
            localStorage.removeItem(key);
            return null;
        }
    };

    setActiveDepositCache = (Username, System, payload, paymentstate = 0) => {
        const key = this.getDepositCacheKey(Username, System, paymentstate);

        localStorage.setItem(key, JSON.stringify({
            ...payload,
            paymentstate: paymentstate,
            createdAt: Date.now(),
            expireAt: Date.now() + (5 * 60 * 1000),
        }));
    };

    clearDepositCache = (Username, System, paymentstate = 0) => {
        const key = this.getDepositCacheKey(Username, System, paymentstate);
        localStorage.removeItem(key);
    };

    confirmdeposit = async (e, num, paymentstate = 0, amountFromPopup = null) => {
        if (e) e.preventDefault();

        const DEPOSIT_CACHE_MINUTES = 5;

        const swalAlert = async (icon, title, text) => {
            await Swal.fire({
                icon,
                title,
                text,
                confirmButtonText: t(this.lang, 'ok'),
                customClass: { popup: "swal-deposit-popup" }
            });
        };

        const openPaymentLink = (link) => {
            const ua = navigator.userAgent;
            const isIOS =
                /iPad|iPhone|iPod/.test(ua) ||
                (ua.includes("Mac") && "ontouchend" in document);

            if (isIOS) {
                window.location.href = link;
            } else {
                if (!isMobile) {
                    window.open(link, "_blank", "noopener,noreferrer,width=1000,height=1000");
                } else {
                    window.open(link, "_blank");
                }
            }
        };

        const showBankPopup = async ({
            amount,
            bankAcc,
            qrcode = null,
            gateway = null,
            data = {},
            expireAt,
            Username,
            cachePaymentState = 0,
        }) => {
            const bankName = bankAcc.fullname_th || gateway?.bank_name || t(this.lang, 'u5_bank');
            const accountName =
                `${bankAcc.first_name_en || ""} ${bankAcc.last_name_en || ""}`.trim()
                || gateway?.account_name
                || "-";
            const accountNumber = bankAcc.accnumber || gateway?.account_no || "-";
            const bankLogo = bankAcc.img_path || bankAcc.full_img || gateway?.img_path || "";
            const finalExpireAt = expireAt || Date.now() + (DEPOSIT_CACHE_MINUTES * 60 * 1000);

            this.setState({
                depositamount: amount,
                mainacc: bankAcc,
                qrcode,
                paymentlist: gateway,
                listacc: data.tblmain || [],
                counter: Math.max(0, Math.floor((finalExpireAt - Date.now()) / 1000)),
                qrcodecheck: !!qrcode,
                depositstate: 1,
            });

            let timerInterval = null;

            await Swal.fire({
                customClass: { popup: "swal-deposit-popup" },
                showCloseButton: false,
                showConfirmButton: true,
                confirmButtonText: t(this.lang, 'close'),
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                html: `
                <div class="dn-result-container">
                    <div class="dn-countdown-section">
                        <div class="dn-countdown-header">⏰ ${t(this.lang, 'ufa_complete_within_time')}</div>
                        <div class="dn-flip-countdown">
                            <div id="dnCountdownText" style="font-size:34px;font-weight:bold;color:#1a1a2e;letter-spacing:2px;">
                                05:00
                            </div>
                        </div>
                    </div>

                    ${qrcode ? `
                        <div style="text-align:center;margin:15px 0;">
                            <img loading="lazy" src="${qrcode}" style="max-width:220px;width:100%;border-radius:12px;" />
                        </div>
                    ` : ""}

                    <div class="dn-bank-card">
                        <div class="dn-bank-layout-new">
                            <div class="dn-bank-left">
                                <div class="dn-bank-logo-box-colored">
                                    ${bankLogo ? `<img loading="lazy" src="${bankLogo}" class="dn-bank-logo-img-colored" />` : ""}
                                </div>
                            </div>

                            <div class="dn-bank-right">
                                <div class="dn-bank-detail-row">
                                    <div class="dn-bank-label">${t(this.lang, 'bank_name')}</div>
                                    <div class="dn-bank-value">${bankName} ${accountName}</div>
                                </div>

                                <div class="dn-bank-detail-row">
                                    <div class="dn-info-label">${t(this.lang, 'account_number')} ${bankName}</div>
                                    <div class="dn-info-value-with-copy">
                                        <span class="dn-account-number" id="dnAccountNumber">${accountNumber}</span>
                                        <button type="button" class="dn-copy-btn" id="dnCopyBtn">
                                            <i class="fas fa-copy"></i>
                                        </button>
                                    </div>
                                </div>

                                <div id="dnCopyNoticeWrap"></div>
                            </div>
                        </div>
                    </div>

                    <div class="dn-amount-section">
                        <div class="dn-amount-label">${t(this.lang, 'ufa_amount_to_transfer')}</div>
                        <div class="dn-amount-value">
                            ${this.curTransferText(amount)}
                        </div>
                        ${this.isForeignCur() ? `<div class="dn-amount-ref" style="text-align:center;font-size:12px;color:#888;margin-top:2px;">(${Number(amount).toLocaleString()} ${t(this.lang, 'baht')} × ${this.curRate().toLocaleString()})</div>` : ''}
                    </div>

                    ${Number(bankAcc?.autoslip) === 1 ? `
                    <button type="button" id="dnUploadSlipBtn" class="dn-popup-submit" style="margin-top:14px;background:linear-gradient(135deg,#00c853,#00701a);">
                        <i class="fas fa-file-upload" style="margin-right:8px;"></i>
                        ${t(this.lang, 'upload_slip_title')}
                    </button>
                    ` : ""}
                </div>
            `,
                didOpen: () => {
                    const countdownEl = document.getElementById("dnCountdownText");
                    const copyBtn = document.getElementById("dnCopyBtn");
                    const accEl = document.getElementById("dnAccountNumber");
                    const noticeWrap = document.getElementById("dnCopyNoticeWrap");
                    const uploadSlipBtn = document.getElementById("dnUploadSlipBtn");

                    if (uploadSlipBtn) {
                        uploadSlipBtn.addEventListener("click", () => {
                            if (timerInterval) clearInterval(timerInterval);
                            Swal.close();
                            window.history.pushState(null, "", "/uploadslip");
                            this.setState({ tabselect: 56 });
                        });
                    }

                    const updateCountdown = () => {
                        const remain = Math.max(0, finalExpireAt - Date.now());
                        const totalSec = Math.floor(remain / 1000);
                        const min = String(Math.floor(totalSec / 60)).padStart(2, "0");
                        const sec = String(totalSec % 60).padStart(2, "0");

                        if (countdownEl) countdownEl.innerText = `${min}:${sec}`;
                        this.setState({ counter: totalSec });

                        if (remain <= 0) {
                            if (timerInterval) clearInterval(timerInterval);

                            this.clearDepositCache(Username, Systems, cachePaymentState);
                            Swal.close();

                            Swal.fire({
                                icon: "warning",
                                title: t(this.lang, 'time_expired'),
                                text: t(this.lang, 'ufa_deposit_timeout'),
                                confirmButtonText: t(this.lang, 'ok'),
                                customClass: { popup: "swal-deposit-popup" }
                            });
                        }
                    };

                    updateCountdown();
                    timerInterval = setInterval(updateCountdown, 1000);

                    if (copyBtn && accEl) {
                        copyBtn.addEventListener("click", async () => {
                            try {
                                await navigator.clipboard.writeText(accEl.innerText);

                                copyBtn.innerHTML = `<i class="fas fa-check"></i>`;
                                copyBtn.style.background = "#22c55e";
                                copyBtn.style.color = "#fff";

                                if (noticeWrap) {
                                    noticeWrap.innerHTML = `
                                    <div id="dnCopyNotice" style="margin-top:8px;font-size:13px;color:#16a34a;font-weight:600;">
                                        ${t(this.lang, 'ufa_account_copied_notice')}
                                    </div>
                                `;
                                }

                                setTimeout(() => {
                                    copyBtn.innerHTML = `<i class="fas fa-copy"></i>`;
                                    copyBtn.style.background = "";
                                    copyBtn.style.color = "";

                                    if (noticeWrap) noticeWrap.innerHTML = "";
                                }, 1500);
                            } catch (err) {
                                console.log("copy error:", err);
                            }
                        });
                    }
                },
                willClose: () => {
                    if (timerInterval) clearInterval(timerInterval);
                }
            });
        };

        const token = localStorage.getItem("auth_token");

        if (!token) {
            await swalAlert("warning", t(this.lang,'ufa_alert'), t(this.lang,'ufa_login_before_action'));
            return;
        }

        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;

        if (num === 0) {
            const amount = Number(amountFromPopup || this.state.depositamount);

            if (!(amount >= this.state.limit.min && amount <= this.state.limit.max)) {
                await swalAlert(
                    "warning",
                    t(this.lang, 'ufa_invalid_deposit_amount'),
                    t(this.lang, 'deposit_limit_prefix') + " " + this.state.limit.min + " " + t(this.lang, 'deposit_max_label') + " " + this.state.limit.max + " " + t(this.lang, 'baht')
                );
                return;
            }

            try {
                const cachedDeposit = this.getActiveDepositCache(Username, Systems, paymentstate);

                if (cachedDeposit) {
                    const cachedAmount = Number(cachedDeposit.amount);
                    const cachedData = cachedDeposit.data || {};
                    const cachedGateway = cachedData.tblpaymentgatewayx || null;
                    const cachedBankAcc =
                        cachedData.mainacc ||
                        (cachedData.tblmain && cachedData.tblmain.length > 0 ? cachedData.tblmain[0] : null) ||
                        null;

                    if (cachedAmount === amount) {
                        if (paymentstate === 1) {
                            if (cachedDeposit.isPaymentLink && cachedDeposit.paymentLink) {
                                openPaymentLink(cachedDeposit.paymentLink);
                                return;
                            }

                            if (cachedDeposit.qrcode) {
                                const gatewayAcc = {
                                    fullname_th: cachedGateway?.bank_name || "Payment Gateway",
                                    first_name_en: cachedGateway?.account_name || cachedGateway?.name || "",
                                    last_name_en: "",
                                    accnumber: cachedGateway?.account_no || "Payment Gateway",
                                    img_path: cachedGateway?.img_path || cachedDeposit.qrcode,
                                    full_img: cachedGateway?.img_path || cachedDeposit.qrcode,
                                    status: 1,
                                    del: 1,
                                };

                                await showBankPopup({
                                    amount: cachedAmount,
                                    bankAcc: gatewayAcc,
                                    qrcode: cachedDeposit.qrcode,
                                    gateway: cachedGateway,
                                    data: cachedData,
                                    expireAt: cachedDeposit.expireAt,
                                    Username,
                                    cachePaymentState: 1,
                                });
                                return;
                            }

                            this.clearDepositCache(Username, Systems, 1);
                        }

                        if (paymentstate === 0) {
                            if (cachedBankAcc) {
                                await showBankPopup({
                                    amount: cachedAmount,
                                    bankAcc: cachedBankAcc,
                                    qrcode: cachedDeposit.qrcode || null,
                                    gateway: cachedGateway,
                                    data: cachedData,
                                    expireAt: cachedDeposit.expireAt,
                                    Username,
                                    cachePaymentState: 0,
                                });
                                return;
                            }

                            this.clearDepositCache(Username, Systems, 0);
                        }
                    } else {
                        const askNew = await Swal.fire({
                            icon: "question",
                            title: t(this.lang, 'ufa_pending_deposit_title'),
                            html: `
                            <div style="font-size:14px;line-height:1.7;">
                                ${t(this.lang, 'ufa_old_order')}: <b>${cachedAmount.toLocaleString()} ${t(this.lang, 'baht')}</b><br>
                                ${t(this.lang, 'ufa_new_amount')}: <b>${amount.toLocaleString()} ${t(this.lang, 'baht')}</b><br><br>
                                ${t(this.lang, 'ufa_cancel_old_create_new')}
                            </div>
                        `,
                            showCancelButton: true,
                            confirmButtonText: t(this.lang, 'ufa_create_new_order'),
                            cancelButtonText: t(this.lang, 'ufa_use_old_order'),
                            reverseButtons: true,
                            customClass: { popup: "swal-deposit-popup" }
                        });

                        if (!askNew.isConfirmed) {
                            if (paymentstate === 1) {
                                if (cachedDeposit.isPaymentLink && cachedDeposit.paymentLink) {
                                    openPaymentLink(cachedDeposit.paymentLink);
                                    return;
                                }

                                if (cachedDeposit.qrcode) {
                                    const gatewayAcc = {
                                        fullname_th: cachedGateway?.bank_name || "Payment Gateway",
                                        first_name_en: cachedGateway?.account_name || cachedGateway?.name || "",
                                        last_name_en: "",
                                        accnumber: cachedGateway?.account_no || "Payment Gateway",
                                        img_path: cachedGateway?.img_path || cachedDeposit.qrcode,
                                        full_img: cachedGateway?.img_path || cachedDeposit.qrcode,
                                        status: 1,
                                        del: 1,
                                    };

                                    await showBankPopup({
                                        amount: cachedAmount,
                                        bankAcc: gatewayAcc,
                                        qrcode: cachedDeposit.qrcode,
                                        gateway: cachedGateway,
                                        data: cachedData,
                                        expireAt: cachedDeposit.expireAt,
                                        Username,
                                        cachePaymentState: 1,
                                    });
                                    return;
                                }
                            }

                            if (paymentstate === 0 && cachedBankAcc) {
                                await showBankPopup({
                                    amount: cachedAmount,
                                    bankAcc: cachedBankAcc,
                                    qrcode: cachedDeposit.qrcode || null,
                                    gateway: cachedGateway,
                                    data: cachedData,
                                    expireAt: cachedDeposit.expireAt,
                                    Username,
                                    cachePaymentState: 0,
                                });
                                return;
                            }

                            this.clearDepositCache(Username, Systems, paymentstate);
                        } else {
                            this.clearDepositCache(Username, Systems, paymentstate);
                        }
                    }
                }

                const res = await instance.post("/api/v1/getqrcode", {
                    username: Username,
                    System: Systems,
                    paymentstate: paymentstate,
                    amount: amount,
                    status: 1
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                const data = res.data || {};
                const gateway = data.tblpaymentgatewayx || null;

                const bankAcc =
                    data.mainacc ||
                    (data.tblmain && data.tblmain.length > 0 ? data.tblmain[0] : null) ||
                    null;

                const hasBankAcc =
                    bankAcc &&
                    bankAcc.accnumber &&
                    bankAcc.status === 1 &&
                    bankAcc.del === 1;

                const paymentClosed =
                    !gateway ||
                    gateway?.bank_name === "ไม่พร้อมฝาก" ||
                    gateway?.account_name === "ปิดฝาก" ||
                    gateway?.DepositStatus === 0 ||
                    gateway?.status === 0;

                const paymentLink = gateway?.link || null;
                const paymentQr = gateway?.QRcode || data.picture || null;

                if (paymentstate === 1) {
                    if (paymentClosed) {
                        this.clearDepositCache(Username, Systems, 1);

                        await swalAlert(
                            "warning",
                            t(this.lang, 'ufa_deposit_closed_temp'),
                            t(this.lang, 'ufa_gateway_closed_temp')
                        );
                        return;
                    }

                    if (paymentLink) {
                        this.setActiveDepositCache(Username, Systems, {
                            amount,
                            data,
                            isPaymentLink: true,
                            paymentLink,
                            qrcode: paymentQr || null,
                        }, 1);

                        this.setState({
                            depositamount: amount,
                            paymentlist: gateway,
                            depositstate: 1
                        });

                        openPaymentLink(paymentLink);
                        return;
                    }

                    if (paymentQr) {
                        const gatewayAcc = {
                            fullname_th: gateway?.bank_name || "Payment Gateway",
                            first_name_en: gateway?.account_name || gateway?.name || "",
                            last_name_en: "",
                            accnumber: gateway?.account_no || "Payment Gateway",
                            img_path: gateway?.img_path || paymentQr,
                            full_img: gateway?.img_path || paymentQr,
                            status: 1,
                            del: 1,
                        };

                        this.setActiveDepositCache(Username, Systems, {
                            amount,
                            data,
                            qrcode: paymentQr,
                        }, 1);

                        await showBankPopup({
                            amount,
                            bankAcc: gatewayAcc,
                            qrcode: paymentQr,
                            gateway,
                            data,
                            expireAt: Date.now() + (DEPOSIT_CACHE_MINUTES * 60 * 1000),
                            Username,
                            cachePaymentState: 1,
                        });
                        return;
                    }

                    this.clearDepositCache(Username, Systems, 1);

                    await swalAlert(
                        "warning",
                        t(this.lang, 'ufa_no_payment_channel'),
                        t(this.lang, 'ufa_no_link_or_qr')
                    );
                    return;
                }

                if (paymentstate === 0) {
                    if (hasBankAcc) {
                        this.setActiveDepositCache(Username, Systems, {
                            amount,
                            data,
                            qrcode: null,
                        }, 0);

                        await showBankPopup({
                            amount,
                            bankAcc,
                            qrcode: null,
                            gateway,
                            data,
                            expireAt: Date.now() + (DEPOSIT_CACHE_MINUTES * 60 * 1000),
                            Username,
                            cachePaymentState: 0,
                        });
                        return;
                    }

                    this.clearDepositCache(Username, Systems, 0);

                    await swalAlert(
                        "warning",
                        t(this.lang, 'ufa_deposit_closed_temp'),
                        t(this.lang, 'ufa_no_bank_for_deposit')
                    );
                    return;
                }

            } catch (error) {
                console.log("confirmdeposit error:", {
                    message: error.message,
                    status: error.response?.status,
                    data: error.response?.data,
                });

                await swalAlert(
                    "error",
                    t(this.lang, 'error_occurred'),
                    t(this.lang, 'ufa_cannot_create_deposit')
                );

                throw error;
            }

            return;
        }

        if (num === 1) {
            this.setState({ depositstate: 1 });
            return;
        }

        if (num === 5) {
            document.getElementById("truemonney").click();
            return;
        }

        this.setState({ depositstate: 0 });
    };

    togglePopup = () => {
        this.setState((prevState) => ({
            isPopupOpen: !prevState.isPopupOpen,
        }));
    };

    onChange = async (event) => {
        console.log(1163, event);
        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            if (nam === "withdrawamount") {
                if (this.state.maxwithdrawstatus === 1) {
                    this.setState({ [nam]: this.state.balance });
                    await this.notify("warning", t(this.lang, 'force_withdraw_all'));
                }
                else if (Number(val) <= Number(this.state.balance)) {
                    this.setState({ [nam]: val });
                }
                else {
                    await this.notify("warning", t(this.lang, 'insufficient_withdraw'));

                }
            } else {
                this.setState({ [nam]: val });
            }
            if (nam === "txtsech" || nam === "txtsech2") {
                const tabselect = this.state.tabselect
                let list = []
                let step = 1
                if (this.state.filterlist.length == 0) {
                    if (tabselect == 16 || tabselect == 20) {
                        list = this.state.listitallgame
                        step = 1
                    }
                    else if (tabselect == 13) {
                        list = this.state.slotlist
                        step = 2
                    }
                    else if (tabselect == 10) {
                        list = this.state.categorylist
                        step = 3
                    }
                    else if (tabselect == 14) {
                        list = this.state.sportlist
                        step = 4
                    }
                    else if (tabselect == 12) {
                        list = this.state.fishinglist
                        step = 5
                    }
                    else if (tabselect == 11) {
                        list = this.state.gamehitlist
                        step = 6
                    }
                    else if (tabselect == 18) {
                        list = this.state.providorlist
                        step = 7
                    }
                    this.setState({ filterlist: list });
                }
                else {
                    list = this.state.filterlist
                }
                let retailArrays = [];
                list.forEach(
                    array => {
                        console.log(1231, tabselect, step, array)
                        if (tabselect == 18 || tabselect == 10 || tabselect == 14) {
                            if (array.providername.toLowerCase().includes(val.toLowerCase())) {
                                retailArrays.push(array);
                            };
                        }
                        else {
                            if (array.description.toLowerCase().includes(val.toLowerCase())) {
                                retailArrays.push(array);
                            };
                        }
                    }
                )
                if (step == 1) this.setState({ listitallgame: retailArrays });
                else if (step == 2) this.setState({ slotlist: retailArrays });
                else if (step == 3) this.setState({ categorylist: retailArrays });
                else if (step == 4) this.setState({ sportlist: retailArrays });
                else if (step == 5) this.setState({ fishinglist: retailArrays });
                else if (step == 6) this.setState({ gamehitlist: retailArrays });
                else if (step == 7) this.setState({ providorlist: retailArrays });
            }

        }
    };
    submitwithdraw = async (e) => {
        try {
            if (this.state.isWithdrawLoading) return;

            const now = Date.now();
            const lockedUntil = Number(localStorage.getItem("withdrawLockedUntil") || 0);

            // ยังติดล็อกอยู่
            if (lockedUntil && now < lockedUntil) {
                const remainSec = Math.ceil((lockedUntil - now) / 1000);
                await this.notify("warning", `${t(this.lang, 'ufa_please_wait')} ${remainSec} ${t(this.lang, 'sec_unit')}`);
                return;
            }

            console.log(this.state.withdrawamount, this.state.balance);

            if (parseFloat(this.state.withdrawamount) > parseFloat(this.state.balance)) {
                // fail -> ล็อก 5 วินาที
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("warning", t(this.lang, 'insufficient_withdraw'));
                return;
            }

            if (parseFloat(this.state.withdrawamount) < 50) {
                // fail -> ล็อก 5 วินาที
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("warning", t(this.lang, 'min_withdraw_prefix') + " 50 " + t(this.lang, 'baht'));
                return;
            }

            const token = localStorage.getItem("auth_token");
            if (!token) {
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("error", t(this.lang, 'withdraw_problem'));
                return;
            }

            this.setState({ isWithdrawLoading: true });

            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;

            const res = await instance.post(
                "/api/v1/userwithdraw",
                {
                    User_id: Username,
                    System: Systems,
                    amount: this.state.withdrawamount
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            console.log(res.data);

            if (res.data.status === 200) {
                const successLock = Date.now() + 5 * 60 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(successLock));

                this.setState({
                    withdrawLockedUntil: successLock,
                    redirectCountdown: 5
                });

                await this.notify("success", t(this.lang, 'withdraw_success'));

                if (this.redirectTimer) clearInterval(this.redirectTimer);
                if (this.redirectTimeout) clearTimeout(this.redirectTimeout);

                this.redirectTimer = setInterval(() => {
                    this.setState((prev) => {
                        if (prev.redirectCountdown <= 1) {
                            clearInterval(this.redirectTimer);
                            return { redirectCountdown: 0 };
                        }
                        return { redirectCountdown: prev.redirectCountdown - 1 };
                    });
                }, 1000);

                this.redirectTimeout = setTimeout(() => {
                    this.checkurl(e, "/history");
                }, 5000);

                return;
            }

            if (res.data.status === 203) {
                // fail -> ล็อก 5 วินาที
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("error", t(this.lang, 'turnover_remaining_prefix') + " " + res.data.amountturnover + " " + t(this.lang, 'baht'));
                return;
            }

            if (res.data.status === 207) {
                // fail -> ล็อก 5 วินาที
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("error", t(this.lang, 'min_withdraw_prefix') + " " + res.data.maxwithdraw + " " + t(this.lang, 'baht'));
                return;
            }

            // fail -> ล็อก 5 วินาที
            const failLock = Date.now() + 5 * 1000;
            localStorage.setItem("withdrawLockedUntil", String(failLock));
            this.setState({ withdrawLockedUntil: failLock });

            await this.notify("error", t(this.lang, 'withdraw_error'));
        } catch (error) {
            console.log("submitwithdraw error:", error);

            // error -> ล็อก 5 วินาที
            const failLock = Date.now() + 5 * 1000;
            localStorage.setItem("withdrawLockedUntil", String(failLock));
            this.setState({ withdrawLockedUntil: failLock });

            await this.notify("error", t(this.lang, 'withdraw_error'));
        } finally {
            this.setState({ isWithdrawLoading: false });
        }
    };
    resetpassword = async (e, type) => {
        e.preventDefault();
        const { phoneNumber, fname, password, oldpassword, passwordcf } = this.state;
        console.log(type, password, oldpassword, passwordcf);
        var token = localStorage.getItem('auth_token');
        if (password === passwordcf) {
            var Username = null;
            var decoded = null;
            if (type === 1 && token != null) {
                decoded = jwt_decode(token);
                Username = decoded.message.playerid;
                instance.post("/api/v1/resetpassword", {
                    username: Username,
                    oldpass: oldpassword,
                    System: Systems,
                    newpass: password,
                    type: type
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", t(this.lang, 'change_password_success'));
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", t(this.lang, 'wrong_old_password'));
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", t(this.lang, 'password_error'));
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", t(this.lang, 'same_password'));
                    }
                });
            }
            else if (type === 2) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", t(this.lang, 'change_password_success'));
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", t(this.lang, 'wrong_old_password'));
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", t(this.lang, 'password_error'));
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", t(this.lang, 'same_password'));
                    }
                });
            }
            else if (type === 3) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", t(this.lang, 'change_password_success'));
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", t(this.lang, 'wrong_old_password'));
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", t(this.lang, 'password_error'));
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", t(this.lang, 'same_password'));
                    }
                });
            }
        }
        else {
            await this.notify("error", t(this.lang, 'password_mismatch'));
        }
    }
    async opencliaminvite(evt, cityName) {
        console.log(cityName);
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/cliaminvite", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    this.rechecklogin(Username, token);
                    await this.notify("success", t(this.lang, 'aff_claim_success'));
                }
                else if (res.data.status === 201) {
                    await this.notify("error", t(this.lang, 'aff_no_balance'));
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", t(this.lang, 'aff_claim_failed'));
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("warning", t(this.lang,'session_expired'));
                    window.location.href = this.state.webnamexback;
                }
            });
        } else {
            await this.notify("error", t(this.lang, 'not_logged_in'));
            return false;
        }
        // });
    }
    handleClick = async (e, price) => {
        console.log(price);
        if (price <= this.state.balance) {
            this.setState({
                withdrawamount: price
            });
        }
        else {
            await this.notify("warning", t(this.lang, 'insufficient_withdraw'));
        }
    }
    handleClickreposit = async (e, price) => {
        this.setState({
            depositamount: price
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //console.log(Username, proid);
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data.status)
                if (res.data.status === 200) {
                    await this.notify("success", t(this.lang, 'ufa_promo_received'));
                    this.setState({
                        modalpromotion: false,
                    })
                }
                else if (res.data.status === 201) {
                    await this.notify("error", t(this.lang,'promo_not_eligible'));
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }
                else if (res.data.status === 204) {
                    await this.notify("error", t(this.lang, 'promo_daily_used_up'));
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", t(this.lang, 'ufa_promo_pending'));
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", t(this.lang,'session_expired'));
                    window.location.href = this.state.webnamexback;
                }
            });
        }
    }
    redeem = async (e, gameIdx, partner) => {
        var userAgent = navigator.userAgent
        await this.checklogin();
        console.log(this.state.loginstate, 55555555)
        if (!this.state.loginstate) {
            await this.notify("error", t(this.lang,'not_logged_in'));
            return;
            //  return document.getElementById("loginmode").click();
        }
        if (this.state.username !== null) {
            instance.post("/api/v1/tablauncher", {
                gameId: gameIdx,
                partner: partner,
                playerUsername: this.state.username,
                isMobile: isMobile,
                System: Systems,
                demo: false
            })
                .then((res) => {
                    if (res.data.status === 200) {
                        //////console.log(res.data.message);
                        var test = res.data.message.launcher
                        if (test !== undefined) {
                            if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                window.location.href = test.mobile;
                            }
                            else {
                                if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                                else window.open(test.mobile);
                            }
                        }
                        else if (test === undefined) {
                            this.notify("error", t(this.lang, 'game_problem'));
                        }
                    }
                    else {
                        //  this.CheckThisGoalError();
                    }
                });
        }
        else {

        }


    }
    redeemcheck = async (e, ListItem) => {
        console.log(ListItem)
        var userAgent = navigator.userAgent
        this.checklogin();
        if (!this.state.loginstate) {
            await this.notify("error", t(this.lang,'not_logged_in'));
            return;
            //  return document.getElementById("loginmode").click();
        }
        if (this.state.username !== null) {

            if (ListItem.gameId != undefined) {
                instance.post("/api/v1/tablauncher", {
                    gameId: ListItem.gameId,
                    partner: ListItem.partner,
                    playerUsername: this.state.username,
                    isMobile: isMobile,
                    System: Systems,
                    demo: false
                })
                    .then((res) => {
                        if (res.data.status === 200) {
                            //////console.log(res.data.message);
                            var test = res.data.message.launcher
                            if (test !== undefined) {
                                if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                    window.location.href = test.mobile;
                                }
                                else {
                                    if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                                    else window.open(test.mobile);
                                }
                            }
                            else if (test === undefined) {
                                this.notify("error", t(this.lang, 'game_problem'));
                            }
                        }
                        else {
                            //  this.CheckThisGoalError();
                        }
                    });
            }
            else {
                this.checkurl(e, "/game/list/" + ListItem.partner)
            }
        }
        else {

        }


    }

    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await this.notify("success", t(this.lang, 'coupon_success_title'));
                }
                else {
                    await this.notify("warning", t(this.lang, 'invalid_coupon'));
                }
            });
        }
        else {
            await this.notify("warning", t(this.lang, 'not_logged_in'));
        }

    }

    copy = async (e, accnumber) => {
        toast.success(t(this.lang, 'copy_success'), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

        navigator.clipboard.writeText(accnumber)
    }
    copyCode = (text) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                setTimeout(function () {
                }, 3000);
            })
            .catch((err) => {
                // console.log(err.message);
            });
        this.notify("success", t(this.lang, 'copy_success'));
    };



    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };

    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };



    handleBwufaMsg = (e) => {
        // รับคำสั่งจาก iframe ธีม (bwufabet02) → เรียก handler นำทางเดิม
        if (e && e.data && e.data.bwufa && e.data.path) {
            if (e.data.path === "/logout") { window.location.href = "/logout"; return; }
            const fakeE = { preventDefault() { }, stopPropagation() { } };
            this.checkurl(fakeE, e.data.path);
        }
    };
    async componentDidMount() {
        NProgress.start();
        // --- affiliate/referral link tracking (?aff= key / ?reg= hash) ---
        try {
            const _url = new URL(window.location.href);
            const _aff = _url.searchParams.get("aff");
            const _reg = _url.searchParams.get("reg");
            if (_aff) { this.saveclickaff(_aff); }
            else if (_reg) { this.saveclick(_reg); }
            else {
                const _tokenf = localStorage.getItem('aff');
                if (_tokenf) { try { const c = JSON.parse(_tokenf); if (c && c.username) this.setState({ userrecomend: c.username }); } catch (e) { } }
            }
        } catch (e) { }
        window.addEventListener("popstate", this.handlePopState);
        window.addEventListener("message", this.handleBwufaMsg);
        // [2026-11-04] ไม่ต่อ socket ซ้ำ — App.js ต่อห้องเดียวกันให้แล้ว (เดิมเปิด 2 connection ต่อผู้เล่น)

        // this.promotionlist();
        // this.checklogin();
        //  this.getwheel();
        try {
            const pathname = window.location.pathname.split("/");
            const mainSettingKey = "mainSettingCache";
            const mainSettingTTL = 30 * 60 * 1000; // 30 นาที

            // ตรวจสอบแคชสำหรับ main setting
            const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);

            if (mainSettingCache) {
                console.log("Using cached data for main setting");
                const data = mainSettingCache;

                document.title = data.tblsetting[0].title;
                applySiteIcon(data.favicon || (data.tblsetting[0] && data.tblsetting[0].favicon), data.tblsetting[0].imglogo, data.tblsetting[0].title, data.tblsetting[0].Description); // ไอคอนเว็บ: favicon จาก BO ไม่งั้นโลโก้

                this.setState({
                    webname: data.tblsetting[0].Description,
                    logoimg: data.tblsetting[0].imglogo,
                    whellsetting: data.tblwheelsetting,
                    maxwithdrawstatus: data.tblcatagoryx[0].withdrawmax,
                    luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                    linelink: data.message[1].value,
                    webnamex: data.message[7].value,
                    describemain: data.tblsetting[0].title,
                    System: data.tblcatagoryx[0].System,
                    cashoutSet: data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting[0],
                    datas: data.message,
                    limit: { min: data.tblcatagoryx[0].limitdeposit, max: data.tblcatagoryx[0].maxdeposit },
                    uploadslip: data.tblcatagoryx[0].uploadslip || 0,
                    currency: (data.tblcatagoryx[0].currency || 'THB'),
                    Rate: Number(data.tblcatagoryx[0].Rate) || 1,
                });
            } else {
                await instance.post("/api/v1/mainsetting", {
                    System: Systems,
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log("luckywheeldisplay", res.data);
                        const datas = res.data.message;
                        const min = res.data.tblcatagoryx[0].limitdeposit;
                        const max = res.data.tblcatagoryx[0].maxdeposit;
                        const maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax;
                        const limit = { min, max };
                        const luckywheeldisplay = res.data.tblwheelsetting[0].status === 1;

                        document.title = res.data.tblsetting[0].title;
                        applySiteIcon(res.data.favicon || (res.data.tblsetting[0] && res.data.tblsetting[0].favicon), res.data.tblsetting[0].imglogo, res.data.tblsetting[0].title, res.data.tblsetting[0].Description); // ไอคอนเว็บ: favicon จาก BO ไม่งั้นโลโก้

                        this.setState({
                            webname: res.data.tblsetting[0].Description,
                            logoimg: res.data.tblsetting[0].imglogo,
                            whellsetting: res.data.tblwheelsetting,
                            maxwithdrawstatus: maxwithdrawstatus,
                            luckywheeldisplay: luckywheeldisplay,
                            linelink: datas[1].value,
                            webnamex: datas[7].value,
                            describemain: res.data.tblsetting[0].title,
                            System: res.data.tblcatagoryx[0].System,
                            cashoutSet: res.data.tblcashoutsetting[0],
                            inviteSet: res.data.tblinvitedsetting[0],
                            datas: datas,
                            limit: limit,
                            uploadslip: res.data.tblcatagoryx[0].uploadslip || 0,
                            currency: (res.data.tblcatagoryx[0].currency || 'THB'),
                            Rate: Number(res.data.tblcatagoryx[0].Rate) || 1,
                        });

                        this.setCache(mainSettingKey, res.data);
                    }
                });
            }

            //   console.log(455, pathname[1] + "/" + pathname[2])
            // [2026-11-04] เดิมใช้ Username/token ที่ยังไม่ได้กำหนดค่า (var ประกาศด้านล่าง) -> ยิง gettrue แบบ userid ว่างทุกครั้งที่เปิดเว็บ
            const _gtTok = localStorage.getItem('auth_token');
            let _gtUid = null;
            if (_gtTok) { try { _gtUid = jwt_decode(_gtTok).message.playerid; } catch (e) { _gtUid = null; } }
            const getTrueKey = `getTrueCache_${_gtUid}_${Systems}`;
            const getTrueTTL = 30 * 60 * 1000; // 30 นาที
            const getTrueCache = this.getCache(getTrueKey, getTrueTTL);

            if (getTrueCache) {
                console.log("Using cached data for getTrue");
                this.setState({
                    trueaccount: getTrueCache,
                });
            } else if (_gtTok && _gtUid) { // ยังไม่ล็อกอิน ไม่ต้องยิง
                await instance.post("/api/v1/gettrue", {
                    userid: _gtUid,
                    System: Systems,
                }, {
                    headers: { Authorization: `Bearer ${_gtTok}` }
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log(res);
                        const trueAccount = res.data.message.tbltruewallet[0];

                        this.setState({
                            trueaccount: trueAccount,
                        });

                        this.setCache(getTrueKey, trueAccount);
                    }
                }).catch((err) => {
                    console.error("Error fetching getTrue data:", err);
                });
            }

            if (pathname.length > 1) {
                console.log(pathname);
                if (pathname[1] == "casino") {
                    this.setState({
                        tabselect: 10,
                    });
                }
                else if (pathname[1] == "gamehit") {

                    this.setState({
                        tabselect: 11,
                    });
                }
                else if (pathname[1] == "fishing") {
                    this.setState({
                        tabselect: 12,
                    });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }
                else if (pathname[1] == "slot") {
                    this.setState({
                        tabselect: 13,
                    });
                }
                else if (pathname[1] == "register") {
                    // ใช้ฟอร์มสมัครของธีม (iframe) แทนฟอร์มเดิม
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "signin" || pathname[1] == "login") {
                    // ใช้หน้า login ของธีม (iframe bwufa) เหมือน /register ไม่ใช้หน้า Signin เก่า (desktop)
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "luckyfortune") {
                    this.setState({
                        tabselect: 35,
                    });
                }
                else if (pathname[1] == "checkindaily") {
                    this.setState({
                        tabselect: 36,
                    });
                }
                else if (pathname[1] == "cardminigame") {
                    this.setState({
                        tabselect: 37,
                    });
                }
                else if (pathname[1] == "coupon") {
                    this.setState({
                        tabselect: 50,
                    });
                }
                else if (pathname[1] == "sport") {
                    this.setState({
                        tabselect: 14,
                    });
                }
                else if (pathname[1] == "event") {
                    this.setState({
                        tabselect: 16,
                    });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    // console.log(1232323)
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 1,
                            tabselectdeposit: 1,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "history") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 3,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "profile") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 8,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    console.log(63855555);
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "affiliate") {
                    let _tk = localStorage.getItem('auth_token');
                    let _uid = "";
                    try { _uid = jwt_decode(_tk).message.playerid; } catch (e) { _uid = ""; }
                    await this.checkuseradvice(_uid);
                    this.setState({
                        tabselect: 4,
                    });
                }
                else if (pathname[1] == "network") {
                    let _tk = localStorage.getItem('auth_token');
                    let _uid = "";
                    try { _uid = jwt_decode(_tk).message.playerid; } catch (e) { _uid = ""; }
                    await this.checkuseradvice(_uid);
                    this.setState({
                        tabselect: 44,
                    });
                }
                else if (pathname[1] == "rebate") {
                    this.setState({
                        tabselect: 5,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "listgameall") {
                    if (typeof this.getgame === "function") {
                        let check = await this.getgame(pathname[2], pathname[3]);
                        if (check) {
                            this.setState({
                                tabselect: 15,
                            });
                        }
                    }
                }
                else if (pathname[1] == "review") {
                    this.setState({ tabselect: 54 });
                    this.fetchReviewList(1);
                }
                else if (pathname[1] == "rank") {
                    this.setState({ tabselect: 55 });
                }
            }
            try {
                console.log(1625656556);
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await this.rechecklogin(Username, token);
                    this.setState({
                        userid: decoded.message.playerid,
                        username: decoded.message.playerid,
                        firstname: decoded.message.firstname,
                        lastname: decoded.message.lastname,
                        loginstate: true,
                    });
                }
                else {
                    this.setState({
                        loginstate: false,
                    });
                }


            }
            catch (error) {
                console.log(185222, error);
            }
        }
        catch (error) {
            console.log(185222, error);
        }
        if (token != null) {
            var decoded = jwt_decode(token);
            let Username = decoded.message.playerid;
            instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: 50
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                console.log(res.data.picture)
                console.log(16888, res.data)
                this.setState({
                    mainacc: res.data.mainacc,
                    listacc: res.data.tblmain,
                    paymentgateway: res.data.tblpaymentgatewayx,
                    paymentlist: res.data.tblpaymentgatewayx,
                });
            });
        }
        NProgress.done();
    }


    async checktab(e, index) {
        console.log(11111, index);
        if (index == 2) {
            //   await this.notify("error", 'ปิดระบบ QRcode ขัวคราว');
            this.setState({
                tabselectdeposit: index,
                tabselect: 1,
            });

        }
        else {
            this.setState({
                tabselectdeposit: index,
                tabselect: 1,
            });

            if (index == 3) {
                this.confirmdeposit(e, 0)
            }
        }
    }
    async checkuseradvice(username) {
        instance.post("/api/v1/checkuseradvice", {
            User_id: username,
            page: 1,
            System: Systems,
        }).then((res) => {
            if ((res.data.status === 200 || res.data.status === 201) && res.data.message) {
                console.log("statsstatsstatsstats", res.data.message);
                this.setState({
                    stats: res.data.message.stats || {},
                    reports: res.data.message.reports || [],
                    useradvice: res.data.message.useradvicelist || []
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }
    async rechecklogin(Username, token) {

        try {
            console.log(4555555555555);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {

                if (res.data.status === 200) {
                    console.log(2142, res.data);
                    localStorage.setItem('auth_token', res.data.token)
                    console.log(1067, res.data.userafftoday, res.data.useraffall);
                    var rankall = res.data.tblrankall;
                    const found = rankall.find(obj => {
                        return obj.checked === 1;
                    });
                    this.setState({
                        usercheck: res.data.usercheck,
                        tblrankall: res.data.tblrankall,
                        rankpic: res.data.tblrank?.image,
                        rankname: res.data.tblrank?.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        fullname: res.data.message.firstname,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        affiliatetoday: res.data.userafftoday,
                        affiliateall: res.data.useraffall,
                        buttoncliam: (found === undefined) ? true : false,
                        loginstate: true,
                    });

                    this.calllisthistory(Username);
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await this.notify("error", t(this.lang,'session_expired'));
                    window.location.href = '/login';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response?.status === 401 || err.response?.status === 403) {
                    localStorage.clear();
                    await this.notify("error", t(this.lang,'session_expired'));
                    window.location.href = '/login';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        console.log(248, proid);
        var Username = "";
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            Username = decoded.message.playerid;
        }
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            console.log(res.data)
            if (res.data.status === 200) {
                //console.log(res.data);
                if (res.data.type === 0) {
                    this.setState({
                        modalpromotion: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        modalpromotion: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }



            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", t(this.lang,'promo_pending_deposit'));
                return false;
            }

        }).catch(async (err) => {
            //   console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", t(this.lang,'session_expired'));
                window.location.href = '/login';
            }
        });
    }


    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    async opencliamcashout(evt, cityName) {
        var str = t(this.lang, 'ufa_withdraw_bonus_line1') + "\n" +
            t(this.lang, 'ufa_withdraw_bonus_line2') + "\n";
        Swal.fire({
            title: t(this.lang, 'ufa_confirm_withdraw_bonus'),
            html: '<pre>' + str + '</pre>',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#81d539",
            cancelButtonColor: "#ea133d",
            confirmButtonText: t(this.lang, 'confirm'),
            cancelButtonText: t(this.lang, 'cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);

                    var Username = decoded.message.playerid;
                    await instance.post("/api/v1/cliamcashout", {
                        userid: Username,
                        System: Systems,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            var decoded = jwt_decode(token);
                            var Username = decoded.message.playerid;
                            this.rechecklogin(Username, token);
                            this.notify("success", t(this.lang, 'aff_claim_success'));

                        }
                        else if (res.data.status === 201) {
                            await this.notify("error", t(this.lang, 'aff_no_balance'));
                            return false;
                        }
                        else if (res.data.status === 202) {
                            await this.notify("error", t(this.lang, 'aff_claim_failed'));
                            return false;
                        }

                    }).catch(async (err) => {
                        // console.log(err);
                        if (err.response.status === 401 || err.response.status === 403) {
                            localStorage.clear();
                            await this.notify("error", t(this.lang,'session_expired'));
                            window.location.href = '/login';
                        }
                    });
                }
                else {
                    await this.notify("error", t(this.lang, 'not_logged_in'));
                }
            }
        });

    }
    fetchReviewList = async (page = 1) => {
        this.setState({ reviewLoading: true, reviewPage: page });
        try {
            const res = await instance.post("/api/v1/customer-review/list", {
                System: Systems,
                page: page,
                limit: 12,
            });
            if (res.data && res.data.status === 200) {
                this.setState({
                    reviewList: res.data.message.list || [],
                    reviewTotal: res.data.message.total || 0,
                });
            } else {
                this.setState({ reviewList: [], reviewTotal: 0 });
            }
        } catch (e) {
            this.setState({ reviewList: [], reviewTotal: 0 });
        } finally {
            this.setState({ reviewLoading: false });
        }
    };

    render() {
        const { activeTab } = this.state;
        const { oldPassword, newPassword, confirmPassword } = this.state;
        let { loginstate, usercheck, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile, limit } = this.state
        const { prodetail, picnonpro, tabselectselect, accnumber, paymentlist, mainacc, trueaccount, listacc, tabselect } = this.state
        var limits = limit
        console.log("mainacc", tabselect);
        const paymentArray = Array.isArray(paymentlist) ? paymentlist : (paymentlist ? [paymentlist] : []);


        var accnumberx;
        if (accnumber != null) {
            accnumberx = accnumber[0];
        }
        console.log(1326, tabselect);
        return (
            <div id="pageTopAnchor">
                {/* หน้าแรก: iframe ธีม bwufabet02 จริง (pixel 1:1) — ส่ง config (logo/api/system) ให้ iframe ดึงเกม+logo จริง */}
                {tabselect === 0 && (
                    <iframe
                        title="lobby"
                        src={"/bwufa/dashboard.html?v=20261025c&sys=" + encodeURIComponent(Systems)
                            + "&logo=" + encodeURIComponent(this.state.logoimg || "")
                            + "&api=" + encodeURIComponent(process.env.NODE_ENV === "production" ? "https://apiclient.newworld.center" : "http://localhost:7001")}
                        className="bwufa-iframe"
                        style={{ position: 'fixed', inset: 0, width: '100%', height: '100dvh', border: 'none', zIndex: 2147482000, background: '#0d0406' }} /* ต่ำกว่าปุ่มแชทสด (2147483000) ให้ปุ่มแชทลอยอยู่บนหน้าแรกได้ */
                    />
                )}
                <div

                    className="main-wrapper"
                    onScroll={this.handleScroll}
                    style={{ height: "100vh" }}
                >
                    <div id="topbar" className={this.state.topbarOpen ? "" : "tt_open"}>
                        <div
                            className="tt_btn_close"
                            onClick={() => this.setState({ topbarOpen: false })}
                        >
                            <i className="fa fa-times" />
                        </div>

                        <div
                            className="tt_btn_open"
                            onClick={() => this.setState({ topbarOpen: true })}
                        >
                            <i className="fa fa-plus" />
                        </div>

                        <a
                            className="tt_img_fixed"
                            target="_blank"
                            rel="noreferrer"
                            href={this.state.linelink}
                        >
                            <img loading="lazy"
                                src="https://s3.newworld.center/image/f88c5493-7556-494a-a0cf-3d762e15a601.webp"
                                alt="line"
                            />
                            <span className="tt_tx_line">LINE : {this.state.lineId}</span>
                        </a>

                        <a
                            className="tt_img_fixed fx_telegram"
                            target="_blank"
                            rel="noreferrer"
                            href="https://t.me/UFA11"
                        >
                            <img loading="lazy"
                                src="https://s3.newworld.center/image/7a8130ae-efc9-496b-8dbb-c26335043e4d.webp"
                                alt="telegram qr"
                            />
                            <span className="tt_tx_telegram">
                                <img loading="lazy"
                                    src="/build/web/igame-index-lobby-wm/img/telegram.png"
                                    alt="telegram"
                                />
                                Telegram : @UFA11
                            </span>
                        </a>

                        <a className="tt_l mt-10 tt_img_fixed" target="_blank" rel="noreferrer" href="#">
                            <img loading="lazy"
                                src="https://s3.newworld.center/image/be368033-a430-4dbb-86d1-fc8b969b4036.webp"
                                alt="game"
                            />
                        </a>
                    </div>
                    <div id="topbar2" className={this.state.topbar2Open ? "" : "tt_open2"}>
                        <div className="tt_l tt_full">
                            <div
                                className="tt_btn_close2"
                                onClick={() => this.setState({ topbar2Open: false })}
                            >
                                <i className="fa fa-times" />
                            </div>
                            <div
                                className="tt_btn_open2"
                                onClick={() => this.setState({ topbar2Open: true })}
                            >
                                <i className="fa fa-plus" />
                            </div>
                        </div>
                        <a
                            className="tt_l tt_img_fixed2"
                            target="_blank"
                            onClick={(e) => {
                                this.checkurl(e, "/login")
                            }}
                        >
                            <img loading="lazy" src="https://s3.newworld.center/image/3af65a89-81d1-478c-ba84-7256c9497e88.webp" />
                        </a>
                        <a
                            className="tt_l tt_img_fixed2"
                            target="_blank"
                            onClick={(e) => {
                                this.checkurl(e, "/login")
                            }}
                        >
                            <img loading="lazy" src="https://s3.newworld.center/image/43fd7b6b-87fc-420e-855c-7615f0628a6d.webp" />
                        </a>
                        <a className="tt_l tt_img_fixed2" target="_blank" href="">
                            <img loading="lazy" src="https://s3.newworld.center/image/5b6d72cd-c6ff-4793-95fe-b916c64ea2de.webp" />
                        </a>
                        <a className="tt_l tt_img_fixed2" target="_blank" href="">
                            <img loading="lazy" src="https://s3.newworld.center/image/994f4ba3-a59e-43a3-a48f-8cc1f90ab933.webp" />
                        </a>
                        <a
                            className="tt_l tt_img_fixed2"
                            target="_blank"
                            onClick={(e) => {
                                this.checkurl(e, "/login")
                            }}
                        >
                            <img loading="lazy" src="https://s3.newworld.center/image/b83e265a-8651-492c-9d1c-538273afa553.webp" />
                        </a>
                        <a
                            className="tt_l tt_img_fixed2"
                            target="_blank"
                            onClick={(e) => {
                                this.checkurl(e, "/login")
                            }}
                        >
                            <img loading="lazy" src="https://s3.newworld.center/image/84805449-c475-4dde-b8a3-8aa188023a2a.webp" />
                        </a>
                        <a
                            className="tt_l tt_img_fixed2"
                            target="_blank"
                            onClick={(e) => {
                                this.checkurl(e, "/login")
                            }}
                        >
                            <img loading="lazy" src="https://s3.newworld.center/image/471ccc9b-b78f-4dd6-9301-dfca4aa53af3.webp" />
                        </a>
                        <a className="tt_l tt_img_fixed2" target="_blank" href="">
                            <img loading="lazy" src="https://s3.newworld.center/image/0db21c53-65f9-4e85-8848-b455a49947b0.webp" />
                        </a>
                        <a
                            className="tt_l tt_img_fixed2"
                            target="_blank"
                            onClick={(e) => {
                                this.checkurl(e, "/login")
                            }}
                        >
                            <img loading="lazy" src="https://s3.newworld.center/image/5e190838-570a-43c9-85fe-3e7afb7cf4ac.webp" />
                        </a>
                        <a
                            className="tt_l tt_img_fixed2"
                            target="_blank"
                            onClick={(e) => {
                                this.checkurl(e, "/login")
                            }}
                        >
                            <img loading="lazy" src="https://s3.newworld.center/image/ca33c20d-a679-4fc2-b290-64c698563d68.webp" />
                        </a>
                    </div>
                    {this.state.gooaldaddyShow && (
                        <div style={{ position: "fixed", left: "10px", top: "578px", zIndex: 999999999, width: "150px", maxWidth: "42vw", maxHeight: "calc(100vh - 583px)", overflow: "hidden" }}>
                            <button
                                onClick={() => this.setState({ gooaldaddyShow: false })}
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    right: "0px",
                                    background: "rgba(0,0,0,0.65)",
                                    border: "none",
                                    borderRadius: "50%",
                                    color: "#fff",
                                    width: "20px",
                                    height: "20px",
                                    fontSize: "13px",
                                    lineHeight: "20px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    padding: 0,
                                    zIndex: 1,
                                }}
                            >×</button>
                            <a href="https://gooaldaddy.com" target="_blank" rel="noreferrer" className="gooaldaddy_float" style={{ display: "block", lineHeight: 0, cursor: "pointer" }}>
                                <img loading="lazy" src="https://s3.newworld.center/gif/f561f112-b816-4666-9425-0e7c2d4135f2.gif" alt="gooaldaddy" style={{ width: "100%", height: "auto", display: "block" }} />
                            </a>
                        </div>
                    )}
                    <div className="tt-l tt-full head_mc" >
                        <style
                            dangerouslySetInnerHTML={{
                                __html:
                                    "\n    .team-popup-close {\n        color: #fff;\n        width: 30px;\n        font-size: 30px;\n        position: absolute;\n        z-index: 999;\n        top: 65px;\n        right: 0px;\n\n    }\n"
                            }}
                        />
                        {/* <a
                        className="tt_l logo_m install_m"
                        href="#"
                    >
                        <img loading="lazy"
                            width={800}
                            height={220}
                            src="/build/web/igame-index-lobby-wm/img/head-download.png"
                        />
                    </a>
                    <a
                        href="#"
                        className="team-popup-close logo_m install_m"
                    >
                        ×
                    </a> */}
                        <div className="tt_l h-linem">
                            <a href={this.state.linelink} target="_blank">
                                <img loading="lazy"
                                    width={140}
                                    height={46}
                                    src="/build/web/igame-index-lobby-wm/img/button-lineadd.jpg?v=1.0"
                                />
                            </a>
                        </div>
                        {/* Telegram */}
                        <div className="tt_l m-telegram">
                            <a href={this.state.linelink} target="_blank">
                                <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/telegram.png" />
                                <span> @UFA11</span>
                            </a>
                        </div>
                        {/* END Telegram */}
                    </div>
                    <div className="tt-l tt-full" >
                        <div className="tt_l tt_full header_bg">
                            <div className="tt_l tt_full header">
                                <a className="tt_l logo_h_m" role="button"
                                    onClick={(e) => {
                                        this.checkurl(e, "/")
                                    }}>
                                    <img loading="lazy"
                                        width={135}
                                        height={40}
                                        src={this.state.logoimg}
                                    />
                                </a>
                                <div
                                    className="tt_r btn_main_menu"
                                    onClick={() => this.setState(prev => ({ topbaruse_m: !prev.topbaruse_m }))}
                                >
                                    <div className="nav_b">
                                        <i className="fa fa-bars" /> Menu{" "}
                                    </div>
                                </div>
                                <div className={`tt_l tt_head_menu use_m ${!this.state.topbaruse_m ? "" : "tt_open"}`}>
                                    <div className="menu-menu-mobile-container">
                                        <ul id="menu-menu-mobile" className="nav">
                                            <li
                                                id="menu-item-60"
                                                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-60"
                                            >
                                                <a role="button"
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/")
                                                    }} aria-current="page">
                                                    {t(this.lang,'home')}
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-61"
                                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-61"
                                            >
                                                <a href='#' role="button"
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/casino")
                                                    }} title={t(this.lang,'ufa_casino_online')}>
                                                    {t(this.lang,'ufa_casino_online')}
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-64"
                                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-64"
                                            >
                                                <a href='#' role="button"
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/sport")
                                                    }}>
                                                    {t(this.lang,'ufa_football_online')}
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-349"
                                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-349"
                                            >
                                                <a href='#' onClick={(e) => {
                                                    this.checkurl(e, "/login")
                                                }}>{t(this.lang,'login')}</a>
                                            </li>
                                            <li
                                                id="menu-item-4283"
                                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-4283"
                                            >
                                                <a href='#' onClick={(e) => { this.checkurl(e, "/review") }}>{t(this.lang,'ufa_review_service')}</a>
                                            </li>
                                            <li
                                                id="menu-item-352"
                                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-352"
                                            >
                                                <a href='#' role="button"
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/network")
                                                    }}>
                                                    {t(this.lang,'ufa_make_income')}
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-63"
                                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-63 ico-new"
                                                style={{ background: "none" }}
                                            >
                                                <a

                                                    onClick={(e) => {
                                                        this.checkurl(e, "/register")
                                                    }}
                                                    style={{
                                                        background: "none",
                                                        animation:
                                                            "0.5s steps(5) 0s infinite normal none running walk-cyclet2"
                                                    }}
                                                >
                                                    {t(this.lang,'register')}
                                                </a>
                                            </li>
                                            <li
                                                id="menu-item-65"
                                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-65"
                                            >
                                                <a href='#' onClick={(e) => {
                                                    this.checkurl(e, "/promotion")
                                                }} >{t(this.lang,'promotion')}</a>
                                            </li>
                                            <li
                                                id="menu-item-62"
                                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-62"
                                            >
                                                <a href="/contactus">{t(this.lang,'ufa_contact_us')}</a>
                                            </li>
                                            <li className="menu-item" style={{ background: "none", display: "flex", alignItems: "center", padding: "10px 16px" }}>
                                                <LanguageSwitcher language={this.lang} size="sm" onChange={() => { window.location.reload(); }} />
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                            <div className="tt_l tt_full m_pc" style={{ position: "relative" }}>
                                <div style={{ position: "absolute", right: 24, top: 12, zIndex: 60 }}>
                                    <LanguageSwitcher language={this.lang} size="sm" onChange={() => { window.location.reload(); }} />
                                </div>
                                <div className="wrapper">
                                    <a
                                        className="tt_l logo_pc"
                                        title={t(this.lang,'seo_title_main')}
                                        role="button"
                                        onClick={(e) => {
                                            this.checkurl(e, "/")
                                        }}
                                    >
                                        <img loading="lazy"
                                            width={135}
                                            height={40}
                                            src={this.state.logoimg}
                                        />
                                    </a>
                                    <div className="tt_l tt_head_menu">
                                        <div className="menu-menu-h-container">
                                            <ul id="menu-menu-h" className="nav">
                                                <li
                                                    id="menu-item-16"
                                                    className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-16"
                                                >
                                                    <a role="button"
                                                        onClick={(e) => {
                                                            this.checkurl(e, "/")
                                                        }} aria-current="page">
                                                        {t(this.lang,'home')}
                                                    </a>
                                                </li>
                                                <li
                                                    id="menu-item-23"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-23"
                                                >
                                                    <a role="button"
                                                        href='#'
                                                        onClick={(e) => {
                                                            this.checkurl(e, "/casino")
                                                        }} title={t(this.lang,'ufa_casino_online')}>
                                                        {t(this.lang,'ufa_casino_online')}
                                                    </a>
                                                </li>
                                                <li
                                                    id="menu-item-37"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-37"
                                                >
                                                    <a role="button"
                                                        href='#'
                                                        onClick={(e) => {
                                                            this.checkurl(e, "/sport")
                                                        }}>
                                                        {t(this.lang,'ufa_football_online')}
                                                    </a>
                                                </li>
                                                <li
                                                    id="menu-item-4284"
                                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-4284"
                                                >
                                                    <a href='#' onClick={(e) => { this.checkurl(e, "/review") }}>{t(this.lang,'ufa_review_service')}</a>
                                                </li>
                                                <li
                                                    id="menu-item-355"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-355"
                                                >
                                                    <a role="button"
                                                        href='#'
                                                        onClick={(e) => {
                                                            this.checkurl(e, "/network")
                                                        }}>
                                                        {t(this.lang,'ufa_make_income')}
                                                    </a>
                                                </li>
                                                <li
                                                    id="menu-item-36"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-36"
                                                >
                                                    <a onClick={(e) => {
                                                        this.checkurl(e, "/promotion")
                                                    }} href='#'>{t(this.lang,'promotion')}</a>
                                                </li>
                                                <li
                                                    id="menu-item-35"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-35"
                                                >
                                                    <a onClick={(e) => {
                                                        this.checkurl(e, "/contactus")
                                                    }} href='#'>{t(this.lang,'ufa_contact_us')}</a>
                                                </li>
                                                <li
                                                    id="menu-item-38"
                                                    className="ico-register menu-item menu-item-type-post_type menu-item-object-page menu-item-38 ico-new"
                                                    style={{ background: "none", marginLeft: 20 }}
                                                >
                                                    <a
                                                        onClick={(e) => {
                                                            this.checkurl(e, "/register")
                                                        }}
                                                        style={{
                                                            background: "none",
                                                            animation:
                                                                "0.5s steps(5) 0s infinite normal none running walk-cyclet2"
                                                        }}
                                                    >
                                                        {t(this.lang,'register')}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="tt_l tt_full slide_a" >
                        <div className="tt_l tt_full slide_pc">
                            <Banner />
                        </div>
                        <div className="tt_l tt_full slide_mobile">
                            <Banner />
                        </div>
                        <style
                            type="text/css"
                            dangerouslySetInnerHTML={{
                                __html:
                                    "\n.slide_mobile {display: none;}\n@media screen and (max-width:800px){\n.slide_mobile {display: block;}\n.slide_pc {display: none;}\n}\n"
                            }}
                        />
                        <div className="wrapper-c">
                            <div className="tt_l tt_full arh_sl" />
                        </div>
                    </div>
                    {/* Sub Banner — ภายใต้แบนเนอร์หลัก */}
                    <div className="tt_l tt_full" style={{ marginTop: 8 }}>
                        <SubBanner />
                    </div>
                    {/* P2: แถบหมวดหมู่ (pill + ไอคอน) สไตล์ bwufabet02 — presentation only, ใช้ handler checkurl เดิม */}
                    <div
                        className="bwufa-catrail-wrap"
                        style={{ display: [0, 10, 11, 12, 13, 14, 15, 17, 37].indexOf(tabselect) >= 0 ? "" : "none" }}
                    >
                        <div className="bwufa-catrail">
                            {[
                                { k: "popular", ic: "fas fa-fire", to: "/", tab: 0 },
                                { k: "sport", ic: "fas fa-futbol", to: "/sport", tab: 14 },
                                { k: "casino", ic: "fas fa-dice", to: "/casino", tab: 10 },
                                { k: "slot", ic: "fas fa-coins", to: "/slot", tab: 13 },
                                { k: "card_game", ic: "fas fa-clone", to: "/cardminigame", tab: 37 },
                                { k: "fishing", ic: "fas fa-fish", to: "/fishing", tab: 12 },
                                { k: "lotto", ic: "fas fa-ticket-alt", to: "/lotto", tab: 17 },
                                { k: "esport", ic: "fas fa-gamepad", to: "/sport", tab: -1 }
                            ].map((c) => (
                                <a
                                    key={c.k}
                                    role="button"
                                    className={"bwufa-cat" + (tabselect === c.tab ? " is-active" : "")}
                                    onClick={(e) => {
                                        this.checkurl(e, c.to);
                                    }}
                                >
                                    <span className="bwufa-cat-ic">
                                        <i className={c.ic} />
                                    </span>
                                    <span className="bwufa-cat-tx">{t(this.lang, c.k)}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                    {/* P4: กริดเกม/หมวด 3 คอลัมน์ สไตล์ bwufabet02 — presentation only, ใช้ handler checkurl เดิม */}
                    <div className="bwufa-grid-wrap" style={{ display: tabselect === 0 ? "" : "none" }}>
                        <div className="bwufa-grid">
                            {[
                                { k: "casino", ic: "fas fa-dice", to: "/casino" },
                                { k: "slot", ic: "fas fa-coins", to: "/slot" },
                                { k: "sport", ic: "fas fa-futbol", to: "/sport" },
                                { k: "fishing", ic: "fas fa-fish", to: "/fishing" },
                                { k: "card_game", ic: "fas fa-clone", to: "/cardminigame" },
                                { k: "lotto", ic: "fas fa-ticket-alt", to: "/lotto" }
                            ].map((c) => (
                                <a
                                    key={c.k}
                                    role="button"
                                    className="bwufa-gcard"
                                    onClick={(e) => { this.checkurl(e, c.to); }}
                                >
                                    <span className="bwufa-gcard-ic"><i className={c.ic} /></span>
                                    <span className="bwufa-gcard-tx">{t(this.lang, c.k)}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className="wrapper-c" style={{ display: !this.state.loginstate ? "none" : "" }}>
                        <div className="tt_l tt_full p_member" style={{ display: tabselect == 0 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'login')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg_tr">
                                <div className="tt_l tt_full">
                                    <div className="tt_l tt_full">
                                        {/*- if not login-*/}
                                        <div
                                            className="tt_l tt_full fr_login fr_login_form"
                                            id="fr_login_form"
                                            style={{ display: "none" }}
                                        >
                                            <div className="fr_center">
                                                <style
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            '\n  #btn-linelogin:before {\n    position: absolute;\n    font-family: "Font Awesome 5 Brands";\n    content: "\\f3c0";\n    margin-left: -41px;\n    font-size: 36px;\n    top: -4px;\n}\n  \n.btn-success-line {\n      display: inline-block;\n    font-weight: 400;\n    color: #212529;\n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid transparent;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: .25rem;\n    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    height: 48px;\n    background-color: #00b900;\n    border-color: #00b900;\n  border-radius: 5px;\n      padding-left: 47px;\n  cursor: pointer;\n  margin-top: .25rem!important;\n  display: block;\n    width: 100%;\n color: #fff;\n  position: relative;\n}\n  \n  #linelogin-c {\n    display: block;\n    position: relative;\n    height: 50px;\n}\n  \n  #linelogin-c:before {\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 50%;\n    border-top: 1px solid #151515;\n}\n  \n  #linelogin-c::after {\n    text-align: center!important;\n    font-size: 18px;\n    content: "หรือ";\n    position: absolute;\n    width: 80px;\n    left: calc(50% - 40px);\n    height: 100%;\n    line-height: 300%;   \n    background-color: white;\n}\n  \n'
                                                    }}
                                                />
                                                <a
                                                    style={{ displayxx: "none", paddingTop: 10 }}
                                                    className="  btn-success-line "
                                                    type="button"
                                                    id="btn-linelogin"
                                                >
                                                    {t(this.lang,'ufa_login_with_line')}
                                                </a>
                                                <div style={{ displaxx: "none" }} id="linelogin-c" />
                                                <form
                                                    id="loginform"
                                                    className=""
                                                    method="POST"
                                                >
                                                    <div className="tt_l fr_input">
                                                        <input
                                                            id="phone"
                                                            className="form-control tt_fr"
                                                            maxLength={10}
                                                            name="phone"
                                                            type="text"
                                                            placeholder={t(this.lang,'ufa_phone_placeholder_full')}
                                                        />
                                                        <input
                                                            id="password"
                                                            className="form-control tt_fr"
                                                            maxLength={24}
                                                            name="password"
                                                            type="password"
                                                            placeholder={t(this.lang,'ufa_password_placeholder')}
                                                        />
                                                    </div>
                                                    <input type="hidden" name="task" defaultValue="login" />
                                                    <button className="tt_r fr_submit" type="submit">
                                                        <i className="fas fa-sign-in-alt" /> {t(this.lang,'login')}
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                        <link
                                            href="/wp-content/themes/UFAC4.COM/css/icon.min.css"
                                            rel="stylesheet"
                                            type="text/css"
                                        />
                                        <div
                                            className="tt_l tt_full fr_login center"
                                            id="fr_login_user_form"
                                            style={{}}
                                        >
                                            <div className="fr_uc">
                                                <span className="tt_l tt_full fr_tx_u">
                                                    {t(this.lang,'ufa_your_member_id')}: <span id="user_">{usercheck}</span> (
                                                    <span className="amount">0</span>)
                                                </span>{" "}
                                            </div>
                                            <div className="tt_l tt_full fr_name">
                                                {t(this.lang,'ufa_hello')} <span id="user">{this.state.username}</span>
                                            </div>
                                            <section className="credit">
                                                <div className="credit-box">
                                                    <div className="amount-box float-left">
                                                        <small>{t(this.lang,'ufa_your_credit_balance')}</small>
                                                        <p className="amount">{balance}</p>
                                                    </div>
                                                    <div className="button-box float-left">
                                                        <a
                                                            onClick={(e) => {
                                                                this.checkurl(e, "/deposit");
                                                            }}
                                                            className="btn-block btn-gold"
                                                        >
                                                            <i className="fas fa-wallet" /> {t(this.lang,'deposit')}
                                                        </a>
                                                        <a
                                                            onClick={(e) => {
                                                                this.checkurl(e, "/withdraw");
                                                            }}
                                                            className="btn-block btn-silver"
                                                        >
                                                            <i className="fas fa-hand-holding-usd" /> {t(this.lang,'withdraw')}
                                                        </a>
                                                    </div>
                                                </div>
                                            </section>
                                            <section className="navigation">
                                                <div className="nav-other-button">
                                                    <div className="other-list other-list-1">
                                                        <a
                                                            role="button" onClick={(e) => {
                                                                this.checkurl(e, "/profile")
                                                            }}
                                                            className="btn-dark-tri hvr-buzz-out"
                                                        >
                                                            <i className="fas fa-user" />
                                                            <p>{t(this.lang,'account_info')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-2">
                                                        <a
                                                            role="button" onClick={(e) => {
                                                                this.checkurl(e, "/history")
                                                            }}
                                                            className="btn-dark-tri hvr-buzz-out"
                                                        >
                                                            <i className="fas fa-list-alt" />
                                                            <p>{t(this.lang,'ufa_finance_history')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-1">
                                                        <a
                                                            role="button" onClick={(e) => {
                                                                this.checkurl(e, "/affiliate")
                                                            }}
                                                            className="btn-dark-tri hvr-buzz-out"
                                                        >
                                                            <i className="fas fa-users" />
                                                            <p>{t(this.lang,'affiliate')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-2">
                                                        <a
                                                            role="button" onClick={(e) => {
                                                                this.checkurl(e, "/rank")
                                                            }}
                                                            className="btn-dark-tri hvr-buzz-out"
                                                        >
                                                            <i className="fas fa-crown" />
                                                            <p>{t(this.lang,'ufa_rank_system')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-1">
                                                        <a
                                                            role="button" onClick={(e) => {
                                                                this.checkurl(e, "/opencard")
                                                            }}
                                                            className="btn-dark-tri hvr-buzz-out"
                                                        >
                                                            <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/card.png" />
                                                            <p>{t(this.lang,'ufa_open_card_fortune')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-2">
                                                        <a
                                                            role="button" onClick={(e) => {
                                                                this.checkurl(e, "/weeklychallenge")
                                                            }}
                                                            className="btn-dark-tri hvr-buzz-out"
                                                        >
                                                            <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/wheel_back2-edit.png" />
                                                            <i className="fas fa-tire" />
                                                            <p>{t(this.lang,'ufa_spin_fortune_wheel')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-1">
                                                        <a className="btn-dark-tri hvr-buzz-out" role="button" onClick={(e) => {
                                                            this.checkurl(e, "/coupon")
                                                        }}>
                                                            <img loading="lazy" src="https://s3.newworld.center/image/5713cfc7-7a20-4002-974f-3e529851901c.webp" style={{ width: 40, filter: "brightness(0) invert(1)" }} />
                                                            <p>{t(this.lang,'ufa_coupon')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-2">
                                                        <a className="btn-dark-tri hvr-buzz-out" role="button" onClick={(e) => {
                                                            this.checkurl(e, "/checkinrule")
                                                        }}>
                                                            <img loading="lazy" src="https://s3.newworld.center/image/d32ae65b-e617-4248-b638-f5dae58f828c.webp" style={{ width: 40, filter: "brightness(0) invert(1)" }} />
                                                            <p>{t(this.lang,'checkin_btn')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-3">
                                                        <a
                                                            role="button" onClick={(e) => {
                                                                this.checkurl(e, "/loss")
                                                            }}
                                                            className="btn-dark-tri hvr-buzz-out"
                                                        >
                                                            <i className="fas fa-donate" />
                                                            <p> {t(this.lang,'ufa_get_cashback_credit')}</p>
                                                        </a>
                                                    </div>
                                                    <div className="other-list other-list-4">
                                                        <a
                                                            href={this.state.linelink}
                                                            target="_blank"
                                                            className="btn-dark-tri hvr-buzz-out"
                                                        >
                                                            <i className="fab fa-line" />
                                                            <p>{t(this.lang,'ufa_contact_staff')}</p>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="nav-play-button hvr-buzz-out ">
                                                    <div className="btn-block play-button hvr-buzz-out">
                                                        {/* <p> ทางเข้าเล่น UFA11</p> */}
                                                        {/* <form method="post" action="https://www.time899.com/HomeSmart.aspx?lang=EN-GB" id="form1" target="_blank" > */}
                                                        <button
                                                            onClick={(e) => this.redeem(e, "sport", "uefa")}
                                                            className="tt_l tt_ful fr_submit_bk ufa_link"
                                                            type="submit"
                                                        >
                                                            {t(this.lang,'ufa_play_entrance')}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="nav-play-button hvr-buzz-out ">
                                                    <div className="btn-block play-button hvr-buzz-out">
                                                        {/* <p> ทางเข้าเล่น UFA11</p> */}
                                                        {/* <form method="post" action="https://www.usa2468.com/HomeSmart.aspx?lang=EN-GB" id="form1" target="_blank" > */}
                                                        <button
                                                            onClick={(e) => this.redeem(e, "sport", "uefa")}
                                                            className="tt_l tt_ful fr_submit_bk ufa_link"
                                                            type="submit"
                                                        >
                                                            {t(this.lang,'ufa_play_entrance')}({t(this.lang,'ufa_backup')} 1)
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="nav-play-button hvr-buzz-out ">
                                                    <div className="btn-block play-button hvr-buzz-out">
                                                        {/* <p> เล่นเดียวนี้ ( สำรอง 1)</p> */}
                                                        {/* <form method="post" action="https://www.ugames88.com/HomeSmart.aspx?lang=EN-GB" id="form1" target="_blank" > */}
                                                        <button
                                                            onClick={(e) => this.redeem(e, "sport", "uefa")}
                                                            className="tt_l tt_ful fr_submit_bk ufa_link"
                                                            type="submit"
                                                        >
                                                            {t(this.lang,'ufa_play_entrance')}({t(this.lang,'ufa_backup')} 2)
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* <div
                                                id="line_lg_"
                                                style={{ background: "rgb(0, 185, 0)" }}
                                                className="tt_l tt_full b_link_game  hvr-buzz buzz"
                                            >
                                                <a
                                                    id="line_lgxx"
                                                    href="./../line.me/login_uselib.php?token_=415189&token_2=0639516267AAA"
                                                    className="u-btn btn-play btn-block hvr-buzz"
                                                >
                                                    <i className="fab fa-line" /> เชื่อมต่อบัญชี LINE LOGIN
                                                </a>
                                            </div> */}
                                                <div className="tt_l tt_full b_logout_game">
                                                    <a
                                                        href="/logout"
                                                        className="u-btn btn-play btn-block hvr-buzz"
                                                    >
                                                        <i className="fas fa-power-off" />
                                                        <span> {t(this.lang,'logout')}</span>
                                                    </a>
                                                </div>
                                                <div className="clear" />
                                                <div className="promo-box tt_l tt_full fr_login center">
                                                    <img loading="lazy"
                                                        src="/build/web/igame-index-lobby-wm/img/ดาวน์โหลด.jpg"
                                                        className="pro-title"
                                                        width="100%"
                                                    />
                                                    <br />
                                                    <br />
                                                    <Promotion />
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect == 8 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'account_info')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="tt_l tt_full">
                                    <div className="tt_l tt_full">
                                        <div className="thaitheme_read"></div>
                                        <div className="thaitheme_read"></div>
                                        <div className="wrapper-m">
                                            <div className="tt_l tt_full from_acc" style={{ display: "" }}>
                                                <div className="fr_center">
                                                    {/* <div class="tt_l tt_full fr_tx1"><strong>User : </strong><span id="user"></span></div> */}
                                                    <div className="tt_l tt_full fr_tx1">
                                                        <strong>{t(this.lang,'account_number')} : </strong>
                                                        <span id="account">{this.state.username}</span>
                                                    </div>
                                                    <div className="tt_l tt_full fr_tx1">
                                                        <strong>{t(this.lang,'ufa_game_user')} : </strong>
                                                        <span id="user_">{usercheck}</span>
                                                    </div>
                                                    {/* <div className="tt_l tt_full fr_tx1">
                                                    <strong>Password เข้าเกมส์ : </strong>
                                                    <span id="password_">AbX299942</span>
                                                </div> */}
                                                    <div className="tt_l tt_full fr_tx1">
                                                        <strong>{t(this.lang,'phone_number')} : </strong>
                                                        <span id="user">{this.state.username}</span>
                                                    </div>
                                                    <div className="tt_l tt_full fr_tx1">
                                                        <strong>{t(this.lang,'ufa_balance_remaining')} : </strong>
                                                        <span id="amount">{balance}</span>
                                                    </div>
                                                </div>
                                                <div className="tt_l tt_full fr_li1x">
                                                    <span className="tt_l fr_uptx">
                                                        {" "}
                                                        update Password :{" "}
                                                    </span>
                                                    <input
                                                        className="form-control tt_bkb  "
                                                        name="password2"
                                                        id="password2"
                                                        type="text"
                                                    />
                                                    <button
                                                        type="button"

                                                        className="btn pass_b fr_submit_bk  "
                                                        data-clipboard-text="Ssddle123"
                                                    >
                                                        Update
                                                    </button>
                                                    <div className="tt_l tt_full tx_sm">
                                                        <small>
                                                            {t(this.lang,'ufa_pwd_hint_1')}
                                                            <br />
                                                            {t(this.lang,'ufa_pwd_hint_2')}
                                                            <br />
                                                            {t(this.lang,'ufa_pwd_hint_3')}
                                                        </small>
                                                    </div>
                                                    {/* <div class="tt_l tt_ful fr_submit_bk2">เล่นเดียวนี้</div> */}
                                                    {/* <form method="post" action="https://www.usa2468.com/HomeSmart.aspx?lang=EN-GB" id="form1" target="_blank" > */}


                                                    <button onClick={(e) => this.redeem(e, "sport", "uefa")} className="tt_l tt_ful fr_submit_bk2" type="submit">
                                                        {t(this.lang,'ufa_play_now')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect == 3 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'account_info')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="tt_l tt_full">
                                    <div className="tt_l tt_full">
                                        <div className="thaitheme_read"></div>
                                        <div className="thaitheme_read">
                                            <style
                                                type="text/css"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        "\n\t\t.page_ {\n\t\t\tmargin-right: 10px;\n\t\t}\n\t\t.page_ a {\n\t\t\tmargin: 5px;\n\t\t\tfont-size: 20px;\n\t\t\tfont-weight: bold;\n\t\t}\n\t"
                                                }}
                                            />
                                            <div className="page_" style={{ textAlign: "right" }}></div>
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        "\n\t\t.statements , .statements  th  , .statements  td {\n\t\t\tborder-spacing: 0px !important; \n\t\t\tborder: 1px solid !important;\n\t\t\tborder-collapse: collapse !important; \n\t\t}\n\t"
                                                }}
                                            />
                                            <table style={{ width: "100%" }} className="statements">
                                                <tbody>

                                                    {/* ฝากเงิน */}
                                                    <tr>
                                                        <th>Datetime</th>
                                                        <th>Deposit</th>
                                                        <th>Detail</th>
                                                        <th>Status</th>
                                                    </tr>

                                                    <tr style={{ textAlign: "center" }}>
                                                        <td>{t(this.lang,'ufa_total_all')}</td>
                                                        <td>
                                                            {
                                                                this.state.historylist
                                                                    ?.filter((x) => x.type === "DE")
                                                                    ?.reduce((sum, item) => sum + Number(item.amount || 0), 0)
                                                                    ?.toLocaleString()
                                                            }
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>

                                                    {
                                                        this.state.historylist
                                                            ?.filter((x) => x.type === "DE")
                                                            ?.map((listitem, i) => (
                                                                <tr key={`de_${i}`} style={{ textAlign: "center" }}>
                                                                    <td>
                                                                        {moment(listitem.createdate).format("DD/MM/YYYY HH:mm")}
                                                                    </td>

                                                                    <td className="text-success">
                                                                        + {Number(listitem.amount || 0).toLocaleString()}
                                                                    </td>

                                                                    <td>
                                                                        {t(this.lang,'deposit')}
                                                                    </td>

                                                                    <td>
                                                                        {
                                                                            listitem.status === "1"
                                                                                ? t(this.lang,'status_approve')
                                                                                : listitem.status === "0"
                                                                                    ? t(this.lang,'status_pending')
                                                                                    : listitem.status === "2"
                                                                                        ? t(this.lang,'ufa_processing')
                                                                                        : listitem.status === "4"
                                                                                            ? t(this.lang,'cancel')
                                                                                            : t(this.lang,'ufa_failed')
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))
                                                    }

                                                    {/* โบนัส */}
                                                    <tr>
                                                        <th colSpan={4}> {t(this.lang,'ufa_item')} {t(this.lang,'bonus_type')} </th>
                                                    </tr>

                                                    <tr>
                                                        <th>Datetime</th>
                                                        <th>Amount</th>
                                                        <th colSpan={2}>{t(this.lang,'ufa_item')}</th>
                                                    </tr>

                                                    {
                                                        this.state.historylist
                                                            ?.filter((x) => x.type === "BN")
                                                            ?.map((listitem, i) => (
                                                                <tr key={`bn_${i}`} style={{ textAlign: "center" }}>
                                                                    <td>
                                                                        {moment(listitem.createdate).format("DD/MM/YYYY HH:mm")}
                                                                    </td>

                                                                    <td className="text-success">
                                                                        + {Number(listitem.amount || 0).toLocaleString()}
                                                                    </td>

                                                                    <td colSpan={2}>
                                                                        {t(this.lang,'bonus_type')}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                    }

                                                    {/* ถอน */}
                                                    <tr>
                                                        <th colSpan={4}> {t(this.lang,'ufa_item')} {t(this.lang,'withdraw')} </th>
                                                    </tr>

                                                    <tr>
                                                        <th>Datetime</th>
                                                        <th>Amount</th>
                                                        <th colSpan={2}>{t(this.lang,'ufa_item')}</th>
                                                    </tr>

                                                    {
                                                        this.state.historylist
                                                            ?.filter((x) => x.type === "WD")
                                                            ?.map((listitem, i) => (
                                                                <tr key={`wd_${i}`} style={{ textAlign: "center" }}>
                                                                    <td>
                                                                        {moment(listitem.createdate).format("DD/MM/YYYY HH:mm")}
                                                                    </td>

                                                                    <td className="text-danger">
                                                                        - {Number(listitem.amount || 0).toLocaleString()}
                                                                    </td>

                                                                    <td colSpan={2}>
                                                                        {t(this.lang,'withdraw')}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                    }

                                                    {/* คืนเครดิต */}
                                                    <tr>
                                                        <th colSpan={4}> {t(this.lang,'ufa_item')} {t(this.lang,'ufa_credit_refund')} </th>
                                                    </tr>

                                                    <tr>
                                                        <th>Datetime</th>
                                                        <th>Amount</th>
                                                        <th colSpan={2}>Member</th>
                                                    </tr>

                                                    {
                                                        this.state.historyrefund?.map((listitem, i) => (
                                                            <tr key={`refund_${i}`} style={{ textAlign: "center" }}>
                                                                <td>
                                                                    {moment(listitem.createdate).format("DD/MM/YYYY HH:mm")}
                                                                </td>

                                                                <td className="text-success">
                                                                    + {Number(listitem.amount || 0).toLocaleString()}
                                                                </td>

                                                                <td colSpan={2}>
                                                                    {listitem.member || "-"}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }

                                                    {/* แนะนำเพื่อน */}
                                                    <tr>
                                                        <th colSpan={4}> {t(this.lang,'ufa_item')} {t(this.lang,'affiliate')} </th>
                                                    </tr>

                                                    <tr>
                                                        <th>Datetime</th>
                                                        <th>Amount</th>
                                                        <th colSpan={2}>Member</th>
                                                    </tr>

                                                    {
                                                        this.state.historyaffiliate?.map((listitem, i) => (
                                                            <tr key={`aff_${i}`} style={{ textAlign: "center" }}>
                                                                <td>
                                                                    {moment(listitem.createdate).format("DD/MM/YYYY HH:mm")}
                                                                </td>

                                                                <td className="text-success">
                                                                    + {Number(listitem.amount || 0).toLocaleString()}
                                                                </td>

                                                                <td colSpan={2}>
                                                                    {listitem.member || "-"}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="wrapper-m">
                                            <div className="tt_l tt_full from_acc" style={{ display: "none" }}>
                                                <div className="fr_center">
                                                    {/* <div class="tt_l tt_full fr_tx1"><strong>User : </strong><span id="user"></span></div> */}
                                                    <div className="tt_l tt_full fr_tx1">
                                                        <strong>{t(this.lang,'account_number')} : </strong>
                                                        <span id="account">{this.state.username}</span>
                                                    </div>
                                                    <div className="tt_l tt_full fr_tx1">
                                                        <strong>{t(this.lang,'ufa_game_user')} : </strong>
                                                        <span id="user_">{usercheck}</span>
                                                    </div>
                                                    <div className="tt_l tt_full fr_tx1">
                                                        <strong>{t(this.lang,'phone_number')} : </strong>
                                                        <span id="user">{this.state.username}</span>
                                                    </div>
                                                    <div className="tt_l tt_full fr_tx1">
                                                        <strong>{t(this.lang,'ufa_balance_remaining')} : </strong>
                                                        <span id="amount">{balance}</span>
                                                    </div>
                                                </div>
                                                <div className="tt_l tt_full fr_li1x">
                                                    <span className="tt_l fr_uptx">
                                                        {" "}
                                                        {t(this.lang,'ufa_update_pwd_ufa')}{" "}
                                                    </span>
                                                    <input
                                                        className="form-control tt_bkb  "
                                                        name="password2"
                                                        id="password2"
                                                        type="text"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn pass_b fr_submit_bk  "
                                                        data-clipboard-text="Ssddle123"
                                                    >
                                                        Update
                                                    </button>
                                                    <div className="tt_l tt_full tx_sm">
                                                        <small>
                                                            {t(this.lang,'ufa_pwd_hint_1')}
                                                            <br />
                                                            {t(this.lang,'ufa_pwd_hint_2')}
                                                            <br />
                                                            {t(this.lang,'ufa_pwd_hint_3')}
                                                        </small>
                                                    </div>
                                                    {/* <div class="tt_l tt_ful fr_submit_bk2">เล่นเดียวนี้</div> */}
                                                    {/* <form method="post" action="https://www.usa2468.com/HomeSmart.aspx?lang=EN-GB" id="form1" target="_blank" > */}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect == 4 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>affiliate</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="tt_l tt_full body_c">
                                    <div className="tt_l tt_full">
                                        <div className="thaitheme_read"></div>
                                        <div className="thaitheme_read" style={{}}>
                                            <h1 className="entry-title">
                                                <span className="icon-bar" />
                                                {t(this.lang,'u5_invite_h1_pre')} {this.state.inviteSet?.depositpercent || "0.6"}{t(this.lang,'u5_invite_h1_post')}
                                            </h1>
                                            <div
                                                className="card-header-info"
                                                style={{
                                                    background: "#479988",
                                                    padding: "0px 10px 0px 10px",
                                                    color: "white"
                                                }}
                                            >
                                                {t(this.lang,'u5_invite_update_pre')}  {this.state.inviteSet?.depositpercent || "0.6"}{t(this.lang,'u5_invite_update_post')} <br />
                                                {t(this.lang,'u5_invite_update_time')}
                                            </div>
                                            <div
                                                id="linkaff_"
                                                style={{ display: "none" }}
                                                className="form-control tt_fr aff"
                                            >
                                                {linkaff}
                                            </div>
                                            <div className="tt_l tt_full fr_sec">
                                                <label className="tt_l fr_tx2x">{t(this.lang,'ufa_referral_link_label')}</label>
                                                <input
                                                    className="form-control tt_bk aff"
                                                    readOnly
                                                    name="link1777877617"
                                                    value={linkaff}
                                                />
                                            </div>
                                            {/* <div class="tt_l tt_full fr_sec2c">(Click ลิงค์ 0 ครั้ง)</div> */}
                                            <a
                                                href="#"
                                                onClick={(e) => { e.preventDefault(); this.copyCode(linkaff); }}
                                                style={{ cursor: "pointer" }}
                                                className="btn btn-block btn-dark-green btn- lg btn-copy ml-0"
                                            >
                                                <i className="far fa-copy" /> {t(this.lang,'ufa_copy_link')}
                                            </a>
                                            <div className="tt_l tt_full fr_sec">
                                                <label className="tt_l fr_tx2x">{t(this.lang,'ufa_referred_friends_count')}</label>
                                                <span
                                                    className="form-control tt_bk aff_c tt_l fr_tx2x"
                                                    style={{ width: "70%", background: "none", border: "none" }}
                                                    readOnly=""
                                                >
                                                    {this.state.stats.totalSignups || 0}
                                                </span>
                                            </div>
                                            <div className="tt_l tt_full fr_sec">
                                                <label className="tt_l fr_tx2x">{t(this.lang,'ufa_referral_credit_count')}</label>
                                                <input
                                                    className="form-control tt_bk tt_l fr_tx2x aff_am "
                                                    style={{ width: "70%", background: "none", border: "none" }}
                                                    readOnly
                                                    value={(tblprofile.AffiliateCash && tblprofile.AffiliateCash > 0)
                                                        ? tblprofile.AffiliateCash
                                                        : 0}
                                                />
                                            </div>
                                            <div className=" ">
                                                <a onClick={(e) => {
                                                    this.opencliaminvite(e, 'bonusrankaccount')
                                                }}
                                                    className="tt_l tt_ful fr_submit_bk btn-copy"
                                                >
                                                    {t(this.lang,'ufa_transfer_to_credit')}
                                                </a>
                                                {/* <div class="tt_l tt_full fr_tx1" style="color: red;"> ขณะนี้ เครดิตเงินคืน และ เครดิตแนะนำเพื่อน ยังไม่สามารถกดรับได้ในขณะนี้ รบกวนทำรายการใหม่หลังวันที่ 12/11/2023 นะคะ</div> */}
                                                <div className="tt_l tt_full fr_tx1">
                                                    {" "}
                                                    {t(this.lang,'ufa_min_500_transfer')}
                                                </div>
                                            </div>
                                            <br />
                                            {/* getaff */}
                                            <link
                                                rel="stylesheet"
                                                type="text/css"
                                                href="../css/tablemain.css?v=1"
                                            />
                                            <div style={{ xdisplay: "none" }} className="tt_l tt_full fr_tx1">
                                                <style
                                                    type="text/css"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            "\n\t\t\t  .table100.ver1 th {\n\t\t\t    font-size: 13px;\n\n\t\t\t}\n\t\t\t.table100-body td {\n\t\t\t    padding-top: 1px;\n\t\t\t    padding-bottom: 1px;\n\t\t\t}\n\n\t\t\t"
                                                    }}
                                                />
                                                <div
                                                    className="table100 ver1 m-b-110"
                                                    style={{ margin: "auto", width: "90%", paddingTop: 5 }}
                                                >
                                                    <div
                                                        className="table100-body js-pscroll ps ps--active-y"
                                                        stylex="display: none;"
                                                    >
                                                        <table>
                                                            <tbody id="memaff">
                                                                <tr className="row100 body">
                                                                    <td
                                                                        className="cell100 column2x"
                                                                        style={{ textAlign: "center" }}
                                                                    >
                                                                        User
                                                                    </td>
                                                                    <td
                                                                        className="cell100 column1x"
                                                                        style={{ textAlign: "center" }}
                                                                    >
                                                                        {t(this.lang,'ufa_your_income')}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <input type="hidden" name="task" defaultValue="aff_to" />
                                                <div style={{ fontSize: 20, textAlign: "center", display: "none" }}>
                                                    {t(this.lang,'u5_invite_sys_pre')}{" "}
                                                    <span
                                                        style={{ color: "green", fontWeight: "bold", fontSize: 20 }}
                                                    >
                                                        20%
                                                    </span>{" "}
                                                    {t(this.lang,'u5_invite_sys_max')}{" "}
                                                    <span style={{ color: "red", fontWeight: "bold", fontSize: 20 }}>
                                                        200
                                                    </span>{" "}
                                                    {t(this.lang,'u5_invite_sys_baht')}
                                                    <br />
                                                    <span style={{ color: "red", fontWeight: "bold", fontSize: 20 }}>
                                                        {t(this.lang,'u5_invite_sys_note')}
                                                    </span>
                                                    <br />
                                                    <br />
                                                    <span style={{ color: "red", fontWeight: "bold", fontSize: 12 }}>
                                                        {t(this.lang,'u5_invite_sys_warn')}
                                                    </span>
                                                </div>
                                                <table style={{ width: "100%", border: "none" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                className="tt_l tt_full fr_tx1"
                                                                style={{ width: "33%", colzozr: "white", border: "none" }}
                                                            >
                                                                <center>
                                                                    <a
                                                                        className="afflink1"
                                                                        onClick={(e) => {
                                                                            this.checkurl(e, "/login")
                                                                        }}
                                                                        style={{ textDecoration: "none", colssor: "white" }}
                                                                        target="b_"
                                                                    >
                                                                        <img loading="lazy"
                                                                            src="/build/web/igame-index-lobby-wm/img/line-icon.png?w=280&ssl=1"
                                                                            style={{ maxWidth: "80%", width: 100 }}
                                                                        />
                                                                        <br />
                                                                        {t(this.lang,'ufa_share_via_line')}
                                                                    </a>
                                                                </center>
                                                            </td>
                                                            <td
                                                                className="tt_l tt_full fr_tx1"
                                                                style={{ width: "33%", cozlozr: "white", border: "none" }}
                                                            >
                                                                <center>
                                                                    <a
                                                                        className="afflink2"
                                                                        href="fb-messenger://share/?link=https://www.UFA11.com/register.php?aff=NDE1MTg5XzQxNTE4OQ=="
                                                                        style={{ textDecoration: "none", cossslor: "white" }}
                                                                        target="b_"
                                                                    >
                                                                        <img loading="lazy"
                                                                            src="/build/web/igame-index-lobby-wm/img/facebook-messenger-icon.png"
                                                                            style={{ maxWidth: "80%", width: 100 }}
                                                                        />
                                                                        <br />
                                                                        {t(this.lang,'ufa_share_via_messenger')}
                                                                    </a>
                                                                </center>
                                                            </td>
                                                            <td
                                                                className="tt_l tt_full fr_tx1"
                                                                style={{ width: "33%", colzzor: "white", border: "none" }}
                                                            >
                                                                <center>
                                                                    <a
                                                                        className="afflink3"
                                                                        href="https://www.facebook.com/sharer/sharer.php?u=https://www.UFA11.com/register?aff=NDE1MTg5XzQxNTE4OQ=="
                                                                        style={{ textDecoration: "none", colossr: "white" }}
                                                                        target="b_"
                                                                    >
                                                                        <img loading="lazy"
                                                                            src="/build/web/igame-index-lobby-wm/img/facebook_circle-512.png"
                                                                            style={{ maxWidth: "80%", width: 100 }}
                                                                        />
                                                                        <br />
                                                                        {t(this.lang,'ufa_share_via_facebook')}
                                                                    </a>
                                                                </center>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <center>
                                                    <img loading="lazy"
                                                        className="aligncenter wp-image-9796 size-full"
                                                        src="https://s3.newworld.center/image/70b7438c-7b39-48d9-8438-7380bad94802.webp"
                                                        alt={t(this.lang,'u5_inv2_alt')}
                                                        width={1080}
                                                        height={1080}
                                                    />
                                                    <p className="tt_l tt_full fr_tx1">
                                                        <b className="tt_l tt_full fr_tx1">
                                                            {t(this.lang,'u5_inv2_share_pre')} <span style={{ color: "" }}>{this.state.inviteSet?.depositpercent || "0.6"}%</span> {t(this.lang,'u5_inv2_share_post')}
                                                        </b>{" "}
                                                        {t(this.lang,'u5_inv2_share2')}
                                                        <br />
                                                        <br />
                                                        {t(this.lang,'u5_inv2_p1_pre')} {this.state.inviteSet?.depositpercent || "0.6"}%
                                                        {t(this.lang,'u5_inv2_p1_post')}
                                                        <br />
                                                        <br />
                                                        <u>{t(this.lang,'u5_inv2_eg')}</u>
                                                        {t(this.lang,'u5_inv2_eg_pre')} {(1000 * (Number(this.state.inviteSet?.depositpercent) || 0) / 100).toLocaleString(undefined, { maximumFractionDigits: 2 })} {t(this.lang,'u5_inv2_eg_post')}
                                                        <br />
                                                        {t(this.lang,'u5_inv2_month_pre')} {this.state.inviteSet?.depositpercent || "0.6"}{t(this.lang,'u5_inv2_month_mid')} {(24160 * (Number(this.state.inviteSet?.depositpercent) || 0) / 100).toLocaleString(undefined, { maximumFractionDigits: 2 })} {t(this.lang,'u5_inv2_month_post')}
                                                        <br />
                                                        {t(this.lang,'u5_inv2_concl')}
                                                    </p>
                                                </center>
                                                {/* <p><b style="font-size: 22px;">ลิ้งค์ช่วยแชร์รับ <span style="color: red;font-size: 22px;">%  </span>  ฟรี </b> (แค่ก๊อปปี้ลิ้งค์ไปแชร์ก็ได้เงินแล้ว) ยิ่งแชร์มากยิ่งได้มาก<br><br>
                              ท่านสามารถนำลิ้งค์ด้านล่างนี้หรือนำป้ายแบนเนอร์ ไปแชร์ในช่องทางต่างๆ ไม่ว่าจะเป็น เว็บไชต์ส่วนตัว, Blog, Facebook หรือ Social Network อื่นๆ หากมีการสมัครสมาชิกโดยคลิกผ่านลิ้งค์ของท่านเข้ามา ลูกค้าที่สมัครเข้ามาก็จะอยู่ภายให้เครือข่ายของท่านทันที และหากลูกค้าภายใต้เครือข่ายของท่านมีการเดิมพันเข้ามา ทุกยอดการเดิมพัน ท่านจะได้รับส่วนแบ่งในการแนะนำ 0% ทันทีโดยไม่มีเงื่อนไข */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full tt_content bg" style={{ display: tabselect == 25 ? "" : "none" }}>
                            <div className="tt_l tt_lcxxx">
                                <div className="tt_l tt_full title_page">
                                    <h1>{t(this.lang,'ufa_get_cashback_credit')}</h1>
                                </div>
                                <div className="tt_l tt_full">
                                    <div className="thaitheme_read" style={{ display: "none" }}></div>
                                    <div className="tt_l tt_full">
                                        <div
                                            className="tt_l tt_full fr_login fr_aff"
                                            style={{ d_isplay: "none" }}
                                        >
                                            <div className="fr_center">
                                                <div className="tt_l tt_full fr_h1">
                                                    {t(this.lang,'u5_cb_free')}
                                                </div>
                                                {/*
<div class="tt_l tt_full fr_tx1">User : <span id="user"></span></div> */}
                                                <div className="tt_l tt_full fr_tx1">
                                                    {t(this.lang,'ufa_cashback_amount')} :{" "}
                                                    <span className="amount_return" id="amount_return">
                                                        {(tblprofile != null) ? tblprofile.Cashtotal : 0}
                                                    </span>{" "}
                                                    {t(this.lang,'baht')}{" "}
                                                </div>
                                                {/* <div class="tt_l tt_full fr_tx1" style="    font-family: 'Prompt',sans-serif; ">ท่านจะได้รับ <span class="aff_val"></span> % ของยอดฝากครั้งแรก<br>จากผู้ที่สมัครผ่าน Link ของท่าน </div>
             */}
                                                <center>
                                                    <p className="tt_l tt_full fr_tx1">
                                                        <b className="tt_l tt_full fr_tx1">
                                                            {t(this.lang,'u5_cb_time_pre')}
                                                            <span style={{ color: "" }}> 13.00น.</span> {t(this.lang,'u5_cb_time_post')}
                                                        </b>{" "}
                                                        <br />
                                                        <br />
                                                    </p>
                                                </center>
                                                <center>
                                                    <p className="tt_l tt_full fr_tx1">
                                                        <b className="tt_l tt_full fr_tx1">
                                                            {t(this.lang,'u5_cb_back_pre')} <span style={{ color: "" }}>0.3%</span> {t(this.lang,'u5_cb_back_post')}
                                                        </b>
                                                        <strong className="thick">
                                                            <u>
                                                                {t(this.lang,'u5_cb_promo')}
                                                            </u>
                                                        </strong>
                                                        {t(this.lang,'u5_cb_easy')}{" "}
                                                        <b style={{ fontSize: 35 }}>
                                                            {t(this.lang,'u5_cb_get')}{" "}
                                                            <span style={{ color: "red", fontSize: 35 }}>0.3%</span> {t(this.lang,'u5_cb_now')}{" "}
                                                        </b>
                                                        {t(this.lang,'u5_cb_more')}
                                                        <br />
                                                    </p>
                                                </center>
                                                {/* <div class="tt_l tt_full fr_tx1">  <input type="text" class="form-control tt_fr aff" name="" value="" readonly="readonly"> </div>  */}
                                                <a
                                                    className="tt_l tt_ful fr_submit_bk"
                                                    role="button" onClick={(e) => {
                                                        this.opencliamcashout(e, 'bonusrankaccount', (tblprofile != null) ? tblprofile.Cashtotal : 0)
                                                    }}
                                                    id="return_rolling"
                                                >
                                                    {t(this.lang,'ufa_transfer_to_credit')}
                                                </a>
                                                {/* <div class="tt_l tt_full fr_tx1" style="color: red;"> ขณะนี้ เครดิตเงินคืน และ เครดิตแนะนำเพื่อน ยังไม่สามารถกดรับได้ในขณะนี้ รบกวนทำรายการใหม่หลังวันที่ 12/11/2023 นะคะ</div> */}
                                                <div className="tt_l tt_full fr_tx1">
                                                    {" "}
                                                    {t(this.lang,'ufa_min_15_transfer')}
                                                </div>
                                                {/* <div class="tt_l tt_full fr_tx3">ยอดแจ้งถอน : 9,999 บาท </div>
<div class="tt_l tt_full fr_tx4">แจ้งถอนเมื่อ :  19/11/2561 14:49 น.</div>
 */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect == 1 ? "" : "none" }}>
                            <div
                                className="tt_l tt_full tt_content bg"
                                style={{ borderRadius: "1rem !important" }}
                            >
                                <div className="tt_l tt_full body_c">
                                    <div className="dn-container">
                                        {/* Credit Section */}
                                        <section className="dn-credit" style={{ display: "none" }}>
                                            <div className="dn-credit-box">
                                                <div className="dn-amount-box">
                                                    <small>
                                                        {t(this.lang,'ufa_balance_baht')}
                                                        {/* <i class="fas fa-sync-alt dn-refresh" title="อัพเดทยอดเงิน" onclick="location.reload();"></i> */}
                                                    </small>
                                                    <p className="dn-amount">{balance}</p>
                                                </div>
                                                {/* <div class="dn-button-box"> */}
                                                {/* <a href="deposit" class="dn-btn-red"><i class="fas fa-wallet"></i> ฝากเงิน</a> */}
                                                {/* <a href="withdraw" class="dn-btn-silver"><i class="fas fa-hand-holding-usd"></i> ถอนเงิน</a> */}
                                                {/* </div> */}
                                            </div>
                                        </section>
                                        {/* Pending Deposit Warning */}
                                        <div id="pendingDepositWarning" style={{ display: "none" }}>
                                            <div className="dn-pending-warning">
                                                <div className="dn-pending-title">⚠️ {t(this.lang,'ufa_pending_deposit_title')}</div>
                                                <div className="dn-pending-message">
                                                    {t(this.lang,'ufa_finish_deposit_first')}
                                                </div>
                                                <div className="dn-pending-contact">
                                                    {t(this.lang,'ufa_need_help_contact_line')}{" "}
                                                    <a
                                                        href={this.state.linelink}
                                                        target="_blank"
                                                        style={{ color: "#ec325f", textDecoration: "underline" }}
                                                    >
                                                        @UFA11
                                                    </a>
                                                </div>
                                                <center>
                                                    <button
                                                        type="button"
                                                        id="dnContinueBtn"
                                                        className="dn-popup-submit"
                                                        style={{ marginTop: 15 }}
                                                    >
                                                        <i className="fas fa-arrow-right" style={{ marginRight: 8 }} />
                                                        {t(this.lang,'ufa_continue_transaction')}
                                                    </button>
                                                </center>
                                            </div>
                                        </div>
                                        {/* Create Deposit Button */}
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                this.openDepositAmountPopup(e);
                                            }}
                                            className="dn-create-btn"
                                            id="dnCreateBtn"
                                        >
                                            <i className="fas fa-plus" /> {t(this.lang,'ufa_create_new_deposit')}
                                        </button>
                                        {/* Hidden form for deposit submission */}
                                        <form
                                            id="depositForm"
                                            method="POST"
                                            onClick={(e) => {
                                                this.checkurl(e, "/deposit")
                                            }
                                            }
                                            style={{ display: "none" }}
                                        >
                                            <input
                                                type="hidden"
                                                name="amount"
                                                id="depositAmountInput"
                                                defaultValue=""
                                            />
                                        </form>
                                        {/* Bank Info Card */}
                                        <div className="dn-card">
                                            <div className="dn-card-header">
                                                {t(this.lang,'ufa_deposit_registered_only')}
                                            </div>
                                            <div className="dn-card-body">
                                                <div className="dn-bank-row">
                                                    <div
                                                        className="dn-bank-logo"
                                                        style={{ backgroundColor: "#4e2e7f" }}
                                                    >
                                                        <img loading="lazy"
                                                            src={accnumberx?.img_path || ""}
                                                            alt=""
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "contain",
                                                                padding: 10
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="dn-bank-info">
                                                        <p>
                                                            {t(this.lang,'bank_name')}:{" "}
                                                            <span className="banktype">
                                                                {t(this.lang,'bank_name')}   {accnumber !== null ? accnumberx.fullname_th : ""}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            {t(this.lang,'account_name')}: <span id="name_acc">{firstname}</span>
                                                        </p>
                                                        <p>
                                                            {t(this.lang,'account_number')}: <span id="account">     {accnumber
                                                                ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12)
                                                                : "No Account Number"}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="dn-alert-info">
                                                    {t(this.lang,'ufa_deposit_problem_contact')}
                                                    LINE ID:
                                                    <a href={this.state.linelink} target="_blank">
                                                        @UFA11
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        {/* History Link */}
                                        <section className="dn-history-link">
                                            <a role='button' onClick={(e) => {
                                                this.checkurl(e, "/history")
                                            }} >
                                                {t(this.lang,'ufa_view_deposit_history')} <i className="fas fa-list-alt" />
                                            </a>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect == 2 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'withdraw')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="tt_l tt_full">
                                    <div className="tt_l tt_full">
                                        <div className="tt_l tt_full body_c">
                                            <div className="mount-credit" style={{ width: "99%" }}>
                                                <a>
                                                    <div className="tt_l tt_full fr_nmtx">{t(this.lang,'available_balance')} </div>
                                                    <span className="number-h amount">{balance}</span> {t(this.lang,'credit')}
                                                </a>
                                            </div>
                                            {/* <div class="must-turn">
<a><div class="tt_l tt_full fr_nmtx"> ต้องมียอดเทริน </div><span class="number-h"> 0</span> เครดิต</a>
</div>
<div class="now-turn">
<a><div class="tt_l tt_full fr_nmtx"> ขณะนี้มียอดเทรินยอดเทริน </div><span class="number-h"> 0</span> เครดิต</a>
</div> */}
                                            <form id="withdform" className="tt_l tt_full fr_re" method="post">
                                                <div style={{ display: "none" }} id="amount">
                                                    0
                                                </div>
                                                <input
                                                    type="hidden"
                                                    name="member_id"
                                                    id="member_id"
                                                    defaultValue={415189}
                                                />
                                                <input type="hidden" name="task" defaultValue="withdraw" />
                                                <div className="tt_l tt_full fr_sec">
                                                    <div className="input-group">
                                                        <label className="tt_l fr_tx2x">{t(this.lang,'account_name')}</label>
                                                        <span
                                                            className="form-control tt_bk tt_l fr_tx2x "
                                                            id="name_acc"
                                                            style={{
                                                                width: "50%",
                                                                backgroundColor: "white",
                                                                border: "none"
                                                            }}
                                                            readOnly=""
                                                            type="text"
                                                        >
                                                            {firstname}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="tt_l tt_full fr_sec">
                                                    <div className="input-group">
                                                        <label className="tt_l fr_tx2x">{t(this.lang,'ufa_transfer_to_bank')}</label>
                                                        <span
                                                            className="form-control tt_bk tt_l fr_tx2x"
                                                            id="account"
                                                            style={{
                                                                width: "50%",
                                                                backgroundColor: "white",
                                                                border: "none"
                                                            }}
                                                            readOnly=""
                                                            name="bank"
                                                        >
                                                            {accnumber
                                                                ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12)
                                                                : "No Account Number"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="tt_l tt_full fr_sec">
                                                    <div className="input-group">
                                                        <label className="tt_l fr_tx2x">{t(this.lang,'ufa_amount')}</label>
                                                        <input
                                                            className="form-control tt_bk"
                                                            placeholder={t(this.lang,'ufa_withdraw_placeholder')}
                                                            maxLength={9}
                                                            id="withdraw_amount"
                                                            onChange={this.onChange}
                                                            name="withdrawamount"
                                                            value={this.state.withdrawamount}
                                                            required
                                                            type="text"
                                                            data-parsley-pattern="/^[0-9.]+$/"
                                                            data-parsley-errors-container="#checkbox-errors-amount"
                                                        />
                                                    </div>
                                                    <div id="checkbox-errors-amount" />
                                                </div>
                                                <div className="form-group">
                                                    <a
                                                        href="#"
                                                        onClick={(e) => { e.preventDefault(); this.submitwithdraw(e); }}
                                                        id="wd"
                                                        className="tt_l tt_ful fr_submit_bk"
                                                    >
                                                        <i className="fas fa-hand-holding-usd" /> {t(this.lang,'ufa_notify_withdraw')}
                                                    </a>
                                                    {/*<input type="submit" id="submit" class="btn btn-dark-green" value="แจ้งถอนเงิน">*/}
                                                </div>
                                                <div
                                                    className="depositList"
                                                    style={{
                                                        border: "2px solid #ce0000",
                                                        borderRadius: 5,
                                                        backgroundColor: "#ffdee4"
                                                    }}
                                                >
                                                    <div
                                                        className="w50"
                                                        style={{
                                                            fontSize: "clamp(15px, 1.5vw, 22px)",
                                                            fontWeight: "bold",
                                                            width: "100%"
                                                        }}
                                                    >
                                                        <a className="timerange" style={{ color: "red" }}>
                                                            <i className="fa fa-times" aria-hidden="true" />{" "}
                                                            {t(this.lang,'ufa_bank_maintenance_notice')}
                                                        </a>
                                                    </div>
                                                </div>
                                            </form>
                                            <table
                                                style={{ width: "100%", fontSize: 24 }}
                                                id="res__"
                                                className="tt_l tt_full fr_tx2"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect == 44 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'ufa_invite_earn')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="thaitheme_read">
                                    <p style={{ textAlign: "center" }}>
                                        <strong>{t(this.lang,'u5_net_h1')}</strong>
                                        <br />
                                        <strong>
                                            {t(this.lang,'u5_net_share')}
                                        </strong>
                                    </p>
                                    <p>
                                        {t(this.lang,'u5_net_p1_a')} <strong>ufabet </strong>
                                        {t(this.lang,'u5_net_p1_nocond')}
                                    </p>
                                    <p>{t(this.lang,'u5_net_eg')}</p>
                                    <p>
                                        {t(this.lang,'u5_net_friend1')}<br />
                                        {t(this.lang,'u5_net_friend1_p')}
                                    </p>
                                    <ul>
                                        <li>
                                            {t(this.lang,'u5_net_friend1_li')}
                                        </li>
                                    </ul>
                                    <p>
                                        {t(this.lang,'u5_net_friend2')}<br />
                                        {t(this.lang,'u5_net_friend2_p')}
                                    </p>
                                    <ul>
                                        <li>
                                            {t(this.lang,'u5_net_friend2_li')}
                                        </li>
                                    </ul>
                                    <p>
                                        {t(this.lang,'u5_net_month')}
                                    </p>
                                    <p>
                                        {t(this.lang,'u5_net_concl')}
                                    </p>
                                    <p>
                                        <a role="button" onClick={(e) => {
                                            this.checkurl(e, "/affiliate")
                                        }}>
                                            <img loading="lazy"
                                                fetchpriority="high"
                                                decoding="async"
                                                className="size-full wp-image-422 aligncenter"
                                                src="https://s3.newworld.center/image/ca6e788f-55ba-4107-ae4c-4360d0a0679e.webp"
                                                alt=""
                                                width={600}
                                                height={280}
                                            />
                                        </a>
                                    </p>
                                    <p>
                                        <a role="button" onClick={(e) => {
                                            this.checkurl(e, "/affiliate")
                                        }}>
                                            <img loading="lazy"
                                                decoding="async"
                                                className="aligncenter wp-image-4319 size-full"
                                                src="https://s3.newworld.center/image/2ca322ea-2377-4c69-9bcb-c8026fba57f7.webp"
                                                alt=""
                                                width={1040}
                                                height={1040}
                                                srcSet="https://s3.newworld.center/image/2ca322ea-2377-4c69-9bcb-c8026fba57f7.webp 1040w, /build/web/igame-index-lobby-wm/img/2568-10-12-23.22.21-300x300.jpg 300w, /build/web/igame-index-lobby-wm/img/2568-10-12-23.22.21-1024x1024.jpg 1024w, /build/web/igame-index-lobby-wm/img/2568-10-12-23.22.21-150x150.jpg 150w, /build/web/igame-index-lobby-wm/img/2568-10-12-23.22.21-768x768.jpg 768w"
                                                sizes="(max-width: 1040px) 100vw, 1040px"
                                            />
                                        </a>
                                    </p>
                                    <p>
                                        <a role="button" onClick={(e) => {
                                            this.checkurl(e, "/affiliate")
                                        }}>
                                            <img loading="lazy"
                                                decoding="async"
                                                className="aligncenter wp-image-4321 size-full"
                                                src="https://s3.newworld.center/image/70b7438c-7b39-48d9-8438-7380bad94802.webp"
                                                alt=""
                                                width={1040}
                                                height={1040}
                                                srcSet="https://s3.newworld.center/image/70b7438c-7b39-48d9-8438-7380bad94802.webp 1040w, /build/web/igame-index-lobby-wm/img/2568-10-12-23.23.17-300x300.jpg 300w, /build/web/igame-index-lobby-wm/img/2568-10-12-23.23.17-1024x1024.jpg 1024w, /build/web/igame-index-lobby-wm/img/2568-10-12-23.23.17-150x150.jpg 150w, /build/web/igame-index-lobby-wm/img/2568-10-12-23.23.17-768x768.jpg 768w"
                                                sizes="(max-width: 1040px) 100vw, 1040px"
                                            />
                                        </a>
                                    </p>
                                    <p>
                                        <a role="button" onClick={(e) => {
                                            this.checkurl(e, "/affiliate")
                                        }}>
                                            <img
                                                loading="lazy"
                                                decoding="async"
                                                className="aligncenter wp-image-4324 size-full"
                                                src="/build/web/igame-index-lobby-wm/img/แนะนำเพื่อน2.gif"
                                                alt=""
                                                width={595}
                                                height={345}
                                            />
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>






                    </div>
                    <div className="tt_l tt_full p_gl" style={{ display: tabselect == 7 ? "" : "none" }}>

                        <div className="wrapper-c">
                            <div className="tt_l tt_full p_gl">
                                <div id="ct_from" className="tt_l tt_full title_page">
                                    <h1>{t(this.lang,'promotion')}</h1>
                                </div>
                                <div className="tt_l tt_full tt_content bg">
                                    {tabselect == 7 ? <Promotion /> : ""}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="wrapper-c" style={{ display: this.state.loginstate || tabselect !== 22 ? "none" : "" }}>
                        {tabselect == 22 ? <Register /> : ""}
                    </div>
                    <div className="wrapper-c" style={{ display: this.state.loginstate || tabselect !== 23 ? "none" : "" }}>

                        {tabselect == 23 ? <Signin /> : ""}
                    </div>

                    <div className="wrapper-c" style={{ display: this.state.loginstate && tabselect == 36 ? "" : "none" }}>
                        <div className="tt_l tt_full p_member" >
                            {tabselect == 36 ? <Checkindaily userid={this.state.username}
                                loginstate={this.state.loginstate}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.checkurl(e, to); // หรือ checkurl(e, to)
                                }} /> : ""}
                        </div>
                    </div>
                    <div className="wrapper-c" style={{ display: this.state.loginstate && tabselect === 51 ? "" : "none" }}>
                        <div className="tt_l tt_full p_gl">
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'ufa_opencard_title')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="thaitheme_read">
                                    <figure className="wp-block-image size-large">
                                        <img loading="lazy"
                                            fetchpriority="high"
                                            decoding="async"
                                            className="alignnone size-full wp-image-186"
                                            src="https://s3.newworld.center/image/468bed3c-8969-483c-a709-cd434ab52aae.webp"
                                            alt=""
                                            width={1040}
                                            height={1040}
                                        />
                                    </figure>
                                    <h1>
                                        <u>
                                            <strong>{t(this.lang,'ufa_join_conditions')}</strong>
                                        </u>
                                    </h1>
                                    <ul>
                                        <li>{t(this.lang,'ufa_card_rule_1')}</li>
                                        <li>{t(this.lang,'ufa_card_rule_2')}</li>
                                        <li>{t(this.lang,'ufa_card_rule_3')}</li>
                                        <li>{t(this.lang,'ufa_card_rule_4')}</li>
                                        <li>{t(this.lang,'ufa_card_rule_5')}</li>
                                        <li>{t(this.lang,'ufa_card_rule_6')}</li>
                                        <li>
                                            {t(this.lang,'ufa_card_rule_7')}
                                        </li>
                                    </ul>
                                    <h2>
                                        <a role="button" onClick={(e) => {
                                            this.checkurl(e, "/cardminigame")
                                        }} rel="noopener noreferrer">
                                            <span style={{ color: "#ff0000" }}>
                                                {t(this.lang,'ufa_start_opencard_cta')}
                                            </span>
                                        </a>
                                    </h2>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="wrapper-c" style={{ display: this.state.loginstate && tabselect === 52 ? "" : "none" }}>
                        <div className="tt_l tt_full p_gl">
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'ufa_spin_fortune_wheel')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="thaitheme_read">
                                    <figure className="wp-block-gallery columns-1 is-cropped wp-block-gallery-1 is-layout-flex wp-block-gallery-is-layout-flex">
                                        <ul className="blocks-gallery-grid">
                                            <li className="blocks-gallery-item">
                                                <figure>
                                                    <a href="../spin">
                                                        <img loading="lazy"
                                                            fetchpriority="high"
                                                            decoding="async"
                                                            className="size-full wp-image-1042 aligncenter"
                                                            src="https://s3.newworld.center/image/1e4b7037-2aee-4a64-96c9-595f99882fe8.webp"
                                                            alt=""
                                                            width={1040}
                                                            height={1040} sizes="(max-width: 1040px) 100vw, 1040px"
                                                        />
                                                    </a>
                                                </figure>
                                            </li>
                                        </ul>
                                    </figure>
                                    <h1 className="wp-block-heading">
                                        <strong>{t(this.lang,'u5_terms')}</strong>
                                    </h1>
                                    <ul className="wp-block-list">
                                        <li>
                                            {t(this.lang,'ufa_wheel_rule_1')}
                                        </li>
                                        <li>
                                            {t(this.lang,'ufa_wheel_rule_2')}
                                        </li>
                                        <li>{t(this.lang,'ufa_wheel_rule_3')}</li>
                                        <li>
                                            {t(this.lang,'ufa_wheel_rule_4')}
                                        </li>
                                        <li>{t(this.lang,'ufa_wheel_rule_5')}</li>
                                        <li>{t(this.lang,'ufa_wheel_rule_6')}</li>
                                        <li>{t(this.lang,'ufa_wheel_rule_7')}</li>
                                    </ul>
                                    <p>
                                        <strong>
                                            <span className="has-inline-color" style={{ color: "#ff1313" }}>
                                                (
                                                <strong>
                                                    {t(this.lang,'ufa_wheel_warning')}
                                                </strong>
                                                )
                                            </span>
                                        </strong>
                                    </p>
                                    <h2>
                                        <a
                                            className="aioseop-link"
                                            role="button"
                                            onClick={(e) => {
                                                this.checkurl(e, "/luckyfortune")
                                            }}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                        >
                                            {t(this.lang,'ufa_start_wheel_cta')}
                                        </a>
                                    </h2>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div className="wrapper-c" style={{ display: this.state.loginstate && tabselect === 53 ? "" : "none" }}>
                        <div className="tt_l tt_full p_gl">
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'checkin_title')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="thaitheme_read">
                                    <figure className="wp-block-gallery columns-1 is-cropped wp-block-gallery-1 is-layout-flex wp-block-gallery-is-layout-flex">
                                        <ul className="blocks-gallery-grid">
                                            <li className="blocks-gallery-item">
                                                <figure>
                                                    <a href="../spin">
                                                        <img loading="lazy"
                                                            fetchpriority="high"
                                                            decoding="async"
                                                            className="size-full wp-image-1042 aligncenter"
                                                            src="https://s3.newworld.center/image/df0f11c2-322a-4af7-962d-edb20d4f44f9.webp"
                                                            alt=""
                                                            width={1040}
                                                            height={1040} sizes="(max-width: 1040px) 100vw, 1040px"
                                                        />
                                                    </a>
                                                </figure>
                                            </li>
                                        </ul>
                                    </figure>
                                    <h1 className="wp-block-heading">
                                        <strong>{t(this.lang,'u5_terms')}</strong>
                                    </h1>
                                    <ul className="wp-block-list">
                                        <li>
                                            {t(this.lang,'ufa_checkin_rule_1')}
                                        </li>

                                        <li>
                                            {t(this.lang,'ufa_checkin_rule_2')}
                                        </li>

                                        <li>
                                            {t(this.lang,'ufa_checkin_rule_3')}
                                        </li>

                                        <li>
                                            {t(this.lang,'ufa_checkin_rule_4')}
                                        </li>

                                        <li>
                                            {t(this.lang,'ufa_checkin_rule_5')}
                                        </li>

                                        <li>
                                            {t(this.lang,'ufa_checkin_rule_6')}
                                        </li>

                                        <li>
                                            {t(this.lang,'ufa_checkin_rule_7')}
                                        </li>
                                    </ul>
                                    <h2>
                                        <a
                                            className="aioseop-link"
                                            role="button"
                                            onClick={(e) => {
                                                this.checkurl(e, "/checkindaily")
                                            }}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                        >
                                            {t(this.lang,'ufa_start_checkin_cta')}
                                        </a>
                                    </h2>
                                </div>
                            </div>
                        </div>


                    </div>
                    {/* ─── รีวิวลูกค้า ─── */}
                    <div className="wrapper-c" style={{ display: tabselect === 54 ? "" : "none" }}>
                        <div className="tt_l tt_full p_gl">
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'ufa_customer_reviews')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div style={{ padding: "24px 16px" }}>
                                    {/* Header */}
                                    <div style={{ textAlign: "center", marginBottom: 32 }}>
                                        <div style={{ fontSize: 15, color: "#6b7280" }}>
                                            {t(this.lang,'ufa_real_reviews')} · {t(this.lang,'ufa_total')} {this.state.reviewTotal.toLocaleString()} {t(this.lang,'ufa_reviews_unit')}
                                        </div>
                                        {this.state.reviewList.length > 0 && (
                                            <div style={{ fontSize: 22, color: "#f59e0b", fontWeight: 700, marginTop: 4 }}>
                                                {"★".repeat(5)} &nbsp;
                                                {(this.state.reviewList.reduce((s, r) => s + (r.score || r.rating || 0), 0) / this.state.reviewList.length).toFixed(1)} / 5
                                            </div>
                                        )}
                                    </div>

                                    {/* Loading */}
                                    {this.state.reviewLoading && (
                                        <div style={{ textAlign: "center", padding: 60, color: "#9ca3af", fontSize: 15 }}>
                                            {t(this.lang,'ufa_loading_reviews')}
                                        </div>
                                    )}

                                    {/* Empty */}
                                    {!this.state.reviewLoading && this.state.reviewList.length === 0 && (
                                        <div style={{ textAlign: "center", padding: 60, color: "#9ca3af" }}>
                                            <div style={{ fontSize: 48, marginBottom: 12 }}>⭐</div>
                                            <div style={{ fontSize: 15 }}>{t(this.lang,'ufa_no_reviews')}</div>
                                        </div>
                                    )}

                                    {/* Cards Grid */}
                                    {!this.state.reviewLoading && this.state.reviewList.length > 0 && (
                                        <div style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                                            gap: 20,
                                        }}>
                                            {this.state.reviewList.map((row, i) => {
                                                const rating = row.score || row.rating || 0;
                                                const name = row.username || row.userid || "?";
                                                const initial = name[0].toUpperCase();
                                                const avatarColors = ["#6366f1", "#ec4899", "#10b981", "#f59e0b", "#3b82f6", "#8b5cf6", "#ef4444"];
                                                const avatarColor = avatarColors[(initial.charCodeAt(0) || 0) % avatarColors.length];
                                                return (
                                                    <div key={row.id || i} style={{
                                                        background: "#fff",
                                                        border: "1px solid #e5e7eb",
                                                        borderRadius: 14,
                                                        padding: 16,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 10,
                                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                                    }}>
                                                        {/* Avatar + name */}
                                                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                                            <div style={{
                                                                width: 44, height: 44, borderRadius: "50%",
                                                                background: avatarColor, color: "#fff",
                                                                fontWeight: 700, fontSize: 20,
                                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                                flexShrink: 0,
                                                            }}>{initial}</div>
                                                            <div>
                                                                <div style={{ fontWeight: 700, fontSize: 14, color: "#111827" }}>{name}</div>
                                                                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>
                                                                    {row.created_at ? new Date(row.created_at).toLocaleDateString("th-TH", { day: "2-digit", month: "short", year: "numeric" }) : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Stars */}
                                                        <div>
                                                            {[1,2,3,4,5].map(s => (
                                                                <span key={s} style={{ fontSize: 18, color: s <= rating ? "#f59e0b" : "#d1d5db" }}>★</span>
                                                            ))}
                                                            <span style={{ fontSize: 12, color: "#6b7280", marginLeft: 4 }}>({rating}/5)</span>
                                                        </div>
                                                        {/* Comment */}
                                                        <div style={{ fontSize: 13, color: "#374151", lineHeight: 1.6 }}>
                                                            {row.comment || row.message || <span style={{ fontStyle: "italic", color: "#d1d5db" }}>{t(this.lang,'ufa_no_comment')}</span>}
                                                        </div>
                                                        {/* Image if any */}
                                                        {row.image && (
                                                            <img loading="lazy"
                                                                src={row.image}
                                                                alt="review"
                                                                style={{ width: "100%", borderRadius: 8, objectFit: "cover", maxHeight: 200, cursor: "pointer", marginTop: 4 }}
                                                                onClick={() => window.open(row.image, "_blank")}
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {/* Pagination */}
                                    {Math.ceil(this.state.reviewTotal / 12) > 1 && (
                                        <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 32, flexWrap: "wrap" }}>
                                            {Array.from({ length: Math.ceil(this.state.reviewTotal / 12) }, (_, i) => i + 1).map(p => (
                                                <button
                                                    key={p}
                                                    onClick={() => this.fetchReviewList(p)}
                                                    style={{
                                                        width: 36, height: 36, borderRadius: "50%",
                                                        border: "none", cursor: "pointer",
                                                        background: this.state.reviewPage === p ? "#f59e0b" : "rgba(255,255,255,0.1)",
                                                        color: this.state.reviewPage === p ? "#000" : "#fff",
                                                        fontWeight: this.state.reviewPage === p ? 700 : 400,
                                                    }}>
                                                    {p}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="wrapper-c" style={{ display: this.state.loginstate && tabselect === 37 ? "" : "none" }}>
                        <div className="tt_l tt_full p_member" >
                            {tabselect == 37 ? <Cardminigame userid={this.state.username}
                                loginstate={this.state.loginstate}
                                point={this.state.point}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.checkurl(e, to); // หรือ checkurl(e, to)
                                }} /> : ""}
                        </div>
                    </div>
                    <div className="wrapper-c" style={{ display: this.state.loginstate && tabselect === 35 ? "" : "none" }}>
                        <div className="tt_l tt_full p_member" >
                            {tabselect == 35 ? <Luckyfortune
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                point={this.state.point}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                }}
                            /> : ""}
                        </div>
                    </div>

                    {/* ─── อัพโหลดสลิป (Upload Slip) ─── */}
                    <div className="tt_l tt_full p_gl" style={{ display: tabselect == 56 ? "" : "none" }}>
                        <div id="ct_from" className="tt_l tt_full title_page">
                            <h1>{t(this.lang, 'upload_slip_title')}</h1>
                        </div>
                        <div className="tt_l tt_full tt_content bg">
                            <div className="row m-0">
                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto">
                                    <div style={{ background: "linear-gradient(135deg,#1b2838 0%,#1e3448 55%,#243b55 100%)", borderRadius: 18, boxShadow: "0 10px 36px rgba(0,0,0,0.55)", padding: 16, margin: "8px 4px", color: "#fff" }}>
                                        {/* Header */}
                                        <div className="text-center pt-3 pb-2">
                                            <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 56, height: 56, borderRadius: "50%", background: "rgba(251,191,36,0.2)", border: "2px solid rgba(251,191,36,0.5)", marginBottom: 8 }}>
                                                <i className="fas fa-file-upload" style={{ fontSize: 24, color: "#fbbf24" }}></i>
                                            </div>
                                            <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>{t(this.lang, 'upload_slip_title')}</div>
                                            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.75)" }}>{t(this.lang, 'upload_slip_desc')}</div>
                                        </div>
                                        {/* Upload area */}
                                        <div className="px-1 pb-1">
                                            <input type="file" hidden onChange={this.handleFileSelectedt} id="upload-slip-page" name="filename" accept="image/*" />
                                            {!this.state.previewUrl ? (
                                                <label htmlFor="upload-slip-page" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: "2px dashed rgba(251,191,36,0.5)", borderRadius: 12, padding: "28px 16px", cursor: "pointer", gap: 10, background: "rgba(251,191,36,0.06)" }}>
                                                    <i className="fas fa-cloud-upload-alt" style={{ fontSize: 40, color: "#fbbf24" }}></i>
                                                    <span style={{ fontWeight: 600, fontSize: 14, color: "#fff" }}>{t(this.lang, 'tap_select_image')}</span>
                                                    <span style={{ fontSize: 11, color: "rgba(255,255,255,0.65)" }}>{t(this.lang, 'supported_format')}</span>
                                                </label>
                                            ) : (
                                                <div style={{ textAlign: "center" }}>
                                                    <img loading="lazy" src={this.state.previewUrl} alt="Preview" style={{ maxWidth: "100%", maxHeight: 260, borderRadius: 10, border: "2px solid rgba(255,255,255,0.3)", objectFit: "contain" }} />
                                                    <div className="mt-2">
                                                        <label htmlFor="upload-slip-page" style={{ fontSize: 12, opacity: 0.7, cursor: "pointer", textDecoration: "underline" }}>{t(this.lang, 'change_slip')}</label>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {/* Confirm / Status */}
                                        <div className="px-1 pb-1 mt-2">
                                            {this.state.files.length > 0 && !this.state.isConfirmed && (
                                                <button className="btn w-100" onClick={this.handleConfirmUpload} disabled={this.state.isUploading} style={{ fontWeight: 700, fontSize: 15, padding: "12px", background: "linear-gradient(135deg,#00c853,#00701a)", color: "#fff", borderRadius: 10, border: "none", boxShadow: "0 4px 14px rgba(0,200,83,0.35)" }}>
                                                    {this.state.isUploading ? (<><i className="fas fa-spinner fa-spin" style={{ marginRight: 6 }}></i>{t(this.lang, 'uploading')}</>) : (<><i className="fas fa-check-circle" style={{ marginRight: 6 }}></i>{t(this.lang, 'confirm_upload')}</>)}
                                                </button>
                                            )}
                                            {this.state.isConfirmed && !this.state.isUploading && (
                                                <div style={{ background: "rgba(74,222,128,0.15)", border: "1px solid rgba(74,222,128,0.5)", borderRadius: 10, padding: "12px", textAlign: "center" }}>
                                                    <i className="fas fa-check-circle" style={{ color: "#4ade80", fontSize: 24, marginBottom: 4, display: "block" }}></i>
                                                    <div style={{ fontWeight: 700, color: "#4ade80" }}>{t(this.lang, 'upload_success_title')}</div>
                                                    <div style={{ fontSize: 12, opacity: 0.8, marginTop: 4 }}>{t(this.lang, 'processing')}</div>
                                                    <button className="btn btn-sm mt-2" onClick={() => this.setState({ files: [], previewUrl: null, isConfirmed: false, isUploading: false })} style={{ background: "rgba(255,255,255,0.15)", color: "#fff", borderRadius: 8, fontSize: 12 }}>
                                                        <i className="fas fa-redo" style={{ marginRight: 4 }}></i>{t(this.lang, 'reupload')}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        {/* Conditions */}
                                        <div style={{ background: "rgba(251,191,36,0.1)", border: "1px solid rgba(251,191,36,0.3)", borderRadius: 10, padding: "12px 16px", margin: "8px 0", fontSize: 14 }}>
                                            <div style={{ fontWeight: 700, marginBottom: 8, color: "#fbbf24", fontSize: 15 }}>
                                                <i className="fas fa-exclamation-circle" style={{ marginRight: 6 }}></i>{t(this.lang, 'upload_conditions_title')}
                                            </div>
                                            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 2, color: "rgba(255,255,255,0.9)" }}>
                                                <li>{t(this.lang, 'cond_slip_1')}</li>
                                                <li>{t(this.lang, 'cond_slip_2')}</li>
                                                <li>{t(this.lang, 'cond_slip_3')}</li>
                                                <li>{t(this.lang, 'cond_slip_4')}</li>
                                                <li>{t(this.lang, 'cond_slip_5')}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ─── ระบบ Rank ─── */}
                    <div className="wrapper-c" style={{ display: tabselect === 55 ? "" : "none" }}>
                        <div className="tt_l tt_full p_member" style={{ padding: "20px 16px" }}>
                            <div style={{ maxWidth: 900, margin: "0 auto" }}>
                                <h1 style={{ textAlign: "center", color: "#f59e0b", fontSize: 26, marginBottom: 8 }}>
                                    <i className="fas fa-crown" style={{ marginRight: 8 }} />{t(this.lang,'ufa_rank_system')}
                                </h1>
                                <p style={{ textAlign: "center", color: "#9ca3af", fontSize: 14, marginBottom: 24 }}>
                                    {t(this.lang,'ufa_rank_subtitle')}
                                </p>

                                {/* Current Rank Card */}
                                {this.state.loginstate && this.state.rankob && (
                                    <div style={{
                                        background: "linear-gradient(135deg, #1e1b4b, #312e81)",
                                        border: "2px solid #f59e0b",
                                        borderRadius: 16,
                                        padding: "20px 24px",
                                        marginBottom: 28,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 20,
                                        flexWrap: "wrap"
                                    }}>
                                        <div style={{
                                            width: 72, height: 72, borderRadius: "50%",
                                            border: "3px solid #f59e0b",
                                            overflow: "hidden", flexShrink: 0,
                                            background: "#1f2937",
                                            display: "flex", alignItems: "center", justifyContent: "center"
                                        }}>
                                            {this.state.rankpic
                                                ? <img loading="lazy" src={/^https?:\/\//.test(this.state.rankpic) ? this.state.rankpic : "/build/rank/" + this.state.rankpic} alt="rank" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                : <i className="fas fa-crown" style={{ fontSize: 32, color: "#f59e0b" }} />
                                            }
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ color: "#f59e0b", fontWeight: 700, fontSize: 18 }}>
                                                {t(this.lang,'ufa_current_rank')}: {this.state.rankname || this.state.rankob?.name || "-"}
                                            </div>
                                            <div style={{ color: "#d1d5db", fontSize: 14, marginTop: 4 }}>
                                                {t(this.lang,'ufa_accumulated_points')}: <span style={{ color: "#fff", fontWeight: 600 }}>{(this.state.rankpoint || 0).toLocaleString()}</span> {t(this.lang,'point')}
                                            </div>
                                            {this.state.rankob?.highamount && (
                                                <div style={{ marginTop: 8 }}>
                                                    <div style={{ background: "#374151", borderRadius: 99, height: 8, overflow: "hidden" }}>
                                                        <div style={{
                                                            background: "linear-gradient(90deg, #f59e0b, #fbbf24)",
                                                            height: "100%",
                                                            width: Math.min(100, ((this.state.rankpoint - (this.state.rankob?.lowamount || 0)) / ((this.state.rankob?.highamount || 1) - (this.state.rankob?.lowamount || 0))) * 100) + "%",
                                                            borderRadius: 99
                                                        }} />
                                                    </div>
                                                    <div style={{ color: "#9ca3af", fontSize: 12, marginTop: 4 }}>
                                                        {(this.state.rankob?.lowamount || 0).toLocaleString()} – {(this.state.rankob?.highamount || 0).toLocaleString()} {t(this.lang,'point')}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Not logged in */}
                                {!this.state.loginstate && (
                                    <div style={{ textAlign: "center", color: "#9ca3af", padding: "40px 0" }}>
                                        <i className="fas fa-lock" style={{ fontSize: 40, color: "#374151", marginBottom: 12, display: "block" }} />
                                        {t(this.lang,'ufa_login_to_view_rank')}
                                    </div>
                                )}

                                {/* Rank Grid */}
                                {this.state.tblrankall && this.state.tblrankall.length > 0 && (
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 16 }}>
                                        {this.state.tblrankall.map((rank, i) => {
                                            const canClaim = rank.checked == 1 || rank.checked === true;
                                            const redeemed = rank.redeemed == 1 || rank.redeemed === true;
                                            const reached = this.state.rankpoint >= (rank.lowamount || 0);
                                            return (
                                                <div key={rank.no || i} style={{
                                                    background: redeemed ? "#1a2e1a" : canClaim ? "#1e3a2e" : "#1f2937",
                                                    border: `2px solid ${redeemed ? "#16a34a" : canClaim ? "#22c55e" : "#374151"}`,
                                                    borderRadius: 12,
                                                    padding: 16,
                                                    textAlign: "center",
                                                    opacity: (!reached && !redeemed) ? 0.6 : 1,
                                                    transition: "all 0.2s"
                                                }}>
                                                    <div style={{
                                                        width: 56, height: 56, borderRadius: "50%",
                                                        margin: "0 auto 10px",
                                                        border: `2px solid ${redeemed ? "#16a34a" : canClaim ? "#22c55e" : "#4b5563"}`,
                                                        overflow: "hidden", background: "#111827",
                                                        display: "flex", alignItems: "center", justifyContent: "center"
                                                    }}>
                                                        {rank.image
                                                            ? <img loading="lazy" src={/^https?:\/\//.test(rank.image) ? rank.image : "/build/rank/" + rank.image} alt={rank.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                            : <i className="fas fa-medal" style={{ fontSize: 24, color: redeemed ? "#16a34a" : canClaim ? "#22c55e" : "#6b7280" }} />
                                                        }
                                                    </div>
                                                    <div style={{ color: "#f3f4f6", fontWeight: 700, fontSize: 15, marginBottom: 4 }}>
                                                        {rank.name || `Rank ${rank.no}`}
                                                    </div>
                                                    <div style={{ color: "#9ca3af", fontSize: 12, marginBottom: 8 }}>
                                                        {(rank.lowamount || 0).toLocaleString()} {t(this.lang,'ufa_points_up')}
                                                    </div>
                                                    {rank.claimamount > 0 && (
                                                        <div style={{ color: "#fbbf24", fontSize: 13, fontWeight: 600, marginBottom: 10 }}>
                                                            {t(this.lang,'ufa_get_bonus')} {parseFloat(rank.claimamount).toLocaleString()} {t(this.lang,'baht')}
                                                        </div>
                                                    )}
                                                    {redeemed ? (
                                                        <div style={{
                                                            background: "#15803d", color: "#fff",
                                                            borderRadius: 8, padding: "6px 0",
                                                            fontSize: 13, fontWeight: 600
                                                        }}>✓ {t(this.lang,'ufa_claimed')}</div>
                                                    ) : canClaim ? (
                                                        <button onClick={(e) => this.redeemrank(e, rank)} style={{
                                                            background: "linear-gradient(135deg, #16a34a, #22c55e)",
                                                            color: "#fff", border: "none",
                                                            borderRadius: 8, padding: "8px 0",
                                                            width: "100%", fontSize: 14,
                                                            fontWeight: 700, cursor: "pointer"
                                                        }}>🎁 {t(this.lang,'ufa_claim')}</button>
                                                    ) : (
                                                        <div style={{
                                                            background: "#374151", color: "#6b7280",
                                                            borderRadius: 8, padding: "6px 0",
                                                            fontSize: 13
                                                        }}>🔒 {t(this.lang,'ufa_not_reached')}</div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}

                                {/* No rank data */}
                                {this.state.loginstate && (!this.state.tblrankall || this.state.tblrankall.length === 0) && (
                                    <div style={{ textAlign: "center", color: "#9ca3af", padding: "40px 0" }}>
                                        {t(this.lang,'ufa_no_rank_data')}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="wrapper-c" style={{ display: this.state.loginstate && tabselect === 50 ? "" : "none" }}>
                        <div className="tt_l tt_full p_member" >
                            {tabselect == 50 ? <Coupon /> : ""}
                        </div>
                    </div>

                    <div className="wrapper-c" style={{ display: tabselect === 10 || tabselect === 14 || tabselect === 4 ? "" : "none" }}>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect === 10 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'ufa_casino_online')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="thaitheme_read">
                                    <p>
                                        <img loading="lazy"
                                            fetchpriority="high"
                                            decoding="async"
                                            className="aligncenter size-full wp-image-3016"
                                            src="https://s3.newworld.center/image/1fc32a33-ba31-4f3d-ad53-3b920d1c80c9.webp"
                                            alt=""
                                            width={875}
                                            height={391}
                                            srcSet="https://s3.newworld.center/image/1fc32a33-ba31-4f3d-ad53-3b920d1c80c9.webp 875w, https://ufac4w.com/wp-content/uploads/2025/03/875x391-casino-300x134.png 300w, https://ufac4w.com/wp-content/uploads/2025/03/875x391-casino-768x343.png 768w"
                                            sizes="(max-width: 875px) 100vw, 875px"
                                        />
                                    </p>
                                    <p>
                                        <strong>UFA11 </strong>
                                        <strong>
                                            {t(this.lang,'seo_casino_h1')}
                                        </strong>
                                    </p>
                                    <p>&nbsp;</p>
                                    <p>
                                        {t(this.lang,'seo_casino_intro')}
                                    </p>
                                    <p>&nbsp;</p>
                                    <p>
                                        <strong>{t(this.lang,'seo_casino_reasons_h')}</strong>
                                    </p>
                                    <p>{t(this.lang,'seo_casino_r1_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_r1_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_r2_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_r2_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_r3_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_r3_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_r4_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_r4_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_r5_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_r5_p')}
                                    </p>
                                    <p>&nbsp;</p>
                                    <p>
                                        <strong>{t(this.lang,'seo_casino_types_h')}</strong>
                                    </p>
                                    <p>{t(this.lang,'seo_casino_t1_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_t1_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_t2_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_t2_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_t3_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_t3_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_t4_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_t4_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_t5_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_t5_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_t6_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_t6_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_casino_t7_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_casino_t7_p')}
                                    </p>
                                    <p>&nbsp;</p>
                                    <p>
                                        {t(this.lang,'seo_casino_conc')}
                                    </p>
                                    <p>&nbsp;</p>
                                    <p>
                                        <a
                                            role="button" onClick={(e) => {
                                                this.checkurl(e, "/register")
                                            }}
                                            style={{
                                                background: "none",
                                                animation:
                                                    "0.5s steps(5) 0s infinite normal none running walk-cyclet2"
                                            }}
                                        >
                                            <img loading="lazy"
                                                decoding="async"
                                                className="aligncenter wp-image-4715 size-full"
                                                src="https://ufac4w.com/wp-content/uploads/2026/02/regis-button-c4.gif"
                                                alt=""
                                                width={800}
                                                height={200}
                                            />
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect === 14 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'ufa_football_online')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="thaitheme_read">
                                    <p>
                                        <img loading="lazy"
                                            fetchpriority="high"
                                            decoding="async"
                                            className="aligncenter wp-image-4316 size-full"
                                            src="https://s3.newworld.center/image/19b72bf5-45ce-4838-b7ca-22953720e6b9.webp"
                                            alt=""
                                            width={875}
                                            height={391}
                                            srcSet="https://s3.newworld.center/image/19b72bf5-45ce-4838-b7ca-22953720e6b9.webp 875w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.16.51-300x134.jpg 300w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.16.51-768x343.jpg 768w"
                                            sizes="(max-width: 875px) 100vw, 875px"
                                        />
                                    </p>
                                    <p>
                                        <strong>UFA11 </strong>
                                        <strong>{t(this.lang,'seo_sport_h1')}</strong>
                                    </p>
                                    <p>
                                        {t(this.lang,'seo_sport_intro1')}
                                    </p>
                                    <p>&nbsp;</p>
                                    <p>
                                        {t(this.lang,'seo_sport_intro2')}
                                    </p>
                                    <p>
                                        <strong>{t(this.lang,'seo_sport_reasons_h')}</strong>
                                    </p>
                                    <p>{t(this.lang,'seo_sport_r1_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_sport_r1_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_sport_r2_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_sport_r2_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_sport_r3_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_sport_r3_p1')}
                                    </p>
                                    <p>
                                        {t(this.lang,'seo_sport_r3_p2')}
                                    </p>
                                    <p>{t(this.lang,'seo_sport_r4_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_sport_r4_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_sport_r5_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_sport_r5_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_sport_r6_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_sport_r6_p')}
                                    </p>
                                    <p>{t(this.lang,'seo_sport_r7_h')}</p>
                                    <p>
                                        {t(this.lang,'seo_sport_r7_p')}
                                    </p>
                                    <p>
                                        <img loading="lazy"
                                            decoding="async"
                                            className="aligncenter size-full wp-image-2992"
                                            src="https://s3.newworld.center/image/d83cb003-043c-4a39-add6-166e84e9dfa4.webp"
                                            alt=""
                                            width={875}
                                            height={391} sizes="(max-width: 875px) 100vw, 875px"
                                        />
                                    </p>

                                    <p>
                                        <strong>{t(this.lang,'seo_sport_types_h')}</strong>
                                    </p>
                                    <p>
                                        {t(this.lang,'seo_sport_types_p')}
                                    </p>
                                    <ol>
                                        <li>{t(this.lang,'seo_sport_li1')}</li>
                                    </ol>
                                    <p>
                                        {t(this.lang,'seo_sport_li1_p')}
                                    </p>
                                    <ol start={2}>
                                        <li>{t(this.lang,'seo_sport_li2')}</li>
                                    </ol>
                                    <p>
                                        {t(this.lang,'seo_sport_li2_p')}
                                    </p>
                                    <ol start={3}>
                                        <li>{t(this.lang,'seo_sport_li3')}</li>
                                    </ol>
                                    <p>
                                        {t(this.lang,'seo_sport_li3_p')}
                                    </p>
                                    <ol start={4}>
                                        <li>{t(this.lang,'seo_sport_li4')}</li>
                                    </ol>
                                    <p>
                                        {t(this.lang,'seo_sport_li4_p')}
                                    </p>
                                    <ol start={5}>
                                        <li>{t(this.lang,'seo_sport_li5')}</li>
                                    </ol>
                                    <p>
                                        {t(this.lang,'seo_sport_li5_p')}
                                    </p>
                                    <ol start={6}>
                                        <li>{t(this.lang,'seo_sport_li6')}</li>
                                    </ol>
                                    <p>
                                        {t(this.lang,'seo_sport_li6_p')}
                                    </p>
                                    <ol start={7}>
                                        <li>{t(this.lang,'seo_sport_li7')}</li>
                                    </ol>
                                    <p>
                                        {t(this.lang,'seo_sport_li7_p')}
                                    </p>
                                    <p>&nbsp;</p>
                                    <p>
                                        {t(this.lang,'seo_sport_conc')}
                                    </p>
                                    <p>
                                        <a
                                            role="button" onClick={(e) => {
                                                this.checkurl(e, "/register")
                                            }}
                                            style={{
                                                background: "none",
                                                animation:
                                                    "0.5s steps(5) 0s infinite normal none running walk-cyclet2"
                                            }}
                                        >
                                            <img loading="lazy"
                                                decoding="async"
                                                className="aligncenter wp-image-4715 size-full"
                                                src="https://ufac4w.com/wp-content/uploads/2026/02/regis-button-c4.gif"
                                                alt=""
                                                width={800}
                                                height={200}
                                            />
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="tt_l tt_full p_gl" style={{ display: tabselect === 4 ? "" : "none" }}>
                            <div id="ct_from" className="tt_l tt_full title_page">
                                <h1>{t(this.lang,'ufa_invite_earn')}</h1>
                            </div>
                            <div className="tt_l tt_full tt_content bg">
                                <div className="thaitheme_read">
                                    <p style={{ textAlign: "center" }}>
                                        <strong>{t(this.lang,'u5_net_h1')}</strong>
                                        <br />
                                        <strong>
                                            {t(this.lang,'u5_net_share')}
                                        </strong>
                                    </p>
                                    <p>
                                        {t(this.lang,'u5_net_p1_a')} <strong>ufabet </strong>
                                        {t(this.lang,'u5_net_p1_nocond')}
                                    </p>
                                    <p>{t(this.lang,'u5_net_eg')}</p>
                                    <p>
                                        {t(this.lang,'u5_net_friend1')}<br />
                                        {t(this.lang,'u5_net_friend1_p')}
                                    </p>
                                    <ul>
                                        <li>
                                            {t(this.lang,'u5_net_friend1_li')}
                                        </li>
                                    </ul>
                                    <p>
                                        {t(this.lang,'u5_net_friend2')}<br />
                                        {t(this.lang,'u5_net_friend2_p')}
                                    </p>
                                    <ul>
                                        <li>
                                            {t(this.lang,'u5_net_friend2_li')}
                                        </li>
                                    </ul>
                                    <p>
                                        {t(this.lang,'u5_net_month')}
                                    </p>
                                    <p>
                                        {t(this.lang,'u5_net_concl')}
                                    </p>
                                    <p>
                                        <a role="button"
                                            onClick={(e) => {
                                                this.checkurl(e, "/affiliate")
                                            }}>
                                            <img loading="lazy"
                                                fetchpriority="high"
                                                decoding="async"
                                                className="size-full wp-image-422 aligncenter"
                                                src="https://s3.newworld.center/image/ca6e788f-55ba-4107-ae4c-4360d0a0679e.webp"
                                                alt=""
                                                width={600}
                                                height={280}
                                            />
                                        </a>
                                    </p>
                                    <p>
                                        <a role="button"
                                            onClick={(e) => {
                                                this.checkurl(e, "/affiliate")
                                            }}>
                                            <img loading="lazy"
                                                decoding="async"
                                                className="aligncenter wp-image-4319 size-full"
                                                src="https://s3.newworld.center/image/2ca322ea-2377-4c69-9bcb-c8026fba57f7.webp"
                                                alt=""
                                                width={1040}
                                                height={1040}
                                                srcSet="https://s3.newworld.center/image/2ca322ea-2377-4c69-9bcb-c8026fba57f7.webp 1040w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.22.21-300x300.jpg 300w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.22.21-1024x1024.jpg 1024w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.22.21-150x150.jpg 150w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.22.21-768x768.jpg 768w"
                                                sizes="(max-width: 1040px) 100vw, 1040px"
                                            />
                                        </a>
                                    </p>
                                    <p>
                                        <a role="button"
                                            onClick={(e) => {
                                                this.checkurl(e, "/affiliate")
                                            }}>
                                            <img loading="lazy"
                                                decoding="async"
                                                className="aligncenter wp-image-4321 size-full"
                                                src="https://s3.newworld.center/image/70b7438c-7b39-48d9-8438-7380bad94802.webp"
                                                alt=""
                                                width={1040}
                                                height={1040}
                                                srcSet="https://s3.newworld.center/image/70b7438c-7b39-48d9-8438-7380bad94802.webp 1040w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.23.17-300x300.jpg 300w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.23.17-1024x1024.jpg 1024w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.23.17-150x150.jpg 150w, https://ufac4w.com/wp-content/uploads/2025/10/2568-10-12-23.23.17-768x768.jpg 768w"
                                                sizes="(max-width: 1040px) 100vw, 1040px"
                                            />
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>


                    </div>



                    <div className="tt_l tt_full  bg_1 fr_login_form" id="fr_login_form" style={{ display: !this.state.loginstate && tabselect !== 23 ? "" : "none" }}>
                        <div className="wrapper-h">
                            <div
                                className="tt_l tt_full  bg_login Parent zoomIn animated"
                                style={{ visibility: "visible", animationName: "zoomIn" }}
                            >
                                <div className="tt_l h-panel-login">
                                    <h3>{t(this.lang,'ufa_login_member')}</h3>
                                </div>
                                <style
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            "\n\n.form-group-input {\n    width: 20%;\n}\n.form-login-home {\n    width: 72%;\n  }\n\n\n@media screen and (max-width: 800px) {\n  .form-group-input {\n    width: 100%;\n  }\n  .form-login-home {\n    width: 100%;\n  }\n}\n\n\n"
                                    }}
                                />
                                <form
                                    className="form-login-home"
                                    id="loginform"
                                >
                                    <div className="form-group-input">
                                        <label className="tt_l tt_full input-tx">{t(this.lang,'ufa_phone_label')}</label>
                                        <input type="text" className="form-control" placeholder={t(this.lang,'ufa_phone_placeholder')}
                                            id="username"
                                            name="username"
                                            onChange={this.onChange}
                                            maxLength={10}
                                            defaultValue=""
                                            required
                                            autoComplete="off" />
                                    </div>
                                    <div className="form-group-input">
                                        <label className="tt_l tt_full input-tx">{t(this.lang,'password_label')}</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="password"
                                            name="password"
                                            onChange={this.onChange}
                                            minLength={10}
                                            placeholder={t(this.lang,'password_label')}
                                            autoComplete="off"
                                            defaultValue=""
                                            required=""
                                        />
                                    </div>
                                    <button
                                        onClick={(e) => {
                                            this.login(e)
                                        }}
                                        type="submit"
                                        className="frb_submit"
                                        style={{ height: 40, marginTop: 40 }}
                                    >
                                        {t(this.lang,'login')}
                                    </button>
                                    <a
                                        className="frb_submit"
                                        style={{
                                            textAlign: "center",
                                            marginLeft: 5,
                                            border: "2px solid #57c42e",
                                            background: "linear-gradient(to bottom, #57c42e 0%,#57c42e 100%)",
                                            height: 40,
                                            marginTop: 40
                                        }}
                                    >
                                        LINE LOGIN
                                    </a>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="tt_l tt_full bg_2x" style={{ display: this.state.loginstate || tabselect === 22 || tabselect === 23 ? "none" : "" }}>
                        <div className="wrapper-c">
                            <div
                                className="tt_l tt_full tt_txt_seo Parent zoomIn animated"
                                style={{ visibility: "visible", animationName: "zoomIn" }}
                            >
                                <h3>
                                    <a role="button"
                                        onClick={(e) => {
                                            this.checkurl(e, "/")
                                        }}>
                                        <img loading="lazy"
                                            className="aligncenter wp-image-4202 size-full"
                                            src="/build/web/igame-index-lobby-wm/img/UFAC4.gif"
                                            alt=""
                                            width={680}
                                            height={200}
                                        />
                                    </a>
                                </h3>
                                <h3>
                                    <img loading="lazy"
                                        className="wp-image-97 aligncenter"
                                        src={this.state.logoimg}
                                        alt=""
                                        width={379}
                                        height={140}
                                    />
                                </h3>
                                <h1 style={{ textAlign: "center" }}>
                                    <span style={{ color: "#ff6600" }}>
                                        <strong>{t(this.lang,'seo_home_h1')}</strong>
                                    </span>
                                </h1>
                                <p>
                                    UFA11&nbsp;
                                    <span style={{ textDecoration: "underline" }}> {t(this.lang,'seo_home_p_casino')}</span>{" "}
                                    <span style={{ textDecoration: "underline" }}>{t(this.lang,'seo_home_p_slot')}</span>{" "}
                                    <span style={{ textDecoration: "underline" }}>{t(this.lang,'seo_home_p_ball')}</span>{" "}
                                    {t(this.lang,'seo_home_p_seg1')}{" "}
                                    <span style={{ color: "#ff0000" }}>{t(this.lang,'seo_home_p_auto')}</span>{" "}
                                    {t(this.lang,'seo_home_p_seg2')}{" "}
                                    <span style={{ color: "#ff6600" }}>
                                        {t(this.lang,'seo_home_p_noapp')}
                                    </span>{" "}
                                    {t(this.lang,'seo_home_p_seg3')}{" "}
                                    <a
                                        onClick={(e) => {
                                            this.checkurl(e, "/login");
                                        }}
                                    >
                                        ufabet
                                    </a>{" "}
                                    {t(this.lang,'seo_home_p_seg4')}{" "}
                                    <span style={{ color: "#ff6600" }}>
                                        {t(this.lang,'seo_home_p_support')}
                                    </span>{" "}
                                    {t(this.lang,'seo_home_p_seg5')}{" "}
                                    <span style={{ color: "#00ff00" }}>{t(this.lang,'seo_home_p_dep24')}</span>
                                </p>
                                <p>&nbsp;</p>
                            </div>
                            <div className="tt_l tt_full mb-20">
                                <div className="owl-carousel slide_jp owl-theme owl-loaded owl-drag">
                                    <BannerMid />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tt_l tt_full  bg_2" style={{ display: this.state.loginstate || tabselect === 22 || tabselect === 23 ? "none" : "" }}>
                        <div className="wrapper-c">
                            <a
                                className="tt_l tt_full tt_b1x animatedParent zoomIn animated"
                                target="_blank"
                                onClick={(e) => {
                                    this.checkurl(e, "/register")
                                }}
                                style={{
                                    background: "none",
                                    animation: "0.5s steps(5) 0s infinite normal none running walk-cyclet2",
                                    visibility: "visible"
                                }}
                            >
                                <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/banner-game-min.gif" />
                            </a>
                            <div className="tt_l tt_full arhx" />
                            <div className="tt_l tt_full btx_vdo">
                                <div className="tt_l btxl">
                                    <div
                                        className="tt_l tt_full tt_txt_seo2x Parent zoomIn animated"
                                        style={{ visibility: "visible", animationName: "zoomIn" }}
                                    >
                                        <h3>
                                            <span style={{ color: "#ff6600" }}>
                                                {t(this.lang,'seo_welcome_h3')}
                                            </span>
                                        </h3>
                                        <p>
                                            <span style={{ color: "#ff6600" }}>
                                                <strong>{t(this.lang,'seo_welcome_strong')}</strong>
                                            </span>{" "}
                                            {t(this.lang,'seo_welcome_seg1')}{" "}
                                            <span style={{ textDecoration: "underline" }}>
                                                {t(this.lang,'seo_welcome_seg_lotto')}
                                            </span>{" "}
                                            <span style={{ textDecoration: "underline" }}>
                                                {t(this.lang,'seo_welcome_seg_boxing')}{" "}
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/casino");
                                                    }}
                                                >
                                                    {t(this.lang,'seo_welcome_casino')}
                                                </a>{" "}
                                                {t(this.lang,'seo_welcome_seg_games')}
                                            </span>{" "}
                                            {t(this.lang,'seo_welcome_seg2')}
                                            <strong>
                                                <span style={{ color: "#ff0000" }}>
                                                    {" "}
                                                    {t(this.lang,'seo_welcome_auto')}
                                                </span>
                                            </strong>
                                            {t(this.lang,'seo_welcome_seg3')}{" "}
                                            <span style={{ color: "#ff6600" }}>
                                                {t(this.lang,'seo_welcome_call')}
                                            </span>{" "}
                                            {t(this.lang,'seo_welcome_seg4')}{" "}
                                            <strong>
                                                <span style={{ color: "#00ff00" }} >LINE ID : @UFA11</span>
                                            </strong>
                                        </p>
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                                <div className="tt_l arrxb">
                                    <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/barr2x.png?v=1.0" />
                                </div>
                                <div
                                    className="tt_r btxr Parent zoomIn animated"
                                    style={{ visibility: "visible", animationName: "zoomIn" }}
                                >
                                    <video width="100%" height="auto" controls="" autoPlay="">
                                        <source
                                            src="https://sv1.cdend.com/c2FnYW1lc2FnYW1lc2FnYW1lc2FnYW1lc2FnYW1lc2FnYW1l/Ufac4.mp4"
                                            type="video/mp4"
                                        />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                            <a
                                className="tt_l tt_full tt_bb2x animatedParent zoomIn animated"
                                target="_blank"
                                onClick={(e) => {
                                    this.checkurl(e, "/register")
                                }}
                                style={{
                                    background: "none",
                                    animation: "0.5s steps(5) 0s infinite normal none running walk-cyclet2",
                                    visibility: "visible"
                                }}
                            >
                                <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/banner-howtoplay.gif" />
                            </a>
                        </div>
                    </div>
                    <div className="tt_l tt_full  bg_3" style={{ display: this.state.loginstate || tabselect === 22 || tabselect === 23 ? "none" : "" }}>
                        <div className="wrapper-c">
                            <div className="tt_l tt_full  ct_home">
                                <h2 className="tt_l tt_full  h_slot1">
                                    {t(this.lang,'ufa_betting_hub_tagline')}
                                </h2>
                                <div className="tt_l tt_full arhx" />
                                <div className="tt_l tt_full slide_b">
                                    <BannerFooter />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tt_l tt_full  bg_4" style={{ display: this.state.loginstate || tabselect === 22 || tabselect === 23 ? "none" : "" }}>
                        <div className="wrapper-c">
                            <div className="tt_l tt_full mb-20 mt-20">
                                <BannerSlip />
                            </div>
                            {/* <h2 className="tt_l tt_full  h_slot">
                            <a
                                title="บทความ UFABET"
                                href="/category/%e0%b8%9a%e0%b8%97%e0%b8%84%e0%b8%a7%e0%b8%b2%e0%b8%a1-ufabet/"
                            >
                                {" "}
                                บทความ UFABET
                            </a>
                        </h2>
                        <div className="tt_l tt_full arhx" />
                        <div className="tt_l tt_full btmc">
                            <article
                                className="tt_l post-l3x  animatedParent zoomIn"
                                style={{ visibility: "hidden", animationName: "none" }}
                            >
                                <a
                                    href="/%e0%b9%82%e0%b8%89%e0%b8%a1%e0%b9%83%e0%b8%ab%e0%b8%a1%e0%b9%88%e0%b8%82%e0%b8%ad%e0%b8%87-ufac4-%e0%b9%83%e0%b8%99%e0%b8%9b%e0%b8%b5-2569-%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%9b%e0%b8%a3%e0%b8%b1/"
                                    title="โฉมใหม่ของ UFA11 ในปี 2569 การปรับระบบครั้งใหญ่ที่ทำให้แพลตฟอร์มเดิมพันออนไลน์ก้าวไปอีกขั้น"
                                >
                                    <div className="tt_img">
                                        <img loading="lazy"
                                            alt=""
                                            width={250}
                                            height={150}
                                            src="/build/web/igame-index-lobby-wm/img/238-450x270-2-250x150.png"
                                        />
                                    </div>
                                    <div className="tt_dsc">
                                        <h3>
                                            โฉมใหม่ของ UFA11 ในปี 2569
                                            การปรับระบบครั้งใหญ่ที่ทำให้แพลตฟอร์มเดิมพันออนไลน์ก้าวไปอีกขั้น
                                        </h3>
                                        <p>การแข่งขันของเว็บไซต์เดิมพันออนไลน์ในปัจจุบันมีความเข้ม […]</p>
                                    </div>
                                </a>
                            </article>
                            <article
                                className="tt_l post-l3x  last animatedParent zoomIn"
                                style={{ visibility: "hidden", animationName: "none" }}
                            >
                                <a
                                    href="/%e0%b9%80%e0%b8%81%e0%b8%a1%e0%b8%a2%e0%b8%b4%e0%b8%87%e0%b8%9b%e0%b8%a5%e0%b8%b2%e0%b8%ad%e0%b8%ad%e0%b8%99%e0%b9%84%e0%b8%a5%e0%b8%99%e0%b9%8c%e0%b8%82%e0%b8%ad%e0%b8%87%e0%b8%84%e0%b9%88%e0%b8%b2/"
                                    title="เกมยิงปลาออนไลน์ของค่าย Play8 ในปี 2569 มีอะไรโดดเด่น"
                                >
                                    <div className="tt_img">
                                        <img loading="lazy"
                                            alt=""
                                            width={250}
                                            height={150}
                                            src="/build/web/igame-index-lobby-wm/img/237-450x270-2-250x150.png"
                                        />
                                    </div>
                                    <div className="tt_dsc">
                                        <h3>เกมยิงปลาออนไลน์ของค่าย Play8 ในปี 2569 มีอะไรโดดเด่น</h3>
                                        <p>เกมยิงปลาออนไลน์ถือเป็นหนึ่งในเกมคาสิโนที่ได้รับความนิย […]</p>
                                    </div>
                                </a>
                            </article>
                            <article
                                className="tt_l post-l3x  animatedParent zoomIn"
                                style={{ visibility: "hidden", animationName: "none" }}
                            >
                                <a
                                    href="/%e0%b8%84%e0%b9%88%e0%b8%b2%e0%b8%a2-mt-gaming-%e0%b8%81%e0%b8%b1%e0%b8%9a%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%9e%e0%b8%b1%e0%b8%92%e0%b8%99%e0%b8%b2%e0%b9%80%e0%b8%81%e0%b8%a1%e0%b8%a2%e0%b8%b4%e0%b8%87/"
                                    title="ค่าย MT Gaming กับการพัฒนาเกมยิงปลาออนไลน์ในปี 2569"
                                >
                                    <div className="tt_img">
                                        <img loading="lazy"
                                            alt=""
                                            width={250}
                                            height={150}
                                            src="/build/web/igame-index-lobby-wm/img/236-450x270-1-250x150.png"
                                        />
                                    </div>
                                    <div className="tt_dsc">
                                        <h3>ค่าย MT Gaming กับการพัฒนาเกมยิงปลาออนไลน์ในปี 2569</h3>
                                        <p>เกมยิงปลาออนไลน์ยังคงเป็นหนึ่งในเกมคาสิโนที่มีผู้เล่นจำ […]</p>
                                    </div>
                                </a>
                            </article>
                            <article
                                className="tt_l post-l3x  last animatedParent zoomIn"
                                style={{ visibility: "hidden", animationName: "none" }}
                            >
                                <a
                                    href="/%e0%b9%80%e0%b8%a5%e0%b9%88%e0%b8%99%e0%b9%80%e0%b8%81%e0%b8%a1%e0%b8%a2%e0%b8%b4%e0%b8%87%e0%b8%9b%e0%b8%a5%e0%b8%b2%e0%b8%ad%e0%b8%ad%e0%b8%99%e0%b9%84%e0%b8%a5%e0%b8%99%e0%b9%8c%e0%b8%81%e0%b8%b1/"
                                    title="เล่นเกมยิงปลาออนไลน์กับ Joker ในปี 2569 กับประสบการณ์ที่เข้มข้น"
                                >
                                    <div className="tt_img">
                                        <img loading="lazy"
                                            alt=""
                                            width={250}
                                            height={150}
                                            src="/build/web/igame-index-lobby-wm/img/235-450x270-1-250x150.png"
                                        />
                                    </div>
                                    <div className="tt_dsc">
                                        <h3>
                                            เล่นเกมยิงปลาออนไลน์กับ Joker ในปี 2569 กับประสบการณ์ที่เข้มข้น
                                        </h3>
                                        <p>เมื่อพูดถึงค่ายเกมที่อยู่ในตลาดออนไลน์มาอย่างยาวนาน ชื่ […]</p>
                                    </div>
                                </a>
                            </article>
                        </div> */}
                        </div>
                    </div>
                    <div className="tt_l tt_full footer">
                        <div className="tt_l tt_full footer_cx">
                            <div className="wrapper-c">
                                <div className="tt_l logo_pc_f">
                                    <a
                                        className="tt_l tt_full mb-10"
                                        title={t(this.lang,'seo_title_main')}
                                        role="button"
                                        onClick={(e) => {
                                            this.checkurl(e, "/")
                                        }}
                                    >
                                        <img loading="lazy" src={this.state.logoimg} />
                                    </a>
                                </div>
                                <div className="tt_r tt_txt_seo3">
                                    <p>
                                        {t(this.lang,'seo_footer_p1')}
                                        <a
                                            onClick={(e) => {
                                                this.checkurl(e, "/login")
                                            }}>
                                            {" "}
                                            {t(this.lang,'seo_footer_link')}
                                        </a>
                                        {t(this.lang,'seo_footer_p2')}
                                    </p>
                                    <p>&nbsp;</p>
                                </div>
                                <div className="tt_l tt_full game_ft mb-20">
                                    <a
                                        onClick={(e) => {
                                            this.checkurl(e, "/login")
                                        }}
                                        title="UFABET"
                                    >
                                        <img loading="lazy"
                                            className="thaitheme_pc"
                                            src="/build/web/igame-index-lobby-wm/img/logo-ufabet.png"
                                            alt=""
                                        />
                                    </a>
                                    <a
                                        onClick={(e) => {
                                            this.checkurl(e, "/login")
                                        }}
                                        title="SAGAMING"
                                    >
                                        <img loading="lazy"
                                            className="thaitheme_pc"
                                            src="/build/web/igame-index-lobby-wm/img/logo-sagaming.png"
                                            alt=""
                                        />
                                    </a>
                                    <a
                                        onClick={(e) => {
                                            this.checkurl(e, "/login")
                                        }}
                                        title="SEXY BACCARAT"
                                    >
                                        <img loading="lazy"
                                            className="thaitheme_pc"
                                            src="/build/web/igame-index-lobby-wm/img/Sexy-Baccarat.png"
                                            alt=""
                                        />
                                    </a>
                                    <a
                                        onClick={(e) => {
                                            this.checkurl(e, "/login")
                                        }}
                                        title="JOKER"
                                    >
                                        <img loading="lazy"
                                            className="thaitheme_pc"
                                            src="/build/web/igame-index-lobby-wm/img/cert5_grey.png"
                                            alt=""
                                        />
                                    </a>
                                    {/* <a
                                    href="https://www.dmca.com/Protection/Status.aspx?ID=3a8e0298-8797-4f0e-9293-86c86a7d82de&refurl=/"
                                    title="DMCA.com Protection Status"
                                    className="dmca-badge"
                                >
                                    <img loading="lazy"
                                        src="https://images.dmca.com/Badges/dmca_copyright_protected150b.png?ID=3a8e0298-8797-4f0e-9293-86c86a7d82de"
                                        alt="DMCA.com Protection Status"
                                    />
                                </a> */}
                                    {/* <a href="" title="SEXY BACCARAT"><noscript><img loading="lazy" class="thaitheme_pc" src="https://images.dmca.com/Badges/dmca_copyright_protected150b.png?ID=3a8e0298-8797-4f0e-9293-86c86a7d82de" alt="DMCA.com Protection Status" /></noscript><img loading="lazy" class="thaitheme_pc lazyloaded" src="https://images.dmca.com/Badges/dmca_copyright_protected150b.png?ID=3a8e0298-8797-4f0e-9293-86c86a7d82de" data-src="https://images.dmca.com/Badges/dmca_copyright_protected150b.png?ID=3a8e0298-8797-4f0e-9293-86c86a7d82de" alt="DMCA.com Protection Status"></a> */}
                                </div>
                            </div>
                            <div className="tt_r copyright_footer">
                                Copyright 2026 ©{" "}
                                <a
                                    title={t(this.lang,'seo_title_main')}
                                    href="https://UFA11.com/"
                                >
                                    UFA11.COM
                                </a>{" "}
                                All Rights Reserved.
                            </div>
                        </div>
                    </div>
                    <div className="fix_footer" style={{ display: !this.state.loginstate ? "none" : "" }}>
                        {/* <a  onClick={(e) => {
                            this.checkurl(e, "/login")
                        }}><span class="link_ico ico_1"><i class="fas fa-user"></i></span> <strong>ข้อมูลส่วนตัว</strong></a> */}
                        <a className="nologin" onClick={(e) => {
                            this.checkurl(e, "/")
                        }}>
                            <span className="link_ico ico_1    ">
                                <i className="fas fa-sign-in-alt" />
                            </span>{" "}
                            <strong className="reg1">{t(this.lang,'profile')}</strong>
                        </a>
                        <a
                            className="nologin"
                            style={{
                                display: "none",
                                background: "none",
                                animation: "0.5s steps(5) 0s infinite normal none running walk-cyclet2"
                            }}
                            onClick={(e) => {
                                this.checkurl(e, "/register")
                            }}
                        >
                            <span className="link_ico ico_2  ">
                                <i className="fas fa-user-plus" />
                            </span>{" "}
                            <strong>{t(this.lang,'register')}</strong>
                        </a>
                        <a
                            className="nologin"
                            style={{ display: "none" }}
                            onClick={(e) => {
                                this.checkurl(e, "/promotion")
                            }}
                        >
                            <span className="link_ico ico_2  ">
                                <i className="fas fa-bullhorn" />
                            </span>{" "}
                            <strong>{t(this.lang,'promotion')}</strong>
                        </a>
                        <a className="readylogin" onClick={(e) => {
                            this.checkurl(e, "/deposit")
                        }}>
                            <span className="link_ico ico_3  ">
                                {" "}
                                <i className="fas fa-wallet" />{" "}
                            </span>
                            <strong> {t(this.lang,'deposit')}</strong>
                        </a>
                        <a className="readylogin" onClick={(e) => {
                            this.checkurl(e, "/withdraw")
                        }}>
                            <span className="link_ico ico_4  ">
                                <i className="fas fa-hand-holding-usd" />
                            </span>
                            <strong> {t(this.lang,'withdraw')}</strong>
                        </a>
                        <a className=" "
                            role="button"
                            onClick={(e) => {
                                this.checkurl(e, "/affiliate")
                            }}>
                            <span className="link_ico ico_4  ">
                                <i className="fas fa-dollar-sign  " />
                            </span>{" "}
                            <strong> {t(this.lang,'ufa_make_income')}</strong>
                        </a>
                        <a className="last" href="/contactus">
                            <span className="link_ico ico_5">
                                <i className="fabx fa-linex">
                                    <i className="fab fa-line" />
                                </i>
                            </span>{" "}
                            <strong> {t(this.lang,'ufa_contact_us')}</strong>
                        </a>
                    </div>

                    <div className="fix_footer" style={{ display: this.state.loginstate ? "none" : "" }}>
                        <a className="nologin" onClick={(e) => {
                            this.checkurl(e, "/login")
                        }}>
                            <span className="link_ico ico_1    ">
                                <i className="fas fa-sign-in-alt" />
                            </span>{" "}
                            <strong className="reg1">{t(this.lang,'login')}</strong>
                        </a>
                        <a
                            className="nologin"
                            style={{
                                background: "none",
                                animation: "0.5s steps(5) 0s infinite normal none running walk-cyclet2"
                            }}
                            role='button'
                            onClick={(e) => {
                                this.checkurl(e, "/register")
                            }}
                        >
                            <span className="link_ico ico_2  ">
                                <i className="fas fa-user-plus" />
                            </span>{" "}
                            <strong>{t(this.lang,'register')}</strong>
                        </a>
                        <a
                            className="nologin"
                            style={{}}
                            role='button'
                            onClick={(e) => {
                                this.checkurl(e, "/promotion")
                            }}
                        >
                            <span className="link_ico ico_2  ">
                                <i className="fas fa-bullhorn" />
                            </span>{" "}
                            <strong>{t(this.lang,'promotion')}</strong>
                        </a>
                        <a
                            role='button'
                            className="readylogin"
                            onClick={(e) => {
                                this.checkurl(e, "/deposit")
                            }}
                            style={{ display: "none" }}
                        >
                            <span className="link_ico ico_3  ">
                                {" "}
                                <i className="fas fa-wallet" />{" "}
                            </span>
                            <strong> {t(this.lang,'deposit')}</strong>
                        </a>
                        <a
                            role='button'
                            className="readylogin"
                            onClick={(e) => {
                                this.checkurl(e, "/withdraw")
                            }}
                            style={{ display: "none" }}
                        >
                            <span className="link_ico ico_4  ">
                                <i className="fas fa-hand-holding-usd" />
                            </span>
                            <strong> {t(this.lang,'withdraw')}</strong>
                        </a>
                        <a className=" " role="button" onClick={(e) => {
                            this.checkurl(e, "/affiliate")
                        }}>
                            <span className="link_ico ico_4  ">
                                <i className="fas fa-dollar-sign  " />
                            </span>{" "}
                            <strong> {t(this.lang,'ufa_make_income')}</strong>
                        </a>
                        <a className="last" href="/contactus">
                            <span className="link_ico ico_5">
                                <i className="fabx fa-linex">
                                    <i className="fab fa-line" />
                                </i>
                            </span>{" "}
                            <strong> {t(this.lang,'ufa_contact_us')}</strong>
                        </a>
                    </div>

                    {this.state.showToTop && (
                        <div
                            id="toTop"
                            onClick={this.forceScrollTop}
                            style={{ display: this.state.showToTop ? "block" : "none" }}
                        >
                            <i className="fa fa-chevron-up" />
                        </div>
                    )}

                    {tabselect === 1 && <PopupDep />}
                    <Popup />
                </div>
            </div>
        );
    }
}

export default Main;
